export const translationAz = {
  '<all users>': '<bütün istifadəçilər>',
  '24 hours': '24 saat',
  '30 days': '30 gün',
  '7 days': '7 gün',
  Account: 'Hesab',
  'Accounting unit': 'Hesab vahidi',
  'Accounting for battery replacement': 'Batareya dəyişdirmə uçotu',
  'Access Rights': 'Hüquqlar',
  'Access to document verification': 'Sənəd yoxlamasına icazə',
  'Access to checking extended registration documents is allowed. After the time has expired, the password must be re-entered to reset the timer and continue testing.':
    'Genişləndirilmiş qeydiyyat sənədlərini yoxlamaq üçün girişə icazə var. Taymer müddəti bitdikdən sonra yoxlamaya davam etmək üçün şifrənizi yenidən daxil etməlisiniz.',
  'Around the clock': 'Gecə‑gündüz',
  Acquirer: 'Ekvayer',
  'Acquirer Id': 'Əldəetmə identifikatoru',
  Acquirers: 'Ekvayrinq',
  Activation: 'Aktivləşdirmə',
  'Activation conditions': 'Aktivləşdirmə şərtləri',
  Action: 'Hərəkət',
  Actions: 'Hərəkət',
  Analytics: 'Analitika',
  Author: 'Müəllif',
  'Active order': 'Kirayədə',
  'Automatic debits': 'Avtomatik pul silinməsi',
  'Altitude above sea level': 'Dəniz səviyyəsindən hündürlük',
  Inactive: 'Qeyri-aktiv',
  'Active trip': 'Aktiv səyahət',
  'Active subscription': 'Aktiv abunəlik',
  'Active subscriptions': 'Aktiv abunəliklər',
  'Activity time': 'Fəaliyyət vaxtı',
  'Activity log': 'Fəaliyyət qeydi',
  'Activity level': 'Fəaliyyət səviyyəsi',
  'Activate if necessary to specify the color of the object': 'Obyektin rəngini təyin etmək lazımdırsa, aktivləşdirin',
  'Activate to provide access to the functionality of creating and editing rates.':
    'Tariflər yaratmaq və redaktə etmək funksiyasına giriş təmin etmək üçün aktivləşdirin',
  'Activate if you want the first rate in the list of available rates for the unit to be selected by default.':
    'Mövcud tarif siyahısındakı ilk tarif standart olaraq seçilməsini istəyirsinizsə, aktivləşdirin.',
  'Active bank card': 'Aktiv bank kartı',
  'Mobile application and its version': 'Mobil tətbiq və onun versiyası',
  Add: 'Əlavə etmək',
  'Add more': 'Daha əlavə et',
  'Add Geopoint': 'POİ əlavə edin',
  'Add action': 'Fəaliyyət əlavə edin',
  'Add comment': 'Şərh əlavə edin',
  'Add condition': 'Şərt əlavə edin',
  'Ad cover': 'Reklam üz qabığı',
  'Add document': 'Sənəd əlavə edin',
  'Add geofence': 'Geozon əlavə edin',
  'Add price plan': 'Tarif əlavə edin',
  'Add language': 'Dil əlavə edin',
  'Add point': 'POİ əlavə edin',
  'Add image': 'Şəkil əlavə edin',
  'Add video': 'Video əlavə edin',
  'Add part': 'Bir hissə əlavə edin',
  'Add event': 'Hadisə əlavə edin',
  'Add translates': 'Tərcümələr əlavə edin',
  'Add translate': 'Tərcümə əlavə edin',
  'Add to group': 'Qrupa əlavə edin',
  'Add working days': 'İş günləri əlavə et',
  'Add time period': 'Zaman müddəti əlavə et',
  Address: 'Ünvan',
  'Additional Information': 'Əlavə məlumat',
  'Additional information about the tariff, including information about the debiting of funds and conditions.':
    'Tarif haqqında əlavə məlumat, o cümlədən vəsaitlərin silinməsi və şərtləri haqqında məlumat.',
  'Add the document content, including data substitution patterns.': 'Sənədin məzmununu, o cümlədən məlumat əvəzetmə şablonlarını əlavə edin.',
  Admin: 'Admin',
  Administrator: 'Administrator',
  Manager: 'Menecer',
  'Admin login': 'Administrator girişi',
  'Alarm retranslator': 'Həyəcan signalı retranslyatoru',
  'Are you sure?': 'Əminsiniz?',
  'Arbitrary command': 'Sərbəst komanda',
  Retranslator: 'Retranslyator',
  'Alarming notification': 'Xəbərdarlıq bildirişi',
  'Alarm notifications': 'Xəbərdarlıq bildirişlər',
  Alarms: 'Xəbərdarlıq',
  All: 'Hamısı',
  'All-time statistics': 'Bütün zamanlar',
  Amount: 'Məbləğ',
  Allowed: 'İcazə verilib',
  'Amount in coin': 'Coin məbləğ',
  'Amount in currency': 'Valyutada məbləğ',
  'Amount owed': 'Borc məbləği',
  'Api Key': 'API açarı',
  Appointments: 'Təyinatlar',
  Assignments: 'Tapşırıqlar',
  'Appointment date': 'Təyinat tarixi',
  Apply: 'Tətbiq edin',
  'App version': 'Tətbiq versiyası',
  'Are sure you want to delete this item': 'Bu elementi silmək istədiyinizə əminsiniz?',
  'Are you sure you wish to send push notifications to all clients of this project':
    'Layihənin bütün müştərilərinə push bildirişi göndərmək istədiyinizə əminsinizmi?',
  'Are you sure you wish to send push notifications to all clients in selected region':
    'Seçilmiş bölgədəki bütün müştərilərə push bildirişi göndərmək istədiyinizə əminsinizmi?',
  'Messages are being sent': 'Mesajlar göndərilir',
  'Assigned to': 'Təyin olunub',
  'Assign a bag': 'Çantanı təyin edin',
  'Assigned to groups': 'Qruplara təyin edildi',
  'Unit has been added to group': 'Obyekt qrupa əlavə edildi',
  'Read-only access': 'Yalnız oxumaq üçün giriş',
  'Select users': 'İstifadəçiləri seçin',
  'Are you sure you want to remove unit from this group?': 'Obyekti qrupdan silmək istədiyinizə əminsinizmi?',
  'At least one element must be added': 'Ən azı bir element əlavə edilməlidir',
  'At least one notification type must be selected': 'Ən azı bir bildiriş növü seçilməlidir.',
  'At least two items must be selected': 'Ən azı iki xidmət seçməlisiniz',
  'At least one field must be filled in': 'Ən azı bir sahə doldurulmalıdır',
  'At least one option must be selected': 'Ən azı bir seçim edilməlidir',
  Audio: 'Səs',
  'Authentication method': 'Doğrulama metodu',
  'Availability in application': 'Tətbiqdə mövcudluq',
  Availability: 'Mövcudluq',
  'in application': 'tətbiqdə',
  Initiator: 'Təşəbbüskar',
  'Order completion initiator': 'Sifarişin tamamlanması təşəbbüskarı',
  'Order cancellation initiator': 'Sifarişin ləğvi təşəbbüskarı',
  'Avail.': 'Mövc.',
  Available: 'Mövcuddur',
  Accessible: 'Əlçatan',
  'Available time': 'Mövcud vaxt',
  'Available units': 'Mövcud obyektlər',
  'Count of trips per one unit per day': 'Gündə bir obyektə səfərlərin sayı',
  'Total price of trips per one unit': 'Dövr üçün obyekt başına sifarişlərin dəyəri',
  'Total price of trips per one unit per day': 'Gündəlik sifarişlərin dəyəri',
  'Active objects': 'Aktiv obyektlər',
  'Not available': 'Mövcud deyil',
  'On charge': 'Şarjda',
  'At warehouse': 'Ambarda',
  'Attached to unit': 'Obyektə qoşulub',
  'Attached tracker': 'Qoşulmuş GPS',
  'Under repair': 'Təmirdə',
  'Unpaid orders': 'Ödənilməmiş sifarişlər',
  'Unpaid fines': 'Ödənilməmiş cərimələr',
  'Availability schedule': 'Mövcudluq cədvəli',
  'Average cost': 'Orta qiymət',
  Average: 'Orta',
  'Average distance': 'Orta məsafə',
  'Average duration': 'Orta müddət',
  'Awaiting confirmation': 'Təsdiq gözlənilir',
  Awaiting: 'Gözləmə',
  'A new refund operation will be created in the related operations if you try again.': 'Əlaqəli əməliyyatları təkrarlamaq yeni bir qaytarma əməliyyatı yaradacaq.',
  Attention: 'Diqqət',
  'A short description of the subscription is displayed in the list of subscriptions in the Subscription catalog section in the mobile application':
    'Abunəliyin qısa təsviri mobil tətbiqin Abunə Kataloqu bölməsindəki abunə siyahısında göstərilir.',
  'A detailed description of the subscription is displayed in the subscription card in the mobile application':
    'Abunəliyin ətraflı təsviri mobil tətbiqetmədəki abunə kartında göstərilir.',
  'A document can be added either by adding text to the fill-in field or by uploading a file containing the document text.': 'Sənədi ya mətn sahəsinə daxil etməklə, ya da sənəd mətnini ehtiva edən faylı yükləməklə əlavə etmək mümkündür.',
  After: 'Vasitəsilə',
  'Baby carriages': 'Uşaq arabaları',
  'Baby carriage': 'Uşaq arabası',
  'Baby carriage price': 'Uşaq arabasının qiyməti',
  Balance: 'Balans',
  Bags: 'Çantalar',
  'Bag number': 'Çanta nömrəsi',
  'List of bag numbers': 'Çanta nömrələrinin siyahısı',
  'Balance AuthCall': 'AuthCall Balansı',
  'Balance History': 'Balans tarixçəsi',
  'Balance packages': 'Bonus paketləri',
  'Balance replenishment': 'Balansın doldurulması',
  'Balance replenishment in currency': 'Balansınıza xarici valyutada əlavə edin',
  'Balance 2023': 'Balans 2023',
  'Top-up balance 2023': 'Balansınızı artırın 2023',
  'Top-up': 'Əlavə ödəniş',
  'Top-up of personal account balance': 'Şəxsi hesabınızın balansını artırın',
  'User balance 2023': 'İstifadəçi balansı 2023',
  Batteries: 'Batareyalar',
  'Battery charge': 'Batareyanın %',
  'Battery charge calculation settings': 'AKB enerji hesablanmasının ayarları',
  'Battery lock: no information': 'Batareyanın kilidi: məlumat yoxdur',
  'Battery lock: Closed': 'Batareyanın kilidi: Bağlıdır',
  'Battery lock: Open': 'Batareyanın kilidi: Açıq',
  'Battery mount type': 'Batareyanın yerləşdirmə növü',
  'Battery before replacement': 'Dəyişdirilmədən əvvəl batareya',
  'Battery after replacement': 'Dəyişdirildikdən sonra batareya',
  'Battery: Attached to unit': 'Obyektə qoşulub',
  'Select a project for battery.': 'Batareyanın yaradıldığı layihəni seçin.',
  'Select a project for the hardware model you are creating': 'Yaradılan avadanlıq modeli üçün layihəni seçin',
  'Select a project for the document you are creating': 'Yaradılan sənəd üçün layihəni seçin',
  'Select a country for the document you are creating': 'Sənədin yaradıldığı ölkəni seçin',
  'Select a business model for the document you are creating': 'Sənədin yaradıldığı biznes modelini seçin',
  'Select a unit type for the document you are creating': 'Sənədin yaradıldığı obyekt tipini seçin',
  'Select a project for the region you are creating': 'Region yaradılan layihəni seçin',
  'Select a project for the geofence you are creating': 'Yaradılan geozona üçün layihəni seçin',
  'Select a project for the geopoint you are creating': 'Yaradılan geopoint üçün layihəni seçin.',
  'Select a project for the icon you are creating': 'Yaradılan ikon üçün layihəni seçin.',
  'Select the project country for the geofence you are creating': 'Yaradılan geozona üçün layihənin ölkəsini seçin',
  'Select the project country for the geopoint you are creating': 'Yaradılan geopoint üçün layihənin ölkəsini seçin.',
  'Select the country region for the geofence you are creating': 'Yaradılan geozona üçün ölkənin regionunu seçin',
  'Select the project country for the region you are creating': 'Region yaradılan layihənin ölkəsini seçin',
  'Select the project country in which battery will be used.': 'Batareyanın istifadə ediləcəyi layihə ölkəsini seçin.',
  'Select the country region for the geopoint you are creating': 'Yaradılan geopoint üçün ölkənin regionunu seçin.',
  'Select the business-model for the geopoint you are creating': 'Yaradılan geopoint üçün biznes modelini seçin.',
  'Specify the owner of the battery.': 'Zəhmət olmasa, batareyanın sahibini göstərin.',
  'Assign battery to the region in which it will be used.': 'Batareyanı istifadə ediləcəyi bölgəyə təyin edin.',
  'Enter the battery name.': 'Batareyanın adını daxil edin.',
  'Registration number must match the number specified in the battery name. Based on the specified registration number, the system generates a QR code required to assign the battery to the unit. Registration number is entered manually to assign the battery if it\'s impossible to scan the QR code.':
    'Qeydiyyat nömrəsi batareyanın adında göstərilən nömrə ilə uyğun olmalıdır. Qeydiyyat nömrəsinə əsasən, sistem batareyanı obyektə təyin etmək üçün tələb olunan QR kodu yaradır. Əgər nədənsə QR kodu oxunmursa, batareyanı təyin etmək üçün qeydiyyat nömrəsi əl ilə daxil edilməlidir.',
  'Provide the battery serial number.': 'Zəhmət olmasa, batareyanın seriya nömrəsini verin.',
  'If the battery is already installed, select the unit. Otherwise, leave the field blank.':
    'Əqər batareya artıq quraşdırılıbsa, obyekti seçin. Əks halda, sahəni boş saxlayın.',
  'Activate if there is a tracker installed in the battery.': 'Batareyada bir GPS quraşdırılıbsa, aktivləşdirin.',
  'If tracker has already been added to the system earlier, to be able to assign the tracker, select the "Select existing" option. To add a new tracker to the system with automatic assignment to the battery, select the "Add new" option.':
    'Əgər sistemə artıq izləyici əlavə edilibsə, onu təyin etmək üçün "Mövcud Seç" seçimini edin. Avtomatik batareya təyinatı ilə sistemə yeni GPS əlavə etmək üçün "Yenisini əlavə et" seçimini edin.',
  'Select a tracker to assign to the battery.': 'Batareyaya təyin etmək üçün bir izləyici seçin.',
  'Enter the tracker name.': 'GPS-in adını daxil edin.',
  'Select the tracker model.': 'GPS-in modelini seçin.',
  'Specify the model of telematics equipment installed. Depending on the selected model, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
    'Zəhmət olmasa, müəssisənizdə quraşdırılmış telematika avadanlığının modelini göstərin. Seçilmiş avadanlıq modeli mesaj qəbulunun, əmr göndərilməsinin və digər funksional xüsusiyyətlərin düzgün işləməsini müəyyən edəcək.',
  'Specify the IMEI of the telematics equipment installed. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
    'Zəhmət olmasa, müəssisənizdə quraşdırılmış telematika avadanlığının IMEI-ni daxil edin. Avadanlığın serverə qoşulması düzgün IMEI-dən asılıdır. Daxil edilmiş məlumatları iki dəfə yoxlamaq tövsiyə olunur.',
  'Enter the number of the SIM card installed in the telematics equipment.': 'Zəhmət olmasa, telematika avadanlığına quraşdırılmış SIM kartın nömrəsini daxil edin.',
  'Choose tracker': 'GPS seçin',
  'Change battery charge calculation method': 'AKB-nin enerji hesablanma metodunu dəyişin',
  'Enter SIM number': 'SIM nömrənizi daxil edin',
  'Enter the serial number' : 'Seriya nömrəsini daxil edin',
  'Enter the courier UID' : 'Kuryerin UID-ni daxil edin',
  'Add device': 'Cihaz əlavə edin',
  'Enter serial number of device': 'Cihazın seriya nömrəsini daxil edin',
  'Device successfully added': 'Cihaz uğurla əlavə edildi.',
  Devices: 'Cihazlar',
  'Co-owned devices': 'Cihazların ortaq sahibi',
  'Are you sure you want to remove selected device from the courier?': 'Seçilmiş cihazı kuryerdən silmək istədiyinizə əminsinizmi?',
  'Assign device': 'Cihaz təyin edin',
  'Purchases of devices': 'Cihaz alışları',
  'Purchase information': 'Satınalma detalları',
  'Enter tracking number (optional)': 'İzləmə nömrəsini daxil edin (isteğe bağlı)',
  'For couriers': 'Kuryerlər üçün',
  'For QR sharing': 'QR şerinq üçün',
  'Price plans for couriers': 'Kuryerlər üçün tariflər',
  'Price plans for qr sharing': 'QR şerinq nisbətləri',
  'Internal name (for admin panel)': 'Daxili ad (admin paneli üçün)',
  'Internal name': 'Daxili ad',
  'Payment in advance ... days before the start of the next subscription period':
    'Növbəti abunə dövrünün başlamasından ... gün əvvəl əvvəlcədən ödəniş',
  'Duration of subscription period, days': 'Abunə müddətinin müddəti, gün',
  'Duration, days': 'Müddət, gün',
  'Price plan group': 'Qiymət planı qrupu',
  'Group of price plans': 'Qiymət planları qrupu',
  'Groups of price plans for couriers': 'Kuryerlər üçün tarif qrupları',
  'Auto-renewal': 'Avtomatik yeniləmə',
  Billing: 'Billinq',
  'Action on payment failure': 'Ödəniş edilmədikdə tədbir',
  'Start subscription automatically when unit becomes online': 'Cihaz qoşulduqda abunəlik avtomatik olaraq başlayın',
  'Default price plan': 'Standart tarif',
  'Price plan in case of payment failure': 'Ödəniş edilmədikdə sabit faiz dərəcəsi',
  'Billing interval type': 'Faktura intervalının növü',
  'Number of full free of charge intervals': 'Pulsuz tam intervalların sayı',
  Title: 'Ad',
  'First partial month is free of charge': 'İlk qismən ay pulsuz təqdim olunur.',
  'Do not make payments for the next period and suspend service if unit is offline':
    'Növbəti dövr üçün ödəniş etmə və xidməti dayandır əqər obyekt qoşulmayıbsa',
  'Days between last message from the unit and next interval': 'Son mesajla növbəti intervalın başlanğıcı arasındakı günlərin sayı',
  'Resume service and payments if unit is back online': 'Obyekt yenidən onlayndırsa, xidmətə və ödənişlərə davam edin',
  'Maximum allowed debt before cancelling service': 'Xidmətin dayandırılmasından əvvəl maksimum borc',
  'Free of charge': 'Pulsuz',
  'Unit owner': 'Obyektin sahibi',
  'executor-subscription': 'Abunəlik',
  'executor-subscriptions': 'Abunəliklər',
  'executor-has-subscriptions': 'Abunəliklər var',
  Intervals: 'İntervallar',
  'executor-unit-service': 'Xidmət',
  'Service active until': 'Xidmət aktivdir',
  'Default price plan group for couriers': 'Defolt kuryer qiyməti qrupu',
  'Managing of courier price plans': 'Kuryerlər üçün tariflər və tarif qruplarının yaradılması',
  'Allow couriers to operate without subscriptions': 'Kuryerlər abunə olmadan işləyirlər',
  default: 'standart olaraq',
  'Service is active': 'Xidmət aktivdir',
  'Blocked from': 'Bloklama tarixi',
  'Reason of blocking': 'Bloklama səbəbi',
  'Price plan group of the next interval': 'Növbəti interval üçün tarif qrupu',
  'Price plan of the next interval': 'Növbəti interval üçün tarif',
  'Date of next payment': 'Növbəti ödəniş tarixi',
  Modify: 'Dəyişik edin',
  Device: 'Cihaz',
  'Installed tracker': 'Quraşdırılmış GPS',
  'Name of charge parameter': 'Parametrin adı',
  'Parameter value when charge is 0%': 'AKB-nin 0% enerji səviyyəsində parametr dəyəri',
  'Parameter value when charge is 100%': 'AKB-nin 100% enerji səviyyəsində parametr dəyəri',
  'Battery registration status in the system': 'Sistemdə batareya qeydiyyatı statusu',
  'Actions on start of the trip': 'Səfərin əvvəlindəki hərəkətlər',
  'Actions minutes before finish of the trip': 'Səfərin bitməsindən bir neçə dəqiqə əvvəl görülən tədbirlər',
  'Time before finish of the trip': 'Səfərin bitməsindən əvvəlki vaxt',
  'Actions on finish of the trip': 'Səfərin sonunda görüləcək tədbirlər',
  'Actions on leaving ride allow area': 'Sürmək icazə olan ərazidən çıxarkən görüləcək tədbirlər',
  'Actions on entering ride allow area': 'Sürmək icazə olan əraziyə qayıtdıqdan sonra görüləcək tədbirlər',
  'Execute actions minutes before finish of the trip': 'Səfərin bitməsindən bir neçə dəqiqə əvvəl görüləcək tədbirlər',
  'Number of minutes before finish of the trip': 'Səyahətin bitməsinə dəqiqələr',
  'Anonymous client': 'Anonim müştəri',
  'Duration, minutes': 'Müddət, dəqiqə',
  'Action not selected': 'Heç bir əməliyyat seçilməyib',
  'Presence in the system': 'Sistemdə mövcudluq',
  'Select unit': 'Bir obyekt seçin',
  'Select a hardware model': 'Avadanlıq modelini seçin',
  'SIM number': 'SIM nömrəsi',
  'Type registration number': 'Zəhmət olmasa qeydiyyat nömrəsini təqdim edin',
  'Tracker attached': 'GPS quraşdırılıb',
  'Birth date': 'Doğum tarixi',
  'Billing model': 'Ödəniş proseduru',
  'Billing period': 'Faktura dövrü',
  'Business model': 'Biznes modeli',
  'Business models': 'Biznes modelləri',
  'All projects': 'Bütün layihələr',
  'All business models': 'Bütün biznes modelləri',
  'Insufficient funds to continue service': 'Xidməti davam etdirmək üçün kifayət qədər vəsait yoxdur',
  'out of': '-',
  'Old billing': 'Köhnə billinq',
  'of your units were hidden and not available for rent to clients': 'obyekt xəritədən gizlədilib və müştərilərə icarəyə verilmir',
  'To resume service, you need to top up the balance': 'Xidməti bərpa etmək üçün balansınızı artırmalısınız.',
  'If you have any questions, please contact your manager': 'Hər hansı bir sualınız varsa, zəhmət olmasa menecerinizlə əlaqə saxlayın.',
  'To ensure that push notification text displays on all screens (including small smartphones), it\'s recommended to limit it to 60-80 characters, including spaces.': 'Push bildiriş mətninin bütün ekranlarda (kiçik smartfonlar daxil olmaqla) düzgün göstərilməsi üçün mətnin 60–80 simvol (boşluqlar daxil) olması tövsiyə olunur.',
  'If tracker is connected to a removable battery, select the "Removable battery" connection method. If tracker is connected to unit with a non-removable battery, select the "Unit" connection method.':
    'GPS çıxarıla bilən batareyaya qoşulubsa, "Çıxarıla bilən Batareya" bağlantı metodunu seçin. İzləyici çıxarıla bilməyən batareyası olan bir obyektə qoşulubsa, "Obyektlər" bağlantı metodunu seçin.',
  'Is paid': 'Ödənilib',
  'Created at': 'Yaradılma tarixi',
  'Paid at': 'Ödəniş tarixi',
  'Paid orders': 'Ödənilmiş sifarişlər',
  'Operation type': 'Əməliyyat növü',
  'Amount in payment currency': 'Ödəniş valyutasındakı məbləğ',
  'Accounting period': 'Faktura dövrü',
  'Bicycle price': 'Velosipedin qiyməti',
  'Bicycle car price': 'Velomobilin qiyməti',
  'Blink lights': 'İşığı yanıb-söndür',
  Facilities: 'İmkanlar',
  'From last': 'Sonuncudan',
  'From first': 'Əvvəldən',
  Finance: 'Maliyyə',
  'Being in a parking area': 'Parklanma zonasında olması',
  'Being in the riding area': 'Sürmə zonasında olmaqsı',
  Beginning : 'Başlanma',
  Block: 'Blok etmək',
  Unblock: 'Blokdan çıxartmaq',
  'Block device': 'Cihazı blokla',
  'Block engine': 'Mühərriki blokla',
  Blocked: 'Bloklandı',
  Unlocked: 'Blokda deil',
  'Blocked-statistic': 'Blokda olan',
  'Blocked since': 'Bloklama tarixi',
  'Bookd.': 'Rezervasiya',
  'Booking timeout': 'Rezervasiya müddəti bitməsi',
  'Booking timed out': 'Rezervasiya müddəti bitdi',
  Booking: 'Rezervasiya',
  Boundary: 'Sərhədlər',
  Bonuses: 'Bonuslar',
  Brief: 'Qısaca',
  'Browser window is inactive': 'Brauzerin pəncərəsi qeyri-aktivdir',
  'Cancel transaction': 'Əməliyyatı ləğv edin',
  'Cancellation date': 'Ləğv tarixi',
  'Can create price plans': 'Tarif planları yarada bilər',
  Call: 'Zəng edin',
  Canceled: 'Ləğv edildi',
  'canceled-status': 'Ləğv edildi',
  Canceled_: 'Ləğv edildi',
  Cancelled: 'Ləğv edildi',
  'Cancelled orders': 'Ləğv edilmiş sifarişlər',
  'Cannot change status because unit\'s owner is blocked': 'Obyektin sahibi bloklandığı üçün statusu dəyişdirmək mümkün deyil',
  Car: 'Avtomobil',
  Cars: 'Avtomobillər',
  'Electric mopeds': 'Elektrikli mopedlər',
  'Calculation method': 'Hesablama metodu',
  'Categories of transport licenses:': 'Nəqliyyat vasitələri üçün hüquq kateqoriyaları:',
  Bikes: 'Velosipedlər',
  Bike: 'Velosiped',
  Velomobiles: 'Velomobillər',
  'Velomobile price': 'Velomobilin qiyməti',
  voltage_abbreviation: 'V',
  Apartments: 'Mənzillər',
  Charge: 'Şarj',
  Couriers: 'Kuryerlər',
  Courier: 'Kuryer',
  'charge-level-low': 'Aşağı (tətbiqdə gizlədilib)',
  'charge-level-medium': 'Orta',
  'charge-level-high': 'Yüksək',
  'Charge/fuel level': 'Şarj/Yanacaq Səviyyəsi',
  'Charge at finish': 'Finişdə şarj',
  'Charge at start': 'Başlanğıcda şarj',
  'Charge when plugged in': 'Qoşulduqda şarj',
  'Charge not found': 'Şarj tapılmadı',
  'Charging stations': 'Şarj stansiyaları',
  Boats: 'Qayıqlar',
  Boat: 'Qayıq',
  kWh: 'kVt/saat',
  'Port 1': 'Port 1',
  'Port 2': 'Port 2',
  'Port 3': 'Port 3',
  'Port 4': 'Port 4',
  'Port 1 connector type': 'Port 1, konnektor növü',
  'Port 2 connector type': 'Port 2, konnektor növü',
  'Port 3 connector type': 'Port 3, konnektor növü',
  'Port 4 connector type': 'Port 4, konnektor növü',
  'Checkout bonus': 'Sifarişi tamamlayarkən bonus',
  'Charge before replacement': 'Dəyişdirmədən əvvəl şarj',
  'Charge after replacement': 'Dəyişdirildikdən sonra şarj',
  'Choose a day of the week': 'Həftənin gününü seçin',
  'Choose a status': 'Status seçin',
  'Choose a color': 'Rəng seçin',
  'Choose a sign': 'Bir işarə seçin',
  'Choose status': 'Status seçin',
  'Choose the language for the rate information provided.': 'Zəhmət olmasa, tarif məlumatlarının hansı dildə təqdim olunduğunu göstərin.',
  'Choose an integrator': 'İnteqrator seçin',
  'Choose the regions': 'Regionları seçin',
  'Choose access rights': 'Giriş hüquqlarını seçin',
  'Choose the acquiring': 'Ekvayrinq seçin',
  'Choose the payment service': 'Xidmətləri seçin',
  'Choose a removable battery': 'Çıxarıla bilən batareya seçin',
  'Choose at least one language': 'Zəhmət olmasa, ən azı bir dil seçin.',
  'Choose file': 'Fayl seçin',
  'Choose from the list': 'Siyahıdan seçin',
  'Choose a business model': 'Biznes modeli seçin',
  'Choose group of price plans': 'Tarif qrupu seçin',
  City: 'Şəhər',
  Clear: 'Təmizlə',
  Client: 'Müştəri',
  'Number of selected clients': 'Seçilmiş müştərilərin sayı',
  'Client authentication': 'Müştəri identifikasiyası',
  'Number of clients selected': 'Seçilmiş müştərilər',
  'Client awaiting confirmation': 'Müştəri təsdiq gözləyir.',
  'Client blocked': 'Müştəri bloklanıb',
  'Client coord': 'Müştəri koordinatları',
  'Client not confirmed': 'Müştəri təsdiqlənməyib',
  'Client photo': 'Müştərinin şəkli',
  'Client price plans': 'Tariflər',
  'Client statistics': 'Müştərilər',
  'Client selection': 'Müştərilərin seçimi',
  'Client assignment method': 'Müştəri təyinatı metodu',
  Clients: 'Müştərilər',
  'Group of clients': 'Müştəri qrupu',
  'Client groups': 'Müştəri qrupları',
  'Unit groups': 'Obyekt qrupları',
  'Client notification log': 'Müştəri jurnalı',
  'Clients who can pre-test the route': 'İlkin marşrut testindən istifadə etmək imkanı olan müştərilər',
  'Client notification settings': 'Müştərilər üçün bildirişlərin qurulması',
  'Client notifications triggers log': 'Müştəri bildiriş jurnalı',
  'Client registration type': 'Müştəri qeydiyyat növü',
  'Client rating': 'Müştəri reytinqi',
  'Client review': 'Müştəri baxışı',
  'Client rating and review': 'Müştəri reytinqi və rəy',
  'Log of notifications by clients': 'Müştəri bildiriş jurnalı',
  'Click here and then select position on map': 'Buraya klikləyin və sonra xəritədə bir yer seçin',
  'Close alarm with description': 'Təsvir göstərərək həyəcən siqnalı bağlayın',
  'Close alarm': 'Həyəcən siqnalı bağlayın',
  'Close door': 'Qapını bağlayın',
  'Close window': 'Pəncərəİstifadəçi tərəfindən bağlanıb bağlayın',
  'Closed by': 'İstifadəçi tərəfindən bağlanıb',
  'Closed requests': 'Bağlı',
  'Closed services': 'Bağlı sifarişlər',
  Closed: 'Bağlı',
  'Closing date': 'Bağlanma tarixi',
  'Coin value': 'Sikkə qiyməti',
  'Collapse menu': 'Menyunu yığışdırın',
  Color: 'Rənq',
  Coordinates: 'Koordinatlar',
  'coordinates-ok': 'Koordinatlar var',
  'coordinates-invalid': 'Yanlış',
  'Color name': 'Rəngin adı',
  'Color setting': 'Rəngin parametrləri',
  'Command descriptions': 'Komandaların təsviri',
  'Command name': 'Komanda adı',
  'Command text': 'Komanda mətni',
  'Command to disable speed limit' : 'Sürət limiti deaktiv komandası',
  Commands: 'Komandalar',
  Command: 'Komanda',
  'Command batch': 'Komandaların göndərişi',
  'Command text can only contain latin letters, numbers, punctuation signs':
    'Komanda mətni yalnız rəqəmlərdən, Latın hərflərindən və durğu işarələrindən ibarət ola bilər.',
  'Commands were put to queue for sending': 'Komandalar göndərilmək üçün növbəyə düzülmüşdülər.',
  'Command was put to queue for sending': 'Komandalar göndərilmək üçün növbəyə düzülüb.',
  'Comment will be used for administrative purposes only and will not be available to the client.':
    'Şərh yalnız inzibati məqsədlər üçün istifadə olunur və müştəri üçün əlçatan olmayacaq.',
  Comments: 'Şərhlər',
  Commentator: 'Şərhçi',
  'Confirm booking': 'Rezervasiyanızı təsdiqləyin',
  'Confirm Email': 'Email-i təsdiqləyin',
  'connection-status-offline': 'Əlaqədə deil',
  'connection-status-online': 'Əlaqədə',
  'Connection status': 'Bağlantı statusu',
  Connecting: 'Qoşulur',
  'Coordinated were copied to clipboard': 'Koordinatlar kopyalandı',
  'Geofence limit reached. Increase map zoom to show all geofences.':
    'Xəritədə geozonaların limiti aşılıb. Bütün geozonalar görmək üçün zəhmət olmasa, yaxınlaşdırın.',
  'Geopoint limit reached. Increase map zoom to show all geopoints.':
    'Xəritədə POİ limiti aşılıb. Bütün POİ görmək üçün zəhmət olmasa, yaxınlaşdırın.',
  'Unit limit reached. Increase map zoom to show all units.':
    'Xəritənin limiti aşılıb. Bütün obyektləri görmək üçün zəhmət olmasa, yaxınlaşdırın.',
  'Click on map to freeze coordinates': 'Koordinatları təyin etmək üçün xəritəyə klikləyin',
  'Copy notification': 'Bildirişi kopyalayın',
  Count: 'Miqdar',
  'Count-statistic': 'Miqdar',
  Cost: 'Qiymət',
  'Count of selected units': 'Obyekt seçilib',
  'Count of selected clients': 'Müştərilər seçilib',
  'Cost of orders': 'Sifarişlərin dəyəri',
  'Deal type': 'Əməliyyat növü',
  Documents: 'Sənədlər',
  'Document type': 'Sənəd növü',
  'Document type not selected': 'Sənəd növü seçilməyib',
  'Document format': 'Sənəd formatı',
  'Document text (HTML)': 'Sənədin mətni (HTML)',
  'Document addition method': 'Sənədin əlavə edilməsi metodu',
  'Type not selected': 'Növ seçilməyib',
  'Does not work': 'İşləmir',
  Works: 'İşləyir',
  'Duration not selected': 'Müddət seçilməyib',
  Send: 'Göndər',
  Settings: 'Parametrlər ',
  'Other settings': 'Digər parametrlər',
  'Last command': 'Sonuncu komanda',
  'Sending time': 'Göndərmə vaxtı',
  Compact: 'Kompakt',
  Completed: 'Tamamlandı',
  'Comparison type': 'Müqayisə növü',
  Company: 'Şirkət',
  Condition: 'Vəziyyət',
  Confirmed: 'Təsdiqlənmiş',
  'Confirmed Client': 'Təsdiqlənmiş müştəri',
  'Confirmed documents': 'Təsdiqlənmiş sənədlər',
  Connection: 'Bağlantı',
  'Connection method': 'Bağlantı metodu',
  'Connected by user': 'İstifadəçi tərəfindən qoşulub',
  'Connect tracker': 'GPS qoşun',
  'Connect battery': 'Batareyanı qoşun',
  'Connected to an object': 'Obyektə qoşulub',
  'Connected to battery': 'Batareyaya qoşulub',
  'Copy of': 'Dublikat',
  Countries: 'Ölkələr',
  Country: 'Ölkə',
  'Country Code': 'Ölkə kodu',
  'Country of registration': 'Qeydiyyat ölkəsi',
  Create: 'Yarat',
  Creation: 'Yaradılış',
  'Create new SMS Gateway': 'SMS şluz yaradın',
  'Create new acquirer': 'Ekvaye yaradın',
  'Create new balance package': 'Bonus paketi yaradın',
  'Create new subscription': 'Abunəlik yaradın',
  'Create new command description': 'Komandanın təsviri yaradın',
  'Create new end-user-price-plan': 'Müştəri tarif planı yaradın',
  'Create new model group': 'Model qrupu yaradın',
  'Create new plan': 'İnteqrator üçün tarif planı yaradın',
  'Create new project': 'Layihə yaradın',
  'Create new region': 'Bölgə yaradın',
  'Create new insurance': 'Sığorta yaradın',
  'Create new route': 'Marşrut yaradın',
  'Create new unit': 'Bir obyekt yaradın',
  'Create new unit model': 'Obyekt modeli yaradın',
  'Create new unit-command-text': 'Bir obyekt üçün komandanı yaradın',
  'Create new unit-hw-model': 'Cihaz modeli yaradın',
  'Create new user': 'İstifadəçi yaradın',
  'Create a field': 'Sahə yaradın',
  'Create unit group': 'Obyekt qrupu yaradın',
  'Creating a client group': 'Müştəri qrupu yaratması',
  'Creating a group': 'Qrup yaratması',
  'Creating a scooter': 'Skuter yaratması',
  'Creating a car': 'Avtomobil yaratması',
  'Creating a bicycle': 'Velosiped yaratması',
  'Creating an electric bicycle': 'Elektrik velosiped yaratması',
  'Creating a bicycle car': 'Velomobil yaratması',
  'Creating a tricycle': 'Trisikl yaratması',
  'Creating a tracker': 'GPS treker yaratması',
  'Creating a baby carriage': 'Uşaq arabasının yaratması',
  'Creating a trailer': 'Qoşqu yaratması',
  'Creating an electric quad bike': 'Elektrikli kvadrosikl yaratması',
  'Creating a charging station': 'Şarj stansiyası yaratması',
  'Creating business model': 'Biznes modeli yaratması',
  'Creation date': 'Yaradılma tarixi',
  'Credit amount': 'Kreditləşdiriləcək məbləğ',
  Creator: 'Yaradan',
  Currency: 'Valyuta',
  'Criteria for achieving the level': 'Səviyyəyə çatmaq üçün meyarlar',
  'Evaluation criterion': 'Qiymətləndirmə meyarları',
  Dashboard: 'İdarəetmə paneli',
  'Data will not be updated': 'Məlumatlar yenilənməyəcək',
  'Data type': 'Məlumat növü',
  'Select data type': 'Məlumat növünü seçin',
  'Date of completion': 'Tamamlanma tarixi',
  'Date of registration': 'Qeydiyyat tarixi',
  'Date of creation': 'Yaradılma tarixi',
  'Date of registration confirmation': 'Qeydiyyat təsdiqinin tarixi',
  'Date of issue of the document': 'Sənədin tərtib olunma tarixi',
  'Display order': 'Göstəriş sırası',
  'Select display order': 'Ekran sırasını seçin',
  Day: 'Gün',
  'Day of week': 'Həftənin günü',
  Days: 'Gün',
  'Days before blocking': 'Mənfi günlərin sayı',
  'Default (cheapest)': 'Standart (ən ucuz)',
  'Default language': 'Standart dil',
  'Default timezone': 'Standart vaxt qurşağı',
  'Default country': 'Standart ölkə',
  'Default business model': 'Standart biznes modeli',
  Delete: 'Sil',
  'Delete geofence?': 'Geozon silinsin',
  'Delete price plan': 'Tarifi silin',
  'Delete language': 'Dili silin',
  'Delete point': 'Nöqtəni silin',
  'Delete route': 'Marşrutu silin',
  'Delete image': 'Şəkli silin',
  'Delete video': 'Videonu silin',
  'Demand coefficient': 'Tələb amili',
  'Demand assessment areas': 'Tələb qiymətləndirmə sahələri',
  'Demand area': 'Tələb qiymətləndirmə sahəsi',
  Description: 'Təsvir',
  Destination: 'Məqsəd',
  'Destination type': 'Təyinat növü',
  'Designated region': 'Təyinat bölgəsi',
  'Destination ID': 'Təyinat ID-si',
  'Description title 1': 'Təsvir başlığı 1',
  'Description title 2': 'Təsvir başlığı 2',
  'Description title 3': 'Təsvir başlığı 3',
  'Description title 4': 'Təsvir başlığı 4',
  'Description value 1': 'Təsvir 1',
  'Description value 2': 'Təsvir 2',
  'Description value 3': 'Təsvir 3',
  'Description value 4': 'Təsvir 4',
  'Description speed mode': 'Təsvir, sürət həddi',
  'Description price plan cost': 'Təsvir, tarif dəyəri',
  Insurance: 'Sığorta',
  'Insurance detail': 'Sığortanın təsviri',
  'Insurance link': 'Sığorta təsvirinə keçid',
  Insurers: 'Sığortaçılar',
  'Insurance price for admin': 'Administrator üçün sığorta dəyəri',
  'Insurance price for integrator': 'İnteqrator üçün sığorta dəyəri',
  'Insurance canceled': 'Sığorta ləğv edildi',
  'is awaiting for confirmation': 'təsdiq gözləyir',
  Import: 'İdxal',
  Repeater: 'Təkrarlayıcı',
  'Unit list edit mode': 'Obyekt siyahısının redaktə metodu',
  'Data content type': 'İdxal ediləcək məlumat məzmunu',
  'Data for import': 'İdxal ediləcək məlumatlar',
  'Import mode': 'İdxal rejimi',
  'Unit assignment type': 'Obyekt təyinat növü',
  Comment: 'Şərh',
  Detailed: 'Ətraflı',
  'Detailed description': 'Ətraflı təsvir',
  'Device vendor': 'İstehsalçı',
  'Device model': 'Model',
  'Device info': 'Cihaz məlumatları',
  Dispatcher: 'Dispetçer',
  Diagnostics: 'Diaqnostika',
  'Distance, m': 'Məsafə, m',
  'Distance, km': 'Məsafə, km',
  'Duration, days (0 - infinite)': 'Müddət, gün (0 - limitsiz)',
  'Duration, hour': 'Müddət, saat',
  'Do you wish to change status and send command': 'Siz statusu dəyişmək və əmri göndərmək əminsiniz',
  'Do you wish to send command': 'Əmri göndərmək əminsiniz',
  Document: 'Sənəd',
  'Document photo': 'Sənədin fotoşəkili',
  'Document name (link to the document)': 'Sənədin adı (sənədə keçid)',
  Documentation: 'Sənədləşmə',
  'Document type not set': 'Sənəd növü təyin edilməyib',
  'Document consent required': 'Sənəd üzrə razılıq tələb olunur',
  'Document expiration date': 'Sənədin qüvvədən düşmə tarixi',
  'Document expiration date (Date of issue + 3 days)': 'Sənədin qüvvədən düşmə tarixi (Tərtib olunma tarixi + 3 gün)',
  'draw polygon, please': 'Zəhmət olmasa, poliqon çəkin.',
  'Documents with the "Country" assignment type are used to display to the client during registration and in the "Legal Documents" section. If you operate with multiple business models, you should add legal documents for each business model. If you need to add a document template populated with client and/or unit data, select the "Unit Type" assignment type.': '“Ölkə” təyinat növü olan sənədlər qeydiyyat zamanı və “Hüquqi sənədlər” bölməsində müştəriyə göstərilir. Əgər siz bir neçə biznes modeli ilə işləyirsinizsə, hər bir biznes modeli üçün hüquqi sənədlər əlavə etməlisiniz. Müştəri və/və ya obyekt məlumatları ilə doldurulan sənəd şablonu əlavə etmək lazımdırsa, “Obyekt tipi” təyinat növünü seçin.',
  'Document template can be provided in two formats: Text and HTML. When you add a document in text format, it will be displayed as is, without formatting. Adding a document in HTML format allows you to display the document exactly as you want.': 'Sənəd şablonu iki formatda təqdim edilə bilər: Mətn və HTML. Sənədi mətn formatında əlavə etdikdə, o, formatlaşdırma nəzərə alınmadan “olduğu kimi” göstəriləcək. Sənədi HTML formatında əlavə etmək isə onu məhz istədiyiniz şəkildə göstərməyə imkan verir.',
  Driver: 'Sürücü',
  'Drivers license photo (Back side)': 'Sürücülük vəsiqəsinin şəkli (arxa tərəf)',
  'Drivers license photo (Front side)': 'Sürücülük vəsiqəsi şəkli (ön tərəf)',
  Edit: 'Redaktə edin',
  Editing: 'Redaktə',
  'Edit Balance': 'Balansı redaktə edin',
  'Edit balance': 'Balansı redaktə edin',
  'Edit insurance': 'Sığortanı redaktə edin',
  'Edit subscription': 'Abunəliyi redaktə edin',
  'Edit fare': 'Tarifi redaktə edin',
  'Edit balance package': 'Bonus paketini redaktə edin',
  'Edit Client': 'Müştərini redaktə edin',
  'Edit command description': 'Komandanın təsvirini redaktə edin',
  'Edit Geopoint': 'POİ redaktə edin',
  'Edit insurance balance': 'Sığorta balansını redaktə edin',
  'Edit SMS Gateway': 'SMS şluz redaktə edin',
  'Edit acquirer': 'Ekvayeri redaktə edin',
  'Edit end-user-price-plan': 'Tarif planını redaktə edin',
  'Edit model group': 'Model qrupunu redaktə edin',
  'Edit price plan': 'Tarif planını redaktə edin',
  'Edit parts': 'Hissələri redaktə edin',
  'Edit plan': 'İnteqrator üçün tarif planını redaktə edin',
  'Edit point': 'Nöqtəni redaktə edin',
  'Edit price plan structure': 'Tarif planının strukturunu redaktə edin',
  'Edit project': 'Layihəni redaktə edin',
  'Edit promo code': 'Promo kodunu redaktə edin',
  'Edit unit group': 'Obyekt qruplarını redaktə edin',
  'Promo Codes': 'Promo kodları',
  'Promo code activations log': 'Promo kodunun aktivləşdirilməsi jurnalı',
  'Purchase Services': 'Alış-veriş xidmətləri',
  'Purchase date': 'Satın alma tarixi',
  Purpose: 'Təyinat',
  'Edit region': 'Regionu redaktə edin',
  'Edit route': 'Marşrutu redaktə edin',
  'Edit service request': 'Tətbiqi redaktə edin',
  'Edit unit': 'Obyekti redaktə edin',
  'Edit unit model': 'Modeli redaktə edin',
  'Edit unit-command-text': 'Komandanı redaktə edin',
  'Edit unit-hw-model': 'Cihaz modelini redaktə edin',
  'Edit user': 'İstifadəçini redaktə edin',
  'Edit group': 'Qrupu redaktə edin',
  'Editing a group': 'Qrupu redaktə etmək',
  'Editing business model': 'Biznes modelinin redaktə edilməsi',
  'Editable by integrator': 'İnteqrator redaktə edə bilər',
  'Editing a charging station': 'Şarj stansiyasının redaktə edilməsi',
  'Editing a geofence': 'Geozon redaktə edilməsi',
  'Electric bike': 'Elektrikli velosiped',
  'Electric bike price': 'El. velosipedin qiyməti',
  Employment: 'İş yeri',
  'Full name of the courier': 'Kuryerin A.S.A.',
  'Current employment': 'Hazırkı iş yeri',
  'Employment type': 'Məşğulluq növü',
  'Courier groups': 'Kuryer qrupları',
  'Courier type': 'Kuryer növü',
  'The method of appointing couriers': 'Kuryerlərin təyin edilməsi üsulu',
  'Employment history': 'Məşğulluq tarixçəsi',
  Email: 'Email',
  'Email sender': 'Göndərənin Email',
  'Enable authentication calls': 'Doğrulama zənglərini aktivləşdirin',
  'Enable password authentication for clients': 'Müştərilərə şifrə ilə identifikasiya etməyə icazə verin',
  'Enabled if unit status is': 'Obyektin statusu uyğun gələrsə, aktivləşdirilir',
  'Enable OSM': 'OSM-dən istifadəyə icazə verin',
  'Enable filtering of new coordinates': 'Yeni koordinatların filtrlənməsini aktivləşdirin',
  'Enable immediately after saving': 'Yadda saxladıqdan dərhal sonra aktivləşdirin',
  'Disable coordinate outlier filtering': 'Kənar koordinatların filtrlənməsini deaktiv edin',
  Error: 'Xəta',
  'This function is disabled for Moneta acquirer': 'Moneta ekvayer üçün bu funksiya deaktiv edilib.',
  'Error of transaction cancelling': 'Əməliyyatın ləğvi xətası',
  'Error code': 'Xəta kodu',
  'Event: ': 'Hadisə: ',
  'Event log': 'Hadisə qeydi',
  'Extended registration': 'Genişləndirilmiş qeydiyyat',
  Extended: 'Genişləndirilmiş',
  'Extended registration type': 'Genişləndirilmiş qeydiyyat növü',
  'Extended registration status': 'Genişləndirilmiş qeydiyyat statusu',
  'Registration status': 'Qeydiyyat statusu',
  'Registration completion status': 'Qeydiyyat statusu',
  'Registration forms': 'Qeydiyyat formaları',
  'Registration form': 'Qeydiyyat forması',
  'Expiry date': 'Bitmə tarixi',
  'Expiration date': 'Bitmə tarixi',
  'Ext. registration': 'Geniş. qeydiyyat',
  'Failed transaction type': 'Uğursuz əməliyyat növü',
  'Field must be a real number': 'Sahə rəqəm olmalıdır',
  'Fields must match': 'Sahələr uyğun olmalıdır',
  'Field types': 'Sahə növləri',
  'Finish time': 'Bitmə vaxtı',
  'Finish-time': 'Tamamlanma vaxtı',
  Finished: 'Tamamlandı',
  finished: 'tamamlandı',
  'Finished orders': 'Tamamlanmış sifarişlər',
  'Financial operations': 'Maliyyə əməliyyatları',
  'Last financial operation': 'Son maliyyə əməliyyatı',
  'Last operation': 'Son əməliyyat',
  'Recipient\'s account': 'Alıcının hesabı',
  'First 6': 'İlk 6',
  'Latest 4': 'Son 4',
  'File not selected': 'Heç bir fayl seçilməyib',
  'File types': 'Fayl növləri',
  'Select file types': 'Fayl növlərini seçin',
  'For balance in currency': 'Valyuta balansı üçün',
  'For subscriptions': 'Abunəliklər üçün',
  'Full description': 'Ətraflı təsvir',
  'Full screen mode': 'Tam ekran rejimi',
  'Full name of the Individual Entrepreneur': 'Fərdi sahibkarın tam adı',
  'statistics-finished': 'Tamamlandı',
  'statistics-cancelled': 'Ləğv edildi',
  'Active clients': 'Aktiv müştərilər',
  'general-statistic-active': 'Aktiv',
  'Inactive clients': 'Aktiv olmayan müştərilər',
  'Blocked clients': 'Bloklanmış müştərilər',
  'By default': 'Defolt',
  'By default, linking a bank card to rent is required, regardless of the method of rent payment. If you want to provide services without the obligatory linking of a bank card, uncheck the box. Please note that disabling this setting may lead to the formation of debts and the inability to repay these debts.':
    ' Varsayılan olaraq, ödəniş üsulundan asılı olmayaraq, kirayə üçün bank kartının əlaqələndirilməsi tələb olunur. Bank kartının məcburi əlaqələndirilməsi olmadan xidmətlər göstərmək istəyirsinizsə, qutunun işarəsini çıxarın. Nəzərə alın ki, bu ayarı deaktiv etmək borcların yığılmaması ilə nəticələnə bilər.',
  '"By default" - holding is confirmed only in cases where the write-off amount is greater than or equal to the holding amount. "New customers" - holding is confirmed in the first order, regardless of the debit amount, the excess is credited to the client\'s balance. "All clients" - holding is always confirmed, the excess is credited to the client\'s balance.':
    '"Defolt" – saxlama yalnız debet məbləği saxlama məbləğindən çox və ya bərabər olduqda təsdiqlənir. "Yeni müştərilər" – saxlama debet məbləğindən asılı olmayaraq ilk sifarişdə təsdiqlənir və artıq məbləğ müştərinin balansına köçürülür. "Bütün müştərilər" – saxlama həmişə təsdiqlənir və artıq məbləğ müştərinin balansına köçürülür.',
  'Active users': 'Aktiv istifadəçilər',
  'Inactive users': 'Aktiv olmayan istifadəçilər',
  Filter: 'Filtr',
  Filtering: 'Filtrasiya',
  'Finish time of last order': 'Son sifarişin tamamlanma vaxtı',
  Firmware: 'Proqram təminatı',
  'First name': 'Ad',
  'First page passport photo': 'Pasportun ilk səhifəsinin fotoşəkili',
  'First rate selected by default': 'Standart tarifin seçilməsi',
  'Form validation error': 'Forma doğrulama xətası',
  'Form type': 'Forma növü',
  'Fuel tank volume': 'Yanacaq çəninin tutumu',
  'Fuel tank volume (L)': 'Yanacaq çəninin tutumu (L)',
  'Fuel type': 'Yanacaq növü',
  'GSM not found': 'GSM tapılmadı',
  General: 'Ümumi',
  'General statistics': 'Ümumi statistika',
  'General information': 'Ümumi məlumat',
  'general-information': 'ümumi məlumat',
  Geofences: 'Geozonlar',
  Geopoints: 'POİ',
  Geopoint: 'Geotəpə',
  'Geopoint types': 'POİ növləri',
  'geopoint-geometry-info-text': 'Geonöqtənin yerləşməsini region daxilində göstərin. Geonöqtə yalnız məlumat xarakteri daşıyır. Geonöqtənin yerləşməsini göstərdikdən sonra “Yadda saxla” düyməsini basın.',
  'Geo objects': 'Geozonalar',
  'GPS status': 'GPS statusu',
  'GPS coordinates': 'GPS koordinatları',
  'gps-status-offline': 'GPS qoşulu deyil',
  'gps-status-online': 'GPS qoşulub',
  'Give the region a name': 'Regionun adını təyin edin',
  Groups: 'Qruplar',
  Group: 'Qrup',
  'HW model': 'Avadanlıq modeli',
  'HW type': 'Avadanlıq növü',
  'Hair dryer': 'Saç qurutma maşını',
  'Hardware ID': 'Avadanlıq ID-si',
  'Hardware IMEI': 'Avadanlığın IMEI-si',
  'Hardware models': 'Avadanlıq modelləri',
  'Hardware id of new tracker': 'Yeni GPS-in ID-si',
  'Hardware model of new tracker': 'Yeni izləyicinin aparat modeli',
  'Hardware parameters': 'Avadanlıq parametrləri',
  'Hardware type': 'Avadanlıq növü',
  'Has attachment files': 'Əlavə edilmiş fayllar var',
  'Has bank cards': 'Bank kartları mövcuddur',
  'Has transaction by bank cards': 'Bank kartları ilə əməliyyat aparılır',
  'Hasn\'t attachment files': 'Əlavə edilmiş fayllar yoxdur',
  'Hasn\'t bank cards': 'Bank kartları mövcud deyil',
  'Hasn\'t transaction by bank cards': 'Bank kartı əməliyyatları yoxdur',
  Hidden: 'Gizlədilib',
  'Hide unit in application': 'Tətbiqdə obyekti gizlət',
  'Hybrid vehicle': 'Hibrid',
  ID: 'ID',
  'Idle time more than (sec)': 'Boş vaxt çoxdur (saniyyə)',
  Idle: 'Boş',
  'If there is no rate translation into the language of the client\'s phone, client will be shown rate information in the default language. We recommend adding translation of the rate into the English and setting the default language of the rate to English.':
    'Əgər tarif planı müştərinin telefon dili ilə uyğun gələn dilə tərcümə olunmazsa, müştəri tarif planı məlumatlarını standart dildə görəcək. Tarif planının ingilis dilinə tərcüməsini əlavə etməyi və tarif planı üçün standart dil olaraq ingilis dilini təyin etməyi tövsiyə edirik.',
  'Is published': 'Nəşr olunub',
  'statistics-idle': 'Boşdur',
  'general-statistics-idle': 'Boş',
  Image: 'Şəkil',
  'Increase balance by amount': 'Balansı məbləğlə artırın',
  'Increase balance': 'Balansı artırın',
  'Decrease balance': 'Balansı azaldın',
  'In rent': 'Kirayədədir',
  'In service': 'Servisdə',
  'In order': 'Sifarişdə',
  'Hidden in the application': 'Tətbiqdə gizlədilib',
  'In service time': 'Xidmətdə olduğu müddət',
  'In the test mode, the subscription is available only to the specified clients-testers. In combat mode, the subscription will be available to all customers in the region':
    'Sınaq dövründə abunəlik yalnız təyin olunmuş sınaq müştəriləri üçün əlçatandır. İstehsal dövründə isə abunəlik regiondakı bütün müştərilər üçün əlçatan olacaq.',
  'In the mobile application, the tariff in the list of tariffs will be displayed in the priority specified in this field.':
    'Mobil tətbiqdə tarif siyahısındakı tarif bu sahədə göstərilən prioritetdə göstəriləcək.',
  Info: 'Məlumat',
  'Information for clients': 'Müştərilər üçün məlumat',
  'Information for the client': 'Müştəri üçün məlumat',
  Integrator: 'İnteqrator',
  Interest: 'Dəyər',
  'Integrator price plans': 'İnteqrator üçün tarif planları',
  Interface: 'İnterfeys',
  'Interval (hh:mm - hh:mm)': 'İnterval (ss:dd - ss:dd)',
  'Interval (hh:mm:ss - hh:mm:ss)': 'İnterval (ss:dd:ss - ss:dd:ss)',
  'Interval start time must be less than end time': 'İntervalın başlama vaxtı bitmə vaxtından az olmalıdır',
  'Invalid e-mail address': 'Yanlış E-mail ünvanı',
  Journal: 'Jurnal',
  Language: 'Dil',
  Languages: 'Dillər',
  'Last Message Time': 'Son mesaj vaxtı',
  'Last message': 'Son mesaj',
  'Last name': 'Soyadı',
  'Last order time status': 'Son sifarişin tamamlanma vaxtı',
  'Last maintenance date': 'Son texniki xidmət tarixi',
  'Last maintenance mileage': 'Son texniki xidmətin yürüşü',
  'Last comment': 'Son şərh',
  'Lights off': 'İşıqları söndürün',
  'Lights on': 'İşığı yandırın',
  Loading: 'Yüklənir',
  'Loading tracks': 'Treklər yüklənir',
  'Loading Units': 'Obyektlər yüklənir',
  'Loading Map': 'Xəritə yüklənir',
  Location: 'Yerləşmə',
  'location-status-parking-forbidden': 'Parkinq qadağandır',
  'location-status-parking-allowed': 'Parkinqə icazə verilir',
  'location-status-riding-forbidden': 'Sürməyə qadağandır',
  'location-status-riding-allowed': 'Sürməyə icazə verilir',
  'Location status, riding': 'Sürməyə icazə olan zonasında status',
  Locator: 'Lokator',
  'Create locator': 'Lokator yaradın',
  '1 hour': '1 saat',
  '2 hours': '2 saat',
  '3 hours': '3 saat',
  '4 hours': '4 saat',
  '6 hours': '6 saat',
  '12 hours': '12 saat',
  '1 day': '1 gün',
  '2 days': '2 gün',
  'Link expire time': 'Linkin etibarlılıq müddəti',
  'Locator link copied to clipboard': 'Lokatorun linki kopyalandı.',
  'Locator link': 'Lokatorun linki',
  'Lock type': 'Kilid növü',
  'Lock price': 'Kilidin qiyməti',
  Login: 'Giriş',
  'Login as': 'Giriş...',
  'Login history': 'Giriş... tarixçəsi',
  Logout: 'Çıxış',
  'Log out': 'Çıxış',
  Logo: 'Loqo',
  'Lower bound of the interval': 'İntervalın aşağı həddi',
  'Main filter': 'Əsas filtr',
  'Maximum icon width': 'Maksimum ikon eni 64px',
  'Maximum icon height': 'Maksimum ikon hündürlüyü 64px',
  'Maintenance log': 'Texniki xidmət jurnalı',
  'Manual top-up': 'Əl ilə doldurma',
  'Manual assignment of clients to a group': 'Müştəriləri əl ilə bir qrupa təyin etmək',
  'Create maintenance entry': 'Jurnal qeydi yaradın',
  Guests: 'Qonaq',
  'Guest account type': 'Qonaq hesabı növü',
  'Edit maintenance entry': 'Jurnal qeydini redaktə edin',
  'Maintenance Interval Mileage, km': 'Texniki baxış intervalı, km',
  'maintenance-expired': 'Müddəti bitib',
  'Map image': 'Xəritə şəkli',
  'Map services': 'Xəritə servisləri',
  Map: 'Xəritə',
  'Maximum available number of uses': 'Maksimum istifadə sayı',
  'Mechanical lock code': 'Mexaniki kilid kodu',
  'Merchant Id': 'Satıcı ID-si',
  'Message Sender': 'Mesaj Göndərən',
  'Messages were sent': 'Mesajlar göndərildi',
  'The message sending task has been sent for processing': 'Mesaj göndərmək tapşırığı emal üçün göndərilib.',
  'Message sent': 'Mesaj göndərildi',
  'Messages from trackers': 'İzləyicilərdən gələn mesajlar',
  'Method of conducting': 'Tətbiq üsulu',
  'Middle name': 'Soyadı',
  Mileage: 'Yürüş',
  'Minutes ago': 'Bir neçə dəqiqə əvvəl',
  'Mobile device': 'Mobil cihaz',
  Model: 'Model',
  Moderator: 'Moderator',
  'Access to document moderation': 'Sənəd yoxlamasına icazə',
  'Model of new tracker': 'Yeni GPS modeli',
  'Model group': 'Modellər qrupu',
  'Model groups': 'Modellər qrupları',
  'Model popularity': 'Modellərin populyarlığı',
  'Model ratio': 'Model nisbəti',
  Models: 'Modellər',
  Month: 'Ay',
  Year: 'İl',
  Multicasting: 'Rassilka',
  Name: 'Ad',
  'Name of new tracker': 'Yeni GPS adı',
  'Name of the level': 'Səviyyə adı',
  'Name and Surname': 'Ad və soyad',
  'Navigation button': 'Kecid düyməsi',
  New: 'Yeni',
  new: 'yeni',
  new_ones: 'Yeni',
  'New alarms': 'Yeni həyəcan siqnalı',
  'New Balance': 'Yeni Balans',
  'New Client': 'Yeni Müştəri',
  'New clients': 'Yeni Müştərilər',
  'New requests': 'Yeni',
  'New icon': 'Yeni ikon',
  'New - the partner has not yet started working due to the various circumstances, so the payment according to the specified payment terms is not carried out. Upon the fact of readiness for work, the status of the partner changes to the Active status, according to which the calculation is carried out on the basis of the specified payment terms. Blocked - the user has no access to the system due to manual blocking of the account by the parent. Parent Blocked - The user is blocked due to the blocking of the parent account.':
    'Yeni – tərəfdaş konfiqurasiya səbəbindən hələ işə başlamayıb, ona görə də göstərilən ödəniş şərtlərinə əsasən ödənişlər emal olunmur. İşə hazır olduqdan sonra tərəfdaşın statusu Aktiv vəziyyətinə yüksəldilir və ödənişlər göstərilən ödəniş şərtlərinə əsasən emal olunur. Bloklanıb – istifadəçi valideyn tərəfindən əl ilə bloklanması səbəbindən sistemə daxil ola bilmir. Valideyn Bloklanıb – istifadəçi valideyn hesabının bloklanması səbəbindən bloklanıb.',
  'Next maintenance': 'Növbəti texniki baxiş',
  No: 'Yox',
  Yes: 'Hə',
  'geofence-disabled': 'Off',
  'geofence-active': 'On',
  'geofence-boundaries-info-text': 'Xəritə alətlərindən istifadə edərək geozona sərhədlərini çəkin. Nöqtələri birləşdirdikdən sonra “Yadda saxla” düyməsini basın',
  'geofence-boundaries-tech-type-info-text': 'Xəritə alətlərindən istifadə edərək texnikin ərazisinin sərhədlərini çəkin. Nöqtələri birləşdirdikdən sonra “Yadda saxla” düyməsini basın',
  'geofence-boundaries-demand-type-info-text': 'Xəritə alətlərindən istifadə edərək tələbatın qiymətləndirilməsi zonasının sərhədlərini çəkin. Nöqtələri birləşdirdikdən sonra “Yadda saxla” düyməsini basın',
  'Not assigned': 'Təyin edilməyib',
  'Not operational': 'Xarab',
  'notification-enabled': 'Qoşulub',
  'Notification-enabled': 'Qoşulub',
  'Notification events': 'Bildiriş hadisələri',
  'Notification will be sent when the client\'s activity level increases to the current level.':
    'Müştərinin aktivlik səviyyəsi cari səviyyəyə yüksəldikdə bildiriş göndəriləcək.',
  'Notification will be sent when the client\'s activity level decreases to the current level.':
    'Müştərinin fəaliyyət səviyyəsi cari səviyyəyə düşdükdə bildiriş göndəriləcək.',
  'require_end_user_bank_card-enabled': 'Qoşulub',
  'require_end_user_bank_card-off': 'Söndürülüb',
  'Not selected': 'Seçilməyib',
  Source: 'Mənbə',
  'One-time password source': 'Birdəfəlik şifrə mənbəyi',
  'Source type': 'Mənbə növü',
  'Source name': 'Mənbə',
  'Skip areas where the object is stationary': 'Obyektin hərəkətsiz olduğu sahələri atlayın',
  'No alarms': 'Həyəcan siqnalı yoxdur',
  'No signal': 'Siqnal yoxdur',
  'No information': 'Məlumat yoxdur',
  'No order finish photo': 'Sifarişin tamamlanmasının heç bir şəkli yoxdur.',
  'No client profile photo': 'Müştərinin şəkli yoxdur',
  'No photo of the courier': 'Kuryerin şəkli yoxdur',
  'No executor photo': 'İcraçının şəkli yoxdur',
  'No unit model picture': 'Obyekt modelinin şəkili yoxdur',
  'No new notifications': 'Yeni bildiriş yoxdur',
  'No cards available': 'Xəritələr mövcud deyil',
  Now: 'İndi',
  'Number of free cancellations': 'Pulsuz rezervasiya ləğvlərin sayı',
  'Number of luggage spaces': 'Baqaj yeri',
  'Number of seats': 'Oturacaq tutumu',
  'Number of clients': 'Müştərilərin sayı',
  'Number of couriers': 'Kuryerlərin sayı',
  'n/a': 'm/d',
  'n/i': 'm/y',
  Offline: 'Əlaqə yoxdur',
  Off: 'Söndürülüb.',
  'Switched off': 'Söndürülüb',
  On: 'Qoşulub.',
  'Switched on': 'Qoşulub',
  'Online available': 'Onlayn',
  'Online in rent': 'Sifariş verildi',
  'only with orders': 'Sifarişlərlə',
  'only without orders': 'Sifarişsiz',
  'Open door': 'Qapını aç',
  Operational: 'Saz',
  'Or command text': 'Və ya komanda mətni',
  Order: 'Sifariş',
  Task: 'Tapşırıq',
  System: 'Sistem',
  'Balance before operation': 'Əməliyyatdan əvvəl balans',
  'Balance after operation': 'Əməliyyatdan sonra balans',
  'Order events': 'Sifariş hadisələri',
  'Order count': 'Sifarişlərin sayı',
  'Order duration': 'Sifarişlərin müddəti',
  Duration: 'Müddət',
  'Order log': 'Sifariş jurnalı',
  'Order status': 'Sifariş statusu',
  'Order completion photo': 'Sifarişin tamamlanmasının fotosu',
  'Reason for termination': 'Xitamın səbəbi',
  'Remaining minutes': 'Qalan dəqiqələr',
  'Remaining trips': 'Qalan səfərlər',
  Remaining: 'Qalıq',
  'Remove from access': 'Mövcud deil',
  'Removable battery': 'Çıxarıla bilən batareya',
  Reading: 'Oxuma',
  'order-status-active': 'Aktiv',
  'order-status-booked': 'Bronda olan',
  'order-status-available': 'Mövcuddur',
  'order-status-not_available': 'Mövcud deil',
  'order-status-on_charge': 'Şarjda',
  'order-status-at_warehouse': 'Ambarda',
  'order-status-service_mode': 'Servisdə',
  'order-status-under_repair': 'Təmirdə',
  'order-status-donor': 'Donor',
  'order-status-stolen': 'Oğurlanmış',
  'order-status-free': 'Boş',
  'order-status-hidden-in-application': 'Tətbiqdə gizlədilib',
  'order-status-paused': 'Fasilə üzərində',
  'Ordinal number': 'Seriya nömrəsi',
  Orders: 'Sifarişlər',
  'Orders count': 'Sifarişlərin sayı',
  'OS type': 'ƏS növü',
  OS: 'ƏS',
  'OS version': 'ƏS versiyası',
  'Out of rent': 'Kirayə bitdi',
  Overview: 'Baxış',
  Owner: 'Sahib',
  Points: 'Nöqtələr',
  Radius: 'Radius',
  Notification: 'Bildiriş',
  Notifications: 'Bildirişlər',
  'Create new notification': 'Yeni bildiriş yaradın',
  'Edit notification': 'Bildirişi redaktə edin',
  'All units in these projects': 'Layihələrdəki bütün obyektlər',
  'All units of these models': 'Bütün model obyektlər',
  'All units owned by these users': 'İstifadəçilərə məxsus obyektlər',
  'Units located in regions': 'Bölgələrdə yerləşən obyektlər',
  'All units loaded': 'Bütün obyektlər yüklənib',
  'All orders loaded': 'Bütün sifarişlər yüklənib.',
  'All orders loaded from cache': 'Bütün sifarişlər keşdən yüklənir',
  'All clients': 'Bütün müştərilər',
  'Registered clients': 'Qeydiyyatdan keçmiş müştərilər',
  Registered: 'Qeydiyyatdan keçmiş',
  'Anonymous clients': 'Anonim müştərilər',
  Anonymous: 'Anonim',
  'All executors': 'Bütün icraçılar',
  Executor: 'İcraçı',
  'Select executor': 'İcraçı seçin',
  'My employee': 'İşçilərim',
  'Co-owners': 'Ortaq sahiblər',
  'Select co-owners': 'Ortaq sahibləri seçin',
  Message: 'Mesaj',
  'Minimum charge': 'Minimum şarj',
  'Maximum charge': 'Maksimum şarj',
  'Maximum speed': 'Maksimal sürət',
  'Positioning loss more than (seconds)': 'Mövqe itkisi (saniyədə)',
  'position-job': 'Vəzifə',
  'Postpone check': 'Təsdiqləməni təxirə salın',
  'Connection loss more than (seconds)': 'Bağlantı uzun müddətə kəsildi (saniyə)',
  'Charge less than (percent)': 'Şarj azdır (%)',
  'Rent duration more than (seconds)': 'Kirayə müddəti çoxdur (saniyə)',
  'Rent duration': 'Kirayə müddəti',
  'Registration type': 'Qeydiyyat növü',
  Registration: 'Qeydiyyat',
  'Movement shorter than (seconds)': 'Daha az hərəkət (saniyə)',
  'Movement longer than (seconds)': 'Daha çox hərəkət (saniyə)',
  'Movement type': 'Hərəkət növü',
  'Move to payment': 'Ödənişə keçin',
  'Move up': 'Yuxarı qaldırın',
  'Move down': 'Aşağı salın',
  'Finish booking': 'Rezervasiyanızı tamamlayın',
  'Cancel booking': 'Rezervasiyanı ləğv edin',
  // "Canceled": "Ləğv edilmiş",
  Finish: 'Bitir',
  'Find orders': 'Sifarişlər axtarın',
  'Find by LBS': 'LBS ilə tapın',
  'Fuel level %': 'Yanacaq səviyyəsi %',
  'Cancel order': 'Sifarişi ləğv edin',
  'Cancel subscription': 'Abunəliyi ləğv edin',
  'Order already closed': 'Sifariş artıq bağlanıb',
  'Are sure you want to finish this order': 'Bu sifarişi tamamlayırsınız?',
  'Are sure you want to cancel this order': 'Həqiqətən də bu sifarişi ləğv etmək istəyirsiniz?',
  'Are sure you want to cancel this transaction': 'Həqiqətən əməliyyatı ləğv etmək istəyirsiniz?',
  'Paid booking currency': 'Ödənişli rezervasiyanın valyutası',
  'Paid booking mode': 'Ödənişli rezervasiya rejimi',
  'Paid booking price': 'Ödənişli rezervasiyanın dəyəri',
  'Parameter name': 'Parametr adı',
  'Passport photos': 'Pasport şəkilləri',
  Password: 'Şifrə',
  'Passwords do not match': 'Şifrələr uyğun gəlmir',
  'Password is required': 'Şifrə daxil etməlisiniz',
  'One-time password': 'Birdəfəlik şifrə',
  'Multiple use password': 'Təkrar istifadə edilə bilən şifrə',
  'Payment method': 'Ödəniş üsulu',
  'Payment conditions': 'Ödəniş şərtləri',
  'Payment procedure': 'Ödəniş proseduru',
  'Payment currency': 'Ödəniş valyutası',
  'Payment acceptance': 'Ödənişlərin qəbulu',
  'Payment services': 'Alış-veriş xidmətləri',
  'Payment amount': 'Ödəniş məbləği',
  'Payment failed': 'Ödəniş emalı xətası',
  'Passport expiration date': 'Pasportun müddəti',
  Citizenship: 'Vətəndaşlıq',
  'Select citizenship': 'Zəhmət olmasa, vətəndaşlığınızı seçin',
  Page: 'Səhifə',
  Period: 'Dövr',
  'Period of validity': 'Qüvvədə olma müddəti',
  'Person type': 'Üz növü',
  'Personal data': 'Şəxsi məlumatlar',
  'Percentage of revenue': 'Gəlirin faizi',
  'Percentage of order value': 'Sifariş dəyərinin faizi',
  'Pending confirmation': 'Təsdiq gözlənilir',
  Phone: 'Telefon',
  'Phone / SIM number': 'Telefon / SİM nömrə',
  'Photo report': 'Foto hesabat',
  'Photo of Registration': 'Qeydiyyat/yaşayış icazəsinin şəkli',
  'Photo of Registration (New)': 'Qeydiyyat/yaşayış icazəsinin şəkli (təzə)',
  'Phone number': 'Telefon nömrəsi',
  'Phone manufacturer and model': 'Telefon istehsalçısı və modeli',
  'Photo gallery': 'Fotoqalereya',
  photo: 'foto',
  Photography: 'Şəkil',
  'Plate number': 'Qeydiyyat nişanı',
  'Planned payment terms': 'Planlaşdırılan ödəniş şərtləri',
  'Place of Birth': 'Doğulduğu yer',
  'Place of registration': 'Qeydiyyat yeri',
  'Place of residence': 'Yaşayış yeri',
  'please, wait': 'xahiş edirik gözləyin',
  Position: 'Yerləşmə',
  'please wait': 'xahiş edirik gözləyin',
  'Please add maintenance record': 'Təmir qeydləri əlavə edin',
  'Please set up car mileage': 'Zəhmət olmasa, nəqliyyat vasitəsinin cari yürüşünü göstərin.',
  'Please set up maintenance interval': 'Texniki baxış intervalını göstərin',
  'Please provide a reason (Optional)': 'Zəhmət olmasa, səbəb göstərin (İstəyə bağlı)',
  'Please enter your phone number in international format: start with "+" and include the country code.':
    'Zəhmət olmasa telefon nömrənizi beynəlxalq formatda daxil edin: "+" ilə başlayın və ölkə kodunu daxil edin.',
  'Please specify the name of the component type': 'Zəhmət olmasa komponent növünün adını göstərin',
  'Please specify the name of the component model': 'Komponentin model adını göstərin',
  'Please provide a free-form description of the model, such as specifications. This field is optional. and is currently only visible for the component model.':
    'Zəhmət olmasa, spesifikasiyalar kimi modelin sərbəst forma təsvirini təqdim edin. Bu sahə isteğe bağlıdır və hazırda yalnız komponent modeli üçün göstərilir.',
  'Please enter the maximum GPS speed value at which the coordinates will be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Koordinatların etibarlı sayılması üçün GPS üzrə maksimal sürət dəyərini göstərin. Filtrləmə yalnız son etibarlı koordinatlara əsasən obyektin xəritədə düzgün göstərilməsi və kənar dəyərlərin qarşısının alınması üçün onlayn mesajlara tətbiq olunur. Avadanlıq tərəfindən göndərilən faktiki koordinatlar mesaj tarixçəsində saxlanılır.',
  'Please note that this functionality is intended exclusively for courier-type business models. In case of leaving a speed limit geofence, a general speed limit command of the region will be sent to devices':
    'Diqqətinizə çatdırırıq ki, bu funksionallıq yalnız kuryer tipli biznes modeli üçün nəzərdə tutulub. Sürət məhdudiyyəti geozonasından kənara çıxarkən, cihazlara region üzrə ümumi sürət məhdudiyyəti komandası göndəriləcək',
  'Power reserve': 'Ehtimal yürüş',
  'Power reserve (km)': 'Ehtimal yürüş (km)',
  'Previously Balance': 'Əvvəlki balans',
  Price: 'Qiymət',
  'Price 1': 'Qiymət 1',
  'Price 2': 'Qiymət 2',
  'Price 3': 'Qiymət 3',
  'Price 4': 'Qiymət 4',
  'Price in currency': 'Qiymət xarici valyutada',
  'Price per unit': 'Hər obyekt üçün qiymət',
  'Price plan': 'Tarif',
  'Price plan creation': 'Tarif planının yaradılması',
  'Price plans': 'Tariflər',
  'Price plan count': 'Tarif planlarının sayı',
  'Price plan type': 'Tarif növü',
  'Price plan preview': 'Tarif önizləməsi',
  'Price plan can be assigned either to all objects of a specific user, or to all objects of a certain model, or to specific objects. To display the selection field for the desired destination, you must select the type of destination.':
    'Tarif müəyyən bir istifadəçinin bütün obyektlərinə, müəyyən bir modelin bütün obyektlərinə və ya müəyyən obyektlərə təyin edilə bilər. Tələb olunan tapşırıq seçim sahəsini göstərmək üçün tapşırıq növünü seçin.',
  Priority: 'Prioritet',
  Process: 'Proses',
  Profile: 'Profil',
  Project: 'Layihə',
  'Profile photo': 'Profil şəkli',
  'Project Country': 'Ölkə',
  'Project Name': 'Layihə',
  'Project countries': 'Ölkələr',
  Projects: 'Layihələr',
  'Promo code': 'Promo kodu',
  'Promo code copied to clipboard': 'Promo kodu kopyalandı.',
  'promotions-and-news-publish-description':
    'Dərc etməzdən əvvəl bütün məlumatları ikiqat yoxlamağı məsləhət görürük.' +
    ' Artıq dərc olunmuş xəbəri redaktə etsəniz, nəşr avtomatik olaraq silinəcək' +
    ' və yenidən nəşr üçün “Hazırlanmış” statusuna keçiriləçək.',
  'promotions-and-news-remove-from-publication-description':
    'Xəbərlər artıq müştərilər üçün əlçatan olmayacaq, lakin xəbər siyahınızda qalacaq.' +
    ' Xəbəri yenidən dərc etmək lazımdırsa, onu redaktə etməlisiniz,' +
    ' Bundan sonra xəbərlər yenidən dərc üçün avtomatik olaraq "Hazırlanmış" statusuna keçiriləcək.',
  'UID code copied to clipboard': 'UID kopyalandı',
  Prohibited: 'Dərc qadağandır',
  Published: 'Dərc olunub',
  Publish: 'Dərc et',
  'Push history': 'Push bildiriş tarixçəsi',
  'Push notifications': 'Push bildirişləri',
  'Push notification': 'Push bildiriş',
  'Push broadcast': 'Push bildirişləri göndərilir',
  'Push notification text for client': 'Müştəri üçün push bildiriş mətnini',
  'Push notification text': 'Push bildiriş mətnini',
  'Push notification to send when user has free cancellations left': 'Qalan pulsuz ləğvlərin sayı barədə push bildiriş',
  'Push notification to send when booking is paid': 'Ödənişli rezervasiya üçün push bildiriş',
  'Push notification translations': 'Push bildiriş tərcümələri',
  Pinned: 'Sancaqlandı',
  'Not pinned': 'Sancaqlanmadı',
  'Pin news': 'Xəbərləri sancın',
  'Pinned post': 'Sancaqlanmış yazı',
  'Rapid message delivery service': 'Ekspress mesaj çatdırılma xidməti',
  Rate: 'Tarif',
  'Rate of cancellation': 'Ləğv nisbəti',
  'Rates for subscriptions': 'Abunəliklər üçün tariflər',
  Rates: 'Tariflər',
  'Ready to order': 'Sifariş üçün hazırdır',
  'Region Name': 'Bölgənin adı',
  Reason: 'Səbəb',
  Refresh: 'Yenilə',
  Refunds: 'Qaytarılmalar',
  Refund: 'Qaytarılma',
  'Refunds(bank)': 'Geri ödəmələr (bank)',
  'Amount to cancel': 'Ləğv məbləği',
  Region: 'Bölgə',
  Regions: 'Bölgələr',
  'Registration date': 'Qeydiyyat tarixi',
  'Registration number': 'Qeydiyyat nömrəsi',
  'Registration status in the system': 'Sistemdə qeydiyyat statusu',
  'Reg. number': 'Qeydiyyat nömrəsi',
  'Reg. number not specified': 'Qeydiyyat nömrəsi təyin edilməyib',
  Remove: 'Sil',
  'Remove translate': 'Tərcüməni silin',
  Removed: 'Silinib',
  'Remove document': 'Sənədi silin',
  'Remove from publication': 'Nəşrdən silin',
  'Removed from publication': 'Nəşrdən silinib',
  'Rent from integrator to integrator': 'İnteqratordan inteqratora icarəyə verilib',
  'Rent to integrator': 'İnteqratora icarəyə verilib',
  'Repeat password': 'Şifrəni təkrarlayın',
  'Repeat the previously entered password to confirm the match.': 'Uyğunluğu təsdiqləmək üçün əvvəllər daxil etdiyiniz şifrəni təkrarlayın.',
  Repeaters: 'Retranslyator',
  'repeater-enabled': 'Aktiv',
  'region-boundaries-info-text': 'Regionun sərhədlərini çəkmək üçün xəritə alətlərindən istifadə edin. Nöqtələri birləşdirdikdən sonra “Yadda saxla” düyməsini basın',
  Protocol: 'Protokol',
  Port: 'Port',
  'Enable repeater for all units matching filter': 'Filtrə uyğun gələn bütün obyektlər üçün retranslyatoru aktivləşdirin',
  'Disable repeater for all units matching filter': 'Filtrə uyğun gələn bütün obyektlər üçün retranslyatoru deaktiv edin',
  'repeating-enabled': 'Aktiv',
  'Repeater information': 'Retranslyator məlumatı',
  'For courier shifts': 'Kuryer növbələr üçün',
  'For shifts': 'Növbələr üçün',
  'Select protocol': 'Protokol seçin',
  'Select unit assignment type': 'Obyekt təyinat növünü seçin',
  Reports: 'Hesabatlar',
  Request: 'Tələb',
  'Requests in progress': 'Davam edir',
  'Required driver experience, years': 'Tələb olunan sürücülük təcrübəsi, il',
  'Required driver age': 'Tələb olunan sürücü yaşı',
  'Required field': 'Tələb olunan sahə',
  'Required step': 'Məcburi addım',
  'Required to fill out': 'Tələb olunan sahə',
  'Required question': 'Məcburi olan sual',
  'Reservation info': 'Sifariş məlumatı',
  Reset: 'Sıfırla',
  'Residence address': 'Yaşayış ünvanı',
  Response: 'Cavab',
  'Restart SIM': 'SIM kartı yenidən başladın',
  Results: 'Nəticələr',
  'Returning clients': 'Qayıdan müştərilər',
  Revenue: 'Gəlir',
  Riding: 'Sürülür',
  Role: 'Rol',
  'Route points': 'Marşrut nöqtələri',
  'Routes purchases': 'Marşrut alışları',
  Satellites: 'Peyklər',
  'Satellites not found': 'Peyklər tapılmadı',
  Save: 'Yadda saxla',
  Saved: 'Yadda saxlanıldı',
  Schedule: 'Cədvəl',
  'New schedule': 'Yeni cədvəl',
  'Existing schedule': 'Mövcud cədvəl',
  'Name of new schedule': 'Yeni cədvəlin adı',
  'Enter name of new schedule': 'Yeni cədvəl üçün ad daxil edin',
  'Select schedule': 'Cədvəl seçin',
  'Geofence schedule': 'Geozon cədvəli',
  'Price plan schedule': 'Tarif cədvəli',
  'schedule-plan': 'Cədvələ sal',
  'Schedule template': 'Cədvəl şablonu',
  'Schedule is enabled': 'Cədvəl daxildir',
  'schedule changes in payment terms at the end of the current billing period':
    'cari ödəniş dövrünün sonunda ödəniş şərtlərində dəyişiklikləri planlaşdırın',
  'Scope of assessment': 'Qiymətləndirmə sahəsi',
  Scooter: 'Skuter',
  Scooters: 'Skuterlər',
  'Send a command': 'Komandanı göndərin',
  'Send command "Disable service mode"': '"Servis rejimini söndür" komandanı göndərin',
  'Send command "Enable service mode"': '"Servis rejimini qoş" komandanı göndərin',
  'Send command to unit': 'Komandanı göndərin',
  'Send push notification to client': 'Müştəriyə push bildirişi göndərin',
  'Send push notification': 'Push bildirişi göndərin',
  'Send push notification to client after registration': 'Qeydiyyatdan sonra müştəriyə push bildirişi göndərin',
  'Send a notification to the client about the level change': 'Səviyyə dəyişikliyi barədə müştəriyə bildiriş göndərin',
  'Use balance payment method only for orders': 'Sifarişlər üçün ödəniş yalnız balansa əsaslanır',
  'Automatic balance replenishment': 'Avtomatik balans doldurulması',
  'Auto top-up disabled': 'Balansın avtomatik doldurulması deaktiv edilib',
  'Auto top-up enabled': 'Balansın avtomatik artırılması aktivdir',
  'Automatic data substitution templates:': 'Avtomatik məlumat əvəzetmə şablonları:',
  'Send to all clients': 'Bütün müştərilərə göndərin',
  'Sender name': 'Göndərənin adı',
  'Serial number': 'Seriya nömrəsi',
  'Serial / State number': 'Seriya / Dövlət nişanın nömrəsi',
  'Server Error': 'Server Xətası',
  'Server error': 'Server xətası',
  'Service ID': 'Xidmət ID-si',
  Operation: 'Əməliyyat',
  Commission: 'Komissiya',
  'Service mode': 'Servis rejimi',
  SM: ' SR',
  'Service enabled': 'Servis aktivdir',
  'Service is online': 'Servis işləyir',
  'Service requests': 'Sifarişlər',
  'Service request': 'Sifariş',
  'Service prices': 'Xidmətlərin qiymətləri',
  Service: 'Xidmət',
  Services: 'Xidmətlər',
  'Service 1': 'Xidmət 1',
  'Service 2': 'Xidmət 2',
  'Service 3': 'Xidmət 3',
  'Service 4': 'Xidmət 4',
  'Services in progress': 'Davam edən müraciətlər',
  'Setting up events': 'Hadisələrin qurulması',
  'Setting up the sender of email notifications': 'E-poçt bildiriş göndərəninin qurulması',
  'Setting up Telegram Gateway': 'Telegram Gateway-in qurulması',
  'Setting up Captcha': 'Captcha-nın qurulması',
  'Set a schedule': 'Cədvəl qurmaq',
  Show: 'Göstər',
  'Shopping service - for buying bonus packages, routes, season tickets, travel cards':
    'Alış-veriş xidməti - bonus paketləri, marşrutlar, keçidlər və səyahət kartları almaq üçün',
  'Short description': 'Qısa təsvir',
  'Show in mobile application': 'Mobil tətbiqdə göstər',
  'Show unit in application': 'Obyekti mobil tətbiqdə göstərin',
  'Show units in mobile application': 'Mobil tətbiqdə obyektləri göstərin',
  'show-in-application': 'Görünən',
  'Show-in-application': 'Görünən',
  'Show units only on visible map area': 'Yalnız görünən ərazidəki obyektləri göstər',
  'Show geofences': 'Geozonalar göstər',
  'Hide geofences': 'Geozonalar gizlət',
  'Show region': 'Bölgəni göstər',
  'Hide region': 'Bölgəni gizlət',
  'Only on visible map area': 'alnız görünən ərazidə',
  'Signal off': 'Səs siqnalını söndürün',
  'Signal on': 'Səs siqnalını yandırın',
  'Siren on': 'Siren səsi aktivdir',
  'Siren off': 'Siren səsi söndürülüb',
  'SIM Balance': 'SİM kart balansı',
  'Simple registration': 'Sadə qeydiyyat',
  'Signing text': 'Тİmzalama mətni',
  Simple: 'Sadə',
  'SMS Gateway': 'SMS-şluzlar',
  'Sms template must include [[code]] placeholder': 'SMS şablonunda [[code]] mətn olmalıdır',
  'SMTP Mail Host': 'SMTP poçt hostu',
  'SMTP server port': 'SMTP server portu',
  'Sorting priority': 'Çeşidləmə prioriteti',
  Sort: 'Çeşidləmə',
  Spacious: 'Geniş',
  Speed: 'Sürət',
  'Speed limit': 'Sürət limiti',
  'Speed limit command': 'Sürət limiti komandası',
  'Speed limit geofences': 'Geozonları sürət limitləri lə',
  Start: 'Başlanma',
  'Start time': 'Başlama vaxtı',
  'Start checking': 'Yoxlamağa başlayın',
  'Start of the billing period': 'Faktura dövrünün başlanğıcı',
  'Start of order': 'Sifarişin başlanğıcı',
  'Start shift': 'Növbənizə başlayın',
  State: 'Vəziyyat',
  Status: 'Status',
  'Date of blocking': 'Bloklama tarixi',
  'status-last-order-finish-time-perfect': '8 saatdan az',
  'status-last-order-finish-time-ok': '8 saatdan 16 saata qədər',
  'status-last-order-finish-time-warning': '16 saatdan 24 saata qədər',
  'status-last-order-finish-time-alarm': '24 saatdan çox',
  Step: 'Addım',
  'Steps of registration': 'Qeydiyyat mərhələləri',
  Statistic: 'Statistika',
  'Subscription fee': 'Abunə haqqı',
  Subscriptions: 'Abunəliklər',
  Subscription: 'Abunəlik',
  'Subscription status': 'Abunə statusu',
  'Such value already exists in this project': 'Bu dəyər artıq bu layihədə istifadə olunur.',
  'Sum of transactions': 'Əməliyyatların miqdarı',
  'Sum of geofences': 'Geozonların cəmi',
  'Suspicious customer': 'Şübhəli müştəri',
  'Suspicious clients': 'Şübhəli müştərilər',
  Summary: 'Cəmi',
  Supply: 'Tələb',
  Support: 'Kömək',
  Superuser: 'Super istifadəçi',
  'Support contacts': 'Texniki dəstək əlaqələri',
  'Successful transactions': 'Uğurlu əməliyyatlar',
  'Sum of all successful banking transactions for the selected period': 'Seçilmiş dövr üçün bütün uğurlu bank əməliyyatlarının cəmi',
  'Sum of all bonuses provided for the selected period': 'Seçilmiş dövr üçün verilən bütün bonusların cəmi',
  'Sum of arrears on orders and fines for the selected period': 'Seçilmiş dövr üçün ödənilməmiş sifarişlərin və cərimələrin məbləği',
  'Sum of the value of orders for the selected period': 'Seçilmiş dövr üçün sifarişlərin ümumi dəyəri',
  Target: 'Hədəf',
  'Target type': 'Hədəf növü',
  'Tariff settings': 'Tariflərin təyin edilməsi',
  Demand: 'Tələb',
  'Use this tariff only at a certain level of demand': 'Tarifdən yalnız müəyyən bir tələb səviyyəsində istifadə edin',
  'Use Google Hybrid': 'Google Hybrid istifadə et',
  'Use GoMap.Az': 'GoMap.Az istifadə et',
  'Minimum demand, percent': 'Minimum tələb, %',
  'Maximum demand, percent': 'Maksimum tələb, %',
  'Minimum demand': 'Minimum tələb',
  'Maximum demand': 'Maksimum tələb',
  Tasks: 'Tapşırıqlar',
  'Balance changing': 'Balans dəyişiklikləri',
  'Activate to provide access to the functionality of manual changing the client\'s balance.':
    'Müştərinin balansını əl ilə dəyişdirmək funksiyasına giriş təmin etmək üçün aktivləşdirin',
  'Promocode creating': 'Promo kodlarının yaradılması',
  'Select a promocode project.': 'Promo kodunun yaradıldığı layihəni seçin.',
  'Select the project country in which the promo code will be applied.': 'Promo kodunun tətbiq olunacağı layihə ölkəsini seçin.',
  'Specify the owner of the promo code.': 'Zəhmət olmasa, promo kodunun sahibini göstərin.',
  'Enter the promo code using numbers and capital letters without spaces or special characters.':
    'Promo kodunu boşluq və xüsusi simvollar olmadan rəqəmlər və böyük hərflərdən istifadə edərək daxil edin.',
  'The description of the promo code is used for administrative purposes and is not available to clients.':
    'Promo kod təsviri inzibati məqsədlər üçün istifadə olunur və müştərilər üçün əlçatan deyil.',
  'If the promo code is intended for activation in all regions of the country, select type Country. If the promo code can be activated only in certain regions of the country, to be able to specify required regions, select type Regions.':
    'Əgər promo kod ölkənin bütün bölgələrində istifadə üçün nəzərdə tutulubsa, Ölkə seçin. Əgər promo kod yalnız ölkənin müəyyən bölgələrində istifadə edilə bilərsə, tələb olunan bölgələri göstərmək üçün Regionlar seçin.',
  'If the property doesn\'t have a cable lock, select "No Lock." When selecting a mechanical lock, the lock code will be displayed in the client\'s mobile app so the client can unlock it. The lock code is set in the settings for each unit. When selecting an electromechanical lock, the client\'s mobile app will allow the lock to be opened by sending a command for N seconds. Important: When the order completion screen is reached, the command to open the lock is sent automatically. This logic is not suitable for all types of electromechanical locks.': 'Əgər obyektin troslu qıfılı yoxdursa, «Qıfıl yoxdur» tipini seçin. Mexaniki qıfıl seçildikdə, müştərinin mobil tətbiqində qıfıl kodu göstəriləcək ki, müştəri qıfılı aça bilsin. Qıfıl kodu hər bir obyektin ayarlarında təyin olunur. Elektromexaniki qıfıl seçildikdə, müştərinin mobil tətbiqi qıfılı N saniyəlik komanda göndərməklə açmağa imkan verir. Vacibdir: sifarişin tamamlanması ekranına keçildikdə, qıfılın açılması üçün komanda avtomatik göndərilir. Bu iş prinsipi bütün elektromexaniki qıfıl növlərinə uyğun olmaya bilər.',
  'If the property has a removable battery, select the "Removable Battery" type. The battery compartment lock status will be displayed in the property card. If the unit doesn\'t have a removable battery, select "Non-removable Battery."': 'Əgər obyekt çıxarıla bilən AKB ilə təchiz olunubsa, «Çıxarılan AKB» tipini seçin. Obyekt kartında AKB bölməsi qıfılının vəziyyəti göstəriləcək. Əgər obyekt çıxarıla bilən AKB ilə təchiz olunmayıbsa, «Çıxarılmayan AKB» seçin.',
  'If the hardware does not transmit the battery charge level, or the hardware transmits the value, but due to the specifics of its operation, the readings are incorrect, you can change the calculation method by specifying, for example, the voltage parameter and specifying the values of this parameter for a 0% charge level and a 100% charge level.': 'Əgər avadanlıq AKB-nin dolum səviyyəsini ötürmürsə və ya ötürür, lakin iş spesifikasına görə göstəricilər düzgün deyilsə, siz hesablamanı dəyişə bilərsiniz. Məsələn, gərginlik parametrini seçərək və bu parametr üçün 0% və 100% dolum səviyyəsinə uyğun dəyərləri göstərərək.',
  'Specify the regions in which clients can activate the promo code.': 'Müştərilərin promo kodunu aktivləşdirə biləcəyi bölgələri göstərin.',
  'Specify the language in which the news should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Müştərinin cihazının dilinə uyğun tərcümə yoxdursa, xəbərin hansı dildə göstəriləcəyini göstərin.',
  'A client can activate a promo code once. Specify the maximum number of clients who can activate promo code.':
    'Müştəri promo kodunu bir dəfə aktivləşdirə bilər. Promo kodunu aktivləşdirə biləcək maksimum müştəri sayını göstərin.',
  'Enter the promo code amount in the country\'s currency. When promo code is activated, the specified amount will be credited to the client\'s balance.':
    'Promo kod məbləğini yerli valyutada daxil edin. Aktivləşdirildikdən sonra göstərilən məbləğ müştərinin balansına köçürüləcək.',
  'Enter a name for the geofence. We recommend using geofence type name and, for example, an address, so you can quickly find the geofence in the list if needed.': 'Geozonaya ad verin. Geozona növünün adını və məsələn ünvanı göstərməyi tövsiyə edirik ki, lazım olduqda geozonanı siyahıda tez tapa biləsiniz.',
  'Specify the start date of the promo code. The promo code can\'t be activated before the start date.':
    'Zəhmət olmasa, promo kodunun etibarlılıq müddətinin başlama tarixini daxil edin. Promo kodunun aktivləşdirilməsi etibarlılıq müddətinin başlanğıcına qədər mümkün deyil.',
  'Specify the expiration date of the promo code. Promo code activation is not available after expiration date. Leave the field blank if the promo code has no expiration date.':
    'Promo kodunun bitmə tarixini göstərin. Bitmə tarixindən sonra promo kod aktivləşdirilə bilməz. Promo kod qeyri-müəyyən müddətə etibarlıdırsa, bu sahəni boş saxlayın.',
  'Specify the icon owner. The icon owner, as well as their child users with editing permissions, will be able to edit and delete the icon.': 'İkonun sahibini göstərin. İkon sahibi və redaktə icazəsi olan onun alt istifadəçiləri ikonu redaktə edə və silə biləcəklər.',
  'Specify the schedule owner. The schedule owner, as well as their child users with editing permissions, will be able to edit and delete the schedule.': 'Cədvəl sahibini göstərin. Cədvəl sahibi və redaktə icazəsi olan onun alt istifadəçiləri cədvəli redaktə edə və silə biləcəklər.',
  'Enter the sum': 'Məbləği daxil edin',
  'Activate to provide access to the functionality of creating promocodes.':
    'Promo kod yaratmaq funksiyasına giriş imkanı vermək üçün aktivləşdirin.',
  'Technical support': 'Texniki dəstək',
  'Text of push notification after registration': 'Qeydiyyatdan sonra push bildirişin mətni',
  'These condition types cannot be combined': 'Bildirişdə seçilmiş şərt növləri birləşdirilə bilməz.',
  'The name of the subscription will be displayed in the mobile application. You can use emoji for emphasis':
    'Abunə adı mobil tətbiqdə göstəriləcək. Diqqəti cəmləşdirmək üçün emojilərdən istifadə edə bilərsiniz.',
  'The subscription will be available only to the specified testers.':
    'Abunəlik yalnız təyin olunmuş test müştəriləri üçün əlçatan olacaq.',
  'The validity period of the subscription condition is specified in days. 1 day = 24 hours.':
    'Abunə müddəti günlərlə göstərilir. 1 gün = 24 saat.',
  'The condition with the minimum cost is marked to display the minimum cost of the subscription in the mobile application':
    'Minimum qiymət şərti mobil tətbiqdə abunəliyin minimum qiymətini göstərmək üçün işarələnib.',
  'The name of the tariff will be displayed in the mobile application both in the tariff preview of the tariff list and in the detailed tariff card.':
    'Tarif adı mobil tətbiqetmədə həm tarif siyahısının tarif önizləməsində, həm də ətraflı tarif kartında göstəriləcək.',
  'The country of the project in which the tariff will be presented is indicated':
    'Tarifin təqdim ediləcəyi layihə ölkəsi göstərilir ',
  'The regions in which the tariff will be presented are indicated':
    'Tarifin təqdim ediləcəyi bölgələr göstərilir ',
  'The currency in which the prices will be presented is indicated':
    'Tarif qiymətlərinin təqdim ediləcəyi valyuta göstərilir.',
  'The owner of the tariff is indicated. The owner will be given the opportunity to manage the tariff':
    'Tarif sahibi göstərilir. Sahibinə tarifi idarə etmək imkanı veriləcək.',
  'The owner of the subscription is indicated. The owner will be given the opportunity to manage the subscription':
    'Abunə sahibi göstərilir. Abunə sahibinə abunəliyi idarə etmək imkanı veriləcək.',
  'The name of the charged service is indicated, for example, Trip start, Trip, Pause, etc. The name of the service is displayed in the fare card in the mobile application':
    'Ödənişli xidmətin adı göstərilir, məsələn, Trip Start, Trip, Pause və s. Xidmətin adı mobil tətbiqdəki tarif kartında göstərilir.',
  'The price of service 1 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    '1 nömrəli xidmətin qiyməti göstərilir, məsələn, 10 qəpik, 5 qəpik/dəq, 3 AZN/saat və s.',
  'The price of service 2 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    '2 nömrəli xidmətin qiyməti göstərilir, məsələn, 10 qəpik, 5 qəpik/dəq, 3 AZN/saat və s.',
  'The price of service 3 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    '3 nömrəli xidmətin qiyməti göstərilir, məsələn, 10 qəpik, 5 qəpik/dəq, 3 AZN/saat və s.',
  'The price of service 4 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    '4 nömrəli xidmətin qiyməti göstərilir, məsələn, 10 qəpik, 5 qəpik/dəq, 3 AZN/saat və s.',
  'The cost of insurance is indicated in an arbitrary format, indicating the currency, for example, 35 rubles. In the specified form, the cost of insurance will be displayed in the mobile application.':
    'Sığorta dəyəri, valyuta, məsələn, 5 AZN formatda daxil edilir. Bu format, mobil tətbiqdə sığorta dəyərini göstərmək üçün istifadə olunacaq.',
  'The insurance description is displayed in the mobile application on a separate screen. Each paragraph is displayed with a bullet. The description must contain the sums insured':
    'Sığorta təsviri mobil tətbiqdə ayrı bir ekranda göstərilir. Hər abzas nöqtəli şəkildə göstərilir. Təsvirdə sığorta məbləği göstərilməlidir.',
  'The internal name is displayed only in the admin panel and is not available to clients in the mobile app.': 'Daxili ad yalnız administrator panelində göstərilir və mobil tətbiqdə müştərilər üçün əlçatan deyil',
  'The minimum battery charge of the object is specified, at which the tariff can be displayed in the mobile application for the object.':
    'Obyektin batareyasının minimum doldurma səviyyəsi göstərilir və tarif obyekt üçün mobil tətbiqetmədə göstərilə bilər.',
  'The name of the object will be displayed in the client interface in the object card':
    'Obyektin adı obyekt kartındakı klient interfeysində göstəriləcək',
  'The serial number or the state number depending on the selected object type is indicated. This information is only displayed in the admin panel.':
    'Seriya nömrəsi və ya dövlət qeydiyyat nömrəsi seçilmiş obyekt növündən asılı olaraq göstərilir. Bu məlumat yalnız idarəetmə panelində göstərilir.',
  'The object status depends on the availability of the object in the client application, the activity of the hardware service mode, etc. Please, pay attention that when the object is set to "Available" status, subscription fee for the object in the current month is activated. We recommend not to transfer object to the status "Accessible" before full adjustment and check of the equipment functioning!':
    'Obyektin statusu onun müştəri tətbiqində mövcudluğunu, aparat xidməti rejimində və digər amilləri müəyyən edir. Nəzərə alın ki, obyektin statusunu "Mövcuddur" olaraq dəyişdirmək cari ay üçün abunə haqqını aktivləşdirir. Avadanlıq tam konfiqurasiya edilib sınaqdan keçirilənə qədər obyektin statusunu "Mövcuddur" olaraq dəyişdirməməyi tövsiyə edirik.',
  'The integrator\'s client is considered to be the person who has placed the order for the integrator\'s unit. Client in a region is considered to be the person who has placed the order for the integrator\'s unit in a specific region.': 'İnteqratorun müştərisi inteqratorun obyektinə verilmiş sifarişə görə müəyyən edilir. Region üzrə müştəri inteqratorun həmin regionda obyektə verilmiş sifarişinə görə müəyyən edilir.',
  'The number must be greater than 0': 'Rəqəm 0-dan böyük olmalıdır',
  'The number must not be less than 0': 'Rəqəm 0-dan az ola bilməz',
  'The number must not be more than': 'Rəqəm daha çox ola bilməz',
  'Field value must be non-negative number': 'Sahə dəyəri mənfi olmayan bir rəqəm olmalıdır.',
  'The number must be an integer': 'Rəqəm tam olmalıdır',
  'The name of the organization is used in acceptance certificates and other documents. Specify the name of the organization in the format LLC "Ivanov", SE Ivanov Ivan Ivanovich.':
    'Təşkilatın adı qəbul sertifikatlarında və digər sənədlərdə istifadə olunur. Zəhmət olmasa, təşkilatın adını bu formatda daxil edin: "Mamed2025" MMC, F/Ş Məmmədov Mamed Mamed oğlu.',
  'Time interval is incorrect': 'Yanlış vaxt intervalı',
  'The first 6 digits of the card': 'Kartın ilk 6 rəqəmi',
  'The last 4 digits of the card': 'Kartın son 4 rəqəmi',
  'The subscription will be activated for the group\'s clients upon turning on the subscription by the user. Specify the expiration date of the subscription, upon which the subscription will be deactivated for group clients.':
    'Qrup müştəriləri üçün üzvlük aktivləşdirildikdə Abonement aktivləşdiriləcək. Abonement bitmə tarixini göstərin, bundan sonra qrup müştəriləri üçün abonement deaktiv ediləcək.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 16:9 for correct display.':
    'Şəkil PNG və ya JPEG formatında olmalıdır. Düzgün görüntü üçün aspekt nisbəti 16:9 olmalıdır.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 1:1 for correct display. Recommended resolution is 300px * 300px':
    'Şəkil PNG və ya JPEG formatında olmalıdır. Düzgün ekran üçün aspekt nisbəti 1:1 olmalıdır. Tövsiyə olunan qətnamə 300px * 300px-dir.',
  'The client\'s activity level is assessed daily. The assessed activity period is the last 30 days. One of 2 criteria is used for assessment: order value or order duration. When selecting the assessment criterion by order value, the amount of paid orders in the country\'s currency required to achieve the level. This takes into account payments both by balance and by bank card. When selecting the assessment criterion by order duration, the total duration of all completed orders over the last 30 days required to achieve the level.':
    'Müştəri fəaliyyət səviyyələri gündəlik qiymətləndirilir. Qiymətləndirilən fəaliyyət dövrü son 30 gündür. Qiymətləndirmə üçün iki meyardan biri istifadə olunur: sifariş dəyəri və ya sifariş müddəti.\n' +
    'Sifariş dəyərinin qiymətləndirilməsi meyarı seçilərkən, səviyyəyə çatmaq üçün tələb olunan yerli valyutada ödənilmiş sifarişlərin miqdarı göstərilir. Buraya həm balans, həm də bank kartı ödənişləri daxildir. Sifariş müddətinin qiymətləndirilməsi meyarı seçilərkən, səviyyəyə çatmaq üçün son 30 gün ərzində tamamlanmış bütün sifarişlərin ümumi müddəti göstərilir.',
  'The amount of paid orders in the country\'s currency required to achieve the level': 'Səviyyəyə çatmaq üçün tələb olunan ödənişli sifarişlərin miqdarı ölkənin valyutasında göstərilir.',
  'The total duration of all completed orders over the last 30 days required to achieve the level.':
    'Səviyyəyə çatmaq üçün tələb olunan son 30 gün ərzində bütün tamamlanmış sifarişlərin ümumi müddəti göstərilir.',
  'The hardware model name is unique within the system. Therefore, to avoid errors, it is recommended to add the project name or other unique identifying characteristics to the name. The name may only contain letters, numbers, hyphens, and underscores.': 'Avadanlıq modelinin adı sistem daxilində unikal olur. Buna görə də səhvlərin qarşısını almaq üçün ada layihənin adını və ya digər unikal identifikasiya xüsusiyyətlərini əlavə etmək tövsiyə olunur. Ad yalnız hərflər, rəqəmlər, defislər və alt xətlərdən ibarət ola bilər',
  'This subscription can have only one condition': 'Bu abunəliyin yalnız bir şərti ola bilər',
  'There are not enough funds on the balance of the personal account. The objects are hidden and are not available for rent to clients. In order to resume the service it is necessary to replenish the balance of the personal account.':
    'Hesab balansınızda kifayət qədər vəsait yoxdur. Əmlaklar gizlidir və müştərilərə icarəyə verilə bilməz. Xidməti bərpa etmək üçün hesab balansınızı artırmalısınız.',
  'There is a debt on the balance of your personal account. To avoid blocking the account, you must pay the debt before the deadline.': 'Hesabınızda ödənilməmiş məbləğ yığılıb. Hesabın dayandırılmasının qarşısını almaq üçün ödənilməmiş məbləği son tarixdən əvvəl ödəməlisiniz.',
  'There are two subtypes available for the "Finish Allowed" geofence: Simple and Bonus. "Simple" geofences are used to specify the area where the order can be completed. "Bonus" geofences are used to automatically credit bonuses to the client\'s balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': '“Finish Allowed” geozona növü üçün 2 alt növ mövcuddur: Sadə və Bonuslu. Sadə geozona sifarişin tamamlanmasına icazə verilən ərazini göstərmək üçündür. Bonuslu geozona isə səfər başa çatdıqdan sonra bonusların avtomatik olaraq müştərinin balansına köçürülməsi üçündür. Vacibdir: bonus yalnız sifariş tam ödənildikdən sonra müştərinin balansına köçürüləcək.',
  Time: 'Vaxt',
  Timezone: 'Saat qurşağı',
  'Time interval (hours)': 'Vaxt intervalı (saatlar)',
  'Time of closing': 'Bağlanma vaxtı',
  'Time of operation': 'Əməliyyat müddəti',
  'Time period': 'Zaman müddəti',
  'The time allocated for verification is coming to an end. To reset the timer and continue checking documents, enter the password again.':
    'Doğrulama üçün ayrılmış vaxt bitmək üzrədir. Taymeri sıfırlamaq və sənəd yoxlamasına davam etmək üçün şifrənizi yenidən daxil edin.',
  'Title image': 'Başlıq şəkli',
  Today: 'Bu gün',
  'Toggle fullscreen': 'Tam ekran rejimini aktivləşdirin',
  Total: 'Cəmi',
  'Total mileage': 'Ümumi yürüş',
  'Total cost (orders)': 'Ümumi xərc (sifarişlər)',
  'Total distance': 'Ümumi yürüş',
  'Total duration': 'Ümumi müddət',
  'Total order count': 'Ümumi sifarişlər',
  'Total price': 'Ümumi qiymət',
  'Total price (orders)': 'Ümumi qiymət (sifarişlər)',
  'Total successful order duration': 'Uğurlu sifarişlərin müddəti',
  'to change the payment terms in the current billing period upon saving the changes, as well as to recalculate the data from the beginning of the billing period to the moment of making changes.':
    'Dəyişiklikləri yadda saxladıqdan sonra cari ödəniş dövründə ödəniş şərtlərində dəyişiklik etmək və həmçinin ödəniş dövrünün əvvəlindən dəyişikliklərin edildiyi ana qədər məlumatları yenidən hesablamaq.',
  'To be able to configure telegram alerts for the notifications created in the system, specify the API key of the telegram bot.':
    'Sistemdə yaradılan bildirişlər üçün Telegram bildirişlərini konfiqurasiya etmək üçün Telegram botunun API açarını göstərin.',
  'To gain access to the extended registration document check, you must enter the moderator\'s password. Access will be available for 9 hours from the moment of entering the password. After the time expires, you must re-enter the password to continue the verification.':
    'Qabaqcıl qeydiyyat sənədinin yoxlanılması prosesinə daxil olmaq üçün moderator şifrəni daxil etməlisiniz. Giriş şifrəni daxil edildiyi andan etibarən doqquz saat ərzində veriləcək. Bu müddətdən sonra yoxlamaya davam etmək üçün şifrəni yenidən daxil etməlisiniz.',
  'To have access to check advanced registration documents, user have to enter the moderator password.':
    'Genişləndirilmiş qeydiyyat sənədlərini yoxlamaq üçün istifadəçi moderator şifrəni daxil etməlidir.',
  'To highlight the news on the main screen you can add a icon in SVG format measuring 24 x 24 pixels. Adding an icon is not required. You can highlight the news by using emoji in the title.':
    'Ana ekranda xəbər hekayəsini vurğulamaq üçün 24 x 24 piksel ölçülü SVG işarəsi əlavə edə bilərsiniz. İşarə əlavə etmək istəyə bağlıdır. Başlıqdakı emojidən istifadə edərək xəbər hekayəsini vurğulaya bilərsiniz.',
  'To automatically populate client, organization, and/or facility information in a document, use the following templates. To quickly copy a template, click it once.': 'Sənəddə müştəri, təşkilat və/və ya obyekt məlumatlarının avtomatik doldurulması üçün aşağıdakı şablonlardan istifadə edin. Şablonu tez bir zamanda kopyalamaq üçün üzərinə bir dəfə klikləyin.',
  Trailers: 'Qoşqular',
  Trailer: 'Qoşqu',
  'Trailer price': 'Qoşqu qiyməti',
  'Track time': 'Trek vaxtı',
  Tracker: 'GPS',
  'Tracker price': 'GPS qiyməti',
  'Tracker charge': 'GPS batareyası',
  Trackers: 'GPS-lər',
  'IoT modules': 'IoT-modullar',
  'Mechanical bicycles': 'Mexaniki velosipedlər',
  'Electric bicycles (without IoT)': 'Elektrikli velosipedlər (IoT olmadan)',
  'Electric bicycles (with IoT)': 'Elektrikli velosipedlər (IoT ilə)',
  'Snow scooters': 'Elektrikli qar skuterləri',
  Trikes: 'Trayklar',
  'Tracker connection': 'GPS qoşulması',
  'Battery connection': 'Batareyanin qoşulması',
  'Monitoring module': 'Monitorinq modulu',
  'Transaction was successfully canceled': 'Əməliyyat uğurla ləğv edildi',
  Transactions: 'Əməliyyatlar',
  'Transactions by bank cards': 'Bank kartı əməliyyatları',
  'Transaction amount': 'Əməliyyat məbləği',
  'Transaction status': 'Əməliyyat statusu',
  'Receipt status': 'Çekin statusu',
  'Translation of push notification after registration': 'Qeydiyyatdan sonra push bildirişlərinin tərcüməsi',
  Translations: 'Tərcümələr',
  'Translate into other languages': 'Başqa dillərə tərcümə et',
  Transmission: 'Sürət qutusu',
  'Transferred for temporary use': 'Müvəqqəti istifadə üçün verilib',
  'Transfer to access': 'Girişə köçürmə',
  'Translation language': 'Tərcümə dili',
  Tricycle: 'Trisikl',
  'Tricycle price': 'Trisikl qiyməti',
  Tricycles: 'Trisikllar',
  'Trigger conditions': 'Tetikleyici şərtlər',
  Trips: 'Səfərlər',
  Trip: 'Səfər',
  Type: 'Növü',
  Subtype: 'Alt növ',
  'Type of allocation': 'Yerləşmə növü',
  'Type of transport': 'Nəqliyyat növü',
  'Type of geofence': 'Geozona növü',
  'Unblock device': 'Cihazın kilidini açın',
  'Unblock engine': 'Mühərriki kilidini açın',
  'Unique name': 'Unikal ad',
  Unit: 'Obyekt',
  'Unit address': 'Obyektin ünvanı',
  'Unit coord': 'Obyektin koordinatları',
  Hardware: 'Avadanlıq',
  'Unit billing type': 'Obyekt üçün ödəniş növü',
  'Unit commands': 'Komandalar',
  'Unit images': 'Obyektin şəkilləri',
  'Unit notification log': 'Obyekt jurnalı',
  'Unit notifications settings': 'Obyektlər üçün bildirişlərin qurulması',
  'Unit state': 'Obyekt vəziyyəti',
  'Unit status change': 'Obyektin statusunun dəyişdirilməsi',
  'Unit status': 'Obyekt statusu',
  'Unit type': 'Obyekt növü',
  'Unit replacement': 'Obyektin əvəz olunması',
  Units: 'Obyektlər',
  units: 'obyekt',
  'Units offline': 'Oflayn rejimdə olan obyektlər',
  'Unit count': 'Obyektlərin sayı',
  'Unit location': 'Obyektin yerləşməsi',
  'Unique identifier': 'Unikal identifikator',
  'Until the next maintenance, km': 'Növbəti texniki baxişa qədər, km',
  Unlimited: 'Limitsiz',
  unlimited: 'limitsiz',
  'Unknown server error': 'Naməlum server xətası',
  'Upper bound of the interval': 'İntervalın yuxarı həddi',
  User: 'İstifadəçi',
  Username: 'İstifadəçi adı',
  'User blocked': 'Bloklandı',
  'User login': 'İstifadəçinin adı',
  'User role': 'İstifadəçinin rolları',
  'Custom roles': 'Xüsusi Rollar',
  'Custom role': 'Xüsusi Rol',
  'Select custom role': 'Xüsusi rol seçin',
  'Type of role': 'Rol Növü',
  'Select type of role': 'Rol növünü seçin',
  'Base role': 'Əsas Rol',
  'Select base role': 'Əsas rol seçin',
  'Automatically enable new features from future releases': 'Gələcək buraxılışlardan yeni funksiyaları avtomatik olaraq daxil edin',
  'User activity log': 'İstifadəçi fəaliyyət qeydi',
  'Use by default': 'Varsayılan olaraq istifadə edin',
  Users: 'İstifadəçilər',
  Usual: 'Sadə',
  'Valid from': 'Etibarlıdır',
  'Valid to': 'Etibarlıdır',
  'Valid until': 'Qüvvədədir',
  'Validation error': 'Doğrulama xətası',
  'Validation error - do you have order? Or order already finished?': 'Doğrulama xətası - sifarişiniz varmı? Yoxsa sifariş artıq tamamlanıb??',
  Value: 'Dəyər',
  'Value in coins': 'Coin dəyər',
  'Value is too small': 'Dəyər çox kiçikdir',
  'Invalid characters in promo code': 'Promo kodda yanlış simvollar',
  'Invalid characters in registration number': 'Qeydiyyat nömrəsindəki simvollar yanlışdır',
  'Invalid coordinate filtering settings': 'Etibarsız koordinatların filtrasiya ayarları',
  'Please add insurance to price plan': 'Zəhmət olmasa, sığortanı qiymətinizə əlavə edin.',
  'Please configure insurance only once': 'Zəhmət olmasa, sığortanı yalnız bir dəfə təyin edin.',
  'Please note that this functionality is intended exclusively for the courier business model. When leaving the speed limit geofence, the speed limit disable command set for the hardware model will be sent to the devices, unless a different command is specified in the location region settings for that hardware model.': 'Nəzərinizə çatdırırıq ki, bu funksionallıq yalnız kuryer biznes modeli üçün nəzərdə tutulub. Sürət məhdudiyyəti geozonasından çıxarkən, avadanlıq modeli üçün təyin edilmiş sürət məhdudiyyətinin deaktivasiya komandası cihazlara göndəriləcək, əgər obyektin yerləşdiyi regionun ayarlarında həmin avadanlıq modeli üçün başqa komanda göstərilməyibsə.',
  'Invalid insurance amount; valid amount is:': 'Göstərilən sığorta qiyməti səhvdir; düzgün qiymət:',
  'Indicate country and city of birth': 'Zəhmət olmasa, doğulduğunuz ölkəni və şəhəri göstərin.',
  Videos: 'Video faylları',
  'Video link': 'Videoya keçid',
  View: 'Baxış',
  'View Profile': 'Profili göstər',
  'View unit': 'Obyekt göstər',
  Viewed: 'Baxılıb',
  'Warehouse number': 'Anbar nömrəsi',
  'Wait polygon': 'Geozon gözlənilir',
  'Waiting time': 'Gözləmə müddəti',
  Week: 'Həftə',
  'Weak signal': 'Zəif siqnal',
  'We recommend using no more than 35 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Başlığın müxtəlif mobil cihazlarda düzgün görünməsini təmin etmək üçün boşluqlar da daxil olmaqla 35 simvoldan çox istifadə etməməyi tövsiyə edirik.',
  'We recommend using no more than 90 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Qısa təsvirin müxtəlif mobil cihazlarda düzgün görünməsini təmin etmək üçün boşluqlar da daxil olmaqla 90 simvoldan çox istifadə etməməyi tövsiyə edirik.',
  'Write the main content of the news': 'Xəbərin əsas hissəsini yazın',
  'Write a brief description. If a schedule is set for the geofence, we recommend including the geofence\'s operating hours in the description. If you\'re creating a speed limit geofence, also include the maximum speed limit.': 'Qısa təsvir yazın. Geozona üçün cədvəl təyin edilibsə, təsvirə geozonanın iş saatlarını daxil etməyi tövsiyə edirik. Əgər sürət məhdudiyyəti geozonası yaradırsınızsa, maksimal sürət həddini də göstərin.',
  'Write a brief description. If the geopoint matches the geofence logic, we recommend duplicating the information from the geofence logic description.': 'Qısa təsvir yazın. Əgər geopoint geozona məntiqinə uyğundursa, geozona məntiqi təsvirindəki məlumatı təkrarlamağı tövsiyə edirik.',
  Width: 'Eni',
  'Width(mm)': 'Eni(mm)',
  Yesterday: 'Dünən',
  admin: 'admin',
  booked: 'rezervasiyada',
  'color not set': 'rəng təyin edilməyib',
  free: 'boş',
  Free: 'Boş',
  gsm: 'GSM',
  'hw_id already exists': 'HW ID artıq sistemdədir',
  integrator: 'inteqrator',
  more: 'aha ətraflı',
  More: 'Aha ətraflı',
  'no address': 'ünvan göstərilməyib',
  'No new clients awaiting confirmation': 'Təsdiq gözləyən yeni müştəri yoxdur.',
  'not booked': 'rezervasiya olunmayıb',
  'not set': 'təyin olunmayıb',
  'Not found': 'Tapılmadı',
  'Normal signal': 'Normal siqnal',
  'No customer data': 'Müştəri məlumatları yoxdur',
  'No data': 'Məlumat yoxdur',
  role: 'rol',
  Images: 'Şəkillər',
  'Image size 300x300, in formats .png, .jpg, .jpeg, .svg.': 'Şəkil ölçüsü: 300x300, .png, .jpg, .jpeg, .svg formatlarında',
  'Payment methods': 'Ödəniş üsulları',
  Payment: 'Ödəniş',
  Selected: 'Seçilib',
  Selection: 'Seçim',
  Select: 'Seçmək',
  'Select date': 'Tarix seçin',
  'Select battery': 'Batareyanı seçin',
  'Freeze coordinates': 'Obyektin koordinatlarını kilidlə',
  'Activate if necessary to freeze coordinates of unit at a certain point. The coordinate input field and unit location on the map will appear after activation.' :
    'Müəyyən bir nöqtədə bir obyektin koordinatlarını kilidləmək lazımdırsa, bu funksiyanı aktivləşdirin. Aktivləşdirildikdən sonra xəritədə koordinat giriş sahəsi və obyektin yeri görünəcək.',
  'After reaching the level, upon successful payment and order finishing, the client will be awarded a reward in the form of cashback at a specified percentage of the order value. The specified reward will be credited to the client until the client\'s activity level changes.':
    'Müəyyən bir səviyyəyə çatdıqdan sonra, sifarişləri tamamladıqdan və uğurla ödədikdən sonra müştəri sifariş dəyərinin müəyyən edilmiş faizinə bərabər olan keşbek mükafatı alacaq. Bu mükafat müştərinin aktivlik səviyyəsi dəyişənə qədər toplanmağa davam edəcək.',
  'Select contact type': 'Əlaqə növünü seçin',
  'Select trackers': 'GPS-ləri seçin',
  'Select service type': 'Xidmət seçin',
  'Select source': 'Mənbə seçin',
  'Select calculation method': 'Bir metod seçin',
  'Select billing model': 'Ödəniş üsulunu seçin',
  'Select the track building period': 'Yolun tikinti dövrünü seçin',
  'Select destination type': 'Təyinat növünü seçin',
  'Select document format': 'Sənəd formatını seçin',
  'Select type': 'Növü seçin',
  'Select fare type': 'Tarif növünü seçin',
  'Select user': 'İstifadəçi seçin',
  'Select object models': 'Obyekt modellərini seçin',
  'Select objects': 'Obyektləri seçin',
  'Select owner': 'Sahibi seçin',
  'Select one option': 'Bir variant seçin',
  'Select currency': 'Valyuta seçin',
  'Select one default condition': 'Bir standart şərt seçin',
  'Select testers': 'Testçiləri seçin',
  'Select subscription type': 'Abunəlik növü seçin',
  'Select regions': 'Regionları seçin',
  'Select region': 'Region seçin',
  'Select price plans': 'Tarifləri seçin',
  'Select price plan': 'Tarif seçin',
  'Select operating mode': 'İş rejimini seçin',
  'Select test clients': 'Test müştərilərini seçin',
  'Select translation language': 'Tərcümə dilini seçin',
  'Select language': 'Dil- seçin',
  'Select license categories': 'Hüquq kateqoriyalarını seçin',
  'Select unit type': 'Obyekt növünü seçin',
  'Select unit types': 'Obyekt növlərini seçin',
  'Select a project': 'Layihə seçin',
  'Select a country': 'Ölkə seçin',
  'Select a period': 'Dövrü seçin',
  'Select period': 'Dövrü seçin',
  'Select an event': 'Hadisə seçin',
  'Select actions': 'Əməliyyatlar seçin',
  'Select action': 'Əməliyyat seçin',
  'Select state': 'Vəziyyət seçin',
  'Select a command pattern': 'Komanda şablonu seçin',
  'Select a condition': 'Şərt seçin',
  'Select a role': 'Rol seçin',
  'Select a technician': 'Texniki seçin',
  'Select a speed limit': 'Sürət məhdudiyyətini seçin',
  'Select section': 'Bölmə seçin',
  'Select group': 'Qrup seçin',
  'Select groups': 'Qrupları seçin',
  'Select geofences': 'Geozonaları seçin',
  'Select clients': 'Müştəriləri seçin',
  'Select level': 'Səviyyə seçin',
  'Select hw type': 'Avadanlıq növünü seçin',
  'Select lock type': 'Qıfıl növünü seçin',
  'Select battery placement type': 'AKB yerləşdirmə növünü seçin',
  'Select command': 'Əmri seçin',
  'Select the objects for which the tariff will be available':
    'Tarifin mövcud olacağı obyektləri seçin',
  'Select a model': 'Model seçin',
  'Select the group of clients for whom you want to activate the subscription':
    'Abunəliyi aktivləşdirmək istədiyiniz müştərilər qrupunu seçin',
  'Select price plans available within the subscription': 'Abunəlik daxilində mövcud olan qiymətləri seçin',
  'Select the language for which the subscription information translation will be added':
    'Tərcümə olunmuş abunə məlumatlarının əlavə ediləcəyi dili seçin.',
  'Select the language for which the price plan information translation will be added':
    'Tarif məlumatlarının tərcüməsinin əlavə ediləcəyi dili seçin',
  'Select the region in which the subscription will be valid. If more than one region is selected, the client will be able to use the subscription in all specified regions.':
    'Abunəlik olacağı bölgəni seçin. Birdən çox bölgə seçilərsə, müştəri göstərilən bütün bölgələrdə abonement istifadə edə biləcək.',
  'Subscription type': 'Abunəlik növü',
  'Select the type of object for which this subscription will be valid':
    'Bu abunəliyin etibarlı olacağı obyekt növünü seçin',
  'Create subscription': 'Abunəlik yaratmaq',
  'Create fare': 'Tarif planının yaradılması',
  'Select the project that will apply this requirement':
    'Bu abunəliyin etibarlı olacağı layihəni seçin',
  'Select the project in which notifications will be sent': 'Bildirişlərin göndəriləcəyi layihəni seçin.',
  'Select the country in which notifications will be sent': 'Bildirişlərin göndəriləcəyi ölkəni seçin.',
  'Select the integrator whose clients will receive notifications': 'Bildirişlərin göndəriləcəyi müştəriləri olan inteqratoru seçin.',
  'Select the region in which notifications will be sent': 'Bildirişlərin göndəriləcəyi regionu seçin.',
  'Select the country in the project in which this subscription will be valid':
    'Layihədə bu abunəliyin etibarlı olacağı ölkəni seçin',
  'Select the color to get the color code that you will later use in the client interface functionality.':
    'Daha sonra müştəri interfeysi funksionallığında istifadə ediləcək rəng kodunu əldə etmək üçün bir rəng seçin.',
  'Select a role. (Administrator or Integrator)': 'Rol seçin (Administrator və ya İnteqrator)',
  'Select a schedule from the list of schedules you have previously created.': 'Əvvəl yaratdığınız cədvəllər siyahısından bir cədvəl seçin.',
  'Select the action you intend to take with respect to the user\'s payment terms:':
    'İstifadəçinin ödəniş şərtləri ilə bağlı görmək istədiyiniz hərəkəti seçin:',
  'Select connection method': 'Bağlantı metodu seçin',
  'Select the battery registration status in the system': 'Sistemdə batareya qeydiyyat statusunu seçin',
  'Select the status of the registration status in the system': 'Sistemdə qeydiyyat statusunuzu seçin',
  'Select the unit to which the tracker connects.': 'GPS qoşulduğu obyekti seçin.',
  'Select the removable battery that the tracker is connected to.': 'GPS qoşulduğu obyekti seçin.',
  'Select the project where group of clients is created.': 'Müştəri qrupunun yaradıldığı layihəni seçin.',
  'Select the country of the project where group of clients is created.': 'Müştəri qrupunun yaradıldığı layihə ölkəsini seçin.',
  'Select the region where group of clients is created.': 'Müştəri qrupunun yaradıldığı bölgəni seçin.',
  'Select the owner of group of clients.': 'Müştəri qrupunun sahibini seçin.',
  'Select the clients you want to assign to the group.': 'Qrupa təyin etmək istədiyiniz müştəriləri seçin.',
  'Select the group of clients for whom you want to activate the subscription.': 'Abunəliyi aktivləşdirmək istədiyiniz müştərilər qrupunu seçin.',
  'Select the type of movement': 'Hərəkət növünü seçin',
  'Select the project for the component type you are creating': 'Komponent tipinin yaradıldığı layihəni seçin',
  'Select the hardware model for which the speed limit command is being added': 'Sürət məhdudiyyəti əmri əlavə olunan avadanlıq modelini seçin',
  'Select the speed limit command according to the selected hardware model': 'Seçilmiş avadanlıq modelinə uyğun sürət məhdudiyyəti əmrlərini seçin',
  'Select the business-model for the geofence you are creating': 'Yaradılan geozona üçün biznes modelini seçin',
  'Select employment type': 'Məşğulluq növünü seçin',
  'Select couriers': 'Kuryerləri seçin',
  'Select a courier': 'Kuryer seçin',
  'Courier identification': 'Kuryer şəxsiyyəti',
  'Select courier identification': 'Kuryer identifikasiyası metodunu seçin',
  'External id of the courier': 'Xarici kuryer ID-si',
  'Select an assignment method': 'Randevu metodunu seçin',
  'Select form type': 'Forma növünü seçin',
  'Select document type': 'Sənəd növünü seçin',
  'Select the document addition method': 'Sənədin əlavə edilməsi metodunu seçin',
  'Select enrollment form': 'Qeydiyyat formasını seçin',
  'Select registration form': 'Qeydiyyat formasını seçin',
  'Select the country code': 'Ölkə kodunu seçin',
  'Select authentication method': 'Doğrulama metodu seçin',
  'Select a bag': 'Çantanı seçin',
  'Select a time zone': 'Saat qurşağı seçin',
  'Select the project for the news item you are creating': 'Xəbərin yaradıldığı layihəni seçin',
  'Select the country for the news item you are creating': 'ВXəbərin yaradıldığı ölkəni seçin',
  'Select criterion': 'Bir meyar seçin',
  'Select the project for the client\'s activity level you are creating':
    'Müştəri fəaliyyət səviyyəsinin yaradıldığı layihəni seçin',
  'Select the translation language of the client\'s activity level name':
    'Müştəri fəaliyyət səviyyəsi adının tərcüməsinin əlavə ediləcəyi dili seçin',
  'Select the project for the conditions you are creating':
    'Müştəri fəaliyyət səviyyəsinə çatmaq üçün şərtlər əlavə etdiyiniz layihəni seçin',
  'Select the country for the conditions you are creating':
    'Müştəri fəaliyyət səviyyəsinə çatmaq üçün şərtlərin əlavə olunduğu ölkəni seçin',
  'Select the business model for the conditions you are creating':
    'Müştəri fəaliyyət səviyyəsinə çatmaq üçün şərtlər əlavə etdiyiniz biznes modelini seçin',
  'Select the client activity level for the achievement conditions you are creating':
    'Nailiyyət şərtlərinin əlavə olunduğu müştəri fəaliyyət səviyyəsini seçin',
  'Select the project for the component model you are creating': 'Komponent modelinin yaradıldığı layihəni seçin',
  'Select the project for the branch you are creating': 'Filialın yaradıldığı layihəni seçin',
  'Select the country for the branch you are creating': 'Filialın yaradıldığı ölkəni seçin',
  'Select the project for the Legal Entity you are creating': 'Hüquqi şəxsin yaradıldığı layihəni seçin',
  'Select the country for the Legal Entity you are creating': 'Hüquqi şəxsin yaradıldığı ölkəni seçin',
  'Select the hardware type that matches your device. The port the device should be pointed to is shown in brackets. If you can\'t find the right hardware type or need any other assistance setting up your device connection, please contact technical support.': 'Cihazınıza uyğun avadanlıq növünü seçin. Mötərizədə cihazın yönləndirilməli olduğu port göstərilir. Əgər uyğun avadanlıq növünü tapa bilmirsinizsə və ya cihazınızın qoşulmasını qurmaqda başqa bir köməyə ehtiyacınız varsa, texniki dəstək xidməti ilə əlaqə saxlayın.',
  'Select owner of the Legal Entity you are creating': 'Hüquqi şəxsin sahibini seçin',
  'Select owner of the branch you are creating': 'Filial sahibini seçin',
  'Select unit type for the hardware model you are creating': 'Avadanlıq modeli üçün yaradılan obyekt növünü seçin',
  'Select the speed limit disable command': 'Sürət məhdudiyyətini söndürmə əmrlərini seçin',
  'Select the days of the week for your schedule': 'Cədvəlin iş günlərini seçin.',
  'Select region of the branch you are creating': 'Filialın yaradıldığı bölgəni seçin',
  'Specify group name. For example, LLC Delivery3000.': 'Zəhmət olmasa, müştəri qrupunuzun adını daxil edin. Məsələn, "Kuryer 3000" MMC.',
  'Enter custom group name description.': 'Müştəri qrupunuz üçün xüsusi bir təsvir daxil edin.',
  'Subscription period already selected': 'Seçilmiş abunəlik müddəti artıq əlavə edilib.',
  'Subscription terms': 'Abunə şərtləri',
  'Subscription price is indicated for each validity period': 'Abunə qiyməti hər etibarlılıq müddəti üçün göstərilir.',
  'subscription-fee-amount-value': 'Qiymət',
  'Subscription purchases': 'Abunəliyin alınması',
  Number: 'Nömrə',
  News: 'Xəbərlər',
  'Number of trips': 'Səfərlərin sayı',
  'Number of trips (-1 - Unlimited)': 'Səfərlərin sayı (-1 - Limitsiz)',
  'Add date': 'Əlavə etmə tarixi',
  'No bank cards': 'Bank kartları yoxdur',
  'Not issued': 'Qeydiyyatdan keçməyib',
  'Clone hardware model': 'Avadanlıq modelini kopyalayın',
  'Clone price plan': 'Tarif planını kopyalayın',
  'Clone subscription': 'Abunəliyi kopyalayın',
  Active: 'Aktiv',
  'active-orders': 'Aktiv',
  Disabled: 'Aktiv deil',
  'Ride allow': 'Sürmək olar',
  'Ride restrict': 'Sürmək qadağandır',
  'Finish allow': 'Bitməyə icazə verilir',
  'Finish restrict': 'Bitməyə qadağandır',
  'Riding allowed': 'Sürmək icazə verilir',
  'Riding prohibited': 'Sürmək qadağandır',
  'Right to edit': 'Redaktə etmək hüququ',
  'Parking allowed': 'Parkinqə icazə verilir',
  'Parking prohibited': 'Parkinq qadağandır',
  'Geofences and geopoints': 'Geozonlar və POİ',
  'Age limit': 'Yaş həddi',
  'Has mechanical lock code': 'Mexaniki kilid kodu göstərilir',
  'Hasn\'t mechanical lock code': 'Mexaniki kilid kodu göstərilməyib.',
  'Mechanical lock status': 'Mexaniki kilid statusu',
  'Hasn\'t mechanical lock': 'Mexaniki kilidi yoxdur',
  'Steering wheel': 'Sükan',
  Accelerator: 'Qaz',
  Brake: 'Əyləc',
  Wheels: 'Təkərlər',
  'When copying a tariff, you must specify which type of tariff the new one will belong to. In case of creating an analogue of the basic tariff to provide it within the framework of the subscription, select "Subscription". Otherwise - select "Basic"':
    'Tarifi kopyalayarkən, yenisi üçün tarif növünü göstərməlisiniz. Abunəliklə istifadə üçün əsas tarif yaradırsınızsa, "Abunə" seçin. Əks halda, "Əsas" seçin.',
  'When you select the Activation for a group of clients destination of the subscription, in the appeared field you\'ll need to select a group of clients for whom the subscription will be automatically activated upon turning on the subscription by the user. When you select the Purchase by client destination of the subscription, it will be available for purchase to all clients in the specified region.':
    '"Müştəri qrupu üçün aktivləşdirmə" abunə seçimini seçərkən, istifadəçi abunəliyi aktivləşdirdikdən sonra abunəliyin avtomatik olaraq aktivləşdiriləcəyi müştəri qrupunu seçmək üçün bir sahə görünəcək. "Müştəri tərəfindən satın alma" abunə seçimini seçərkən, abunəlik göstərilən bölgədəki bütün müştərilər üçün əlçatan olacaq.',
  'When creating an IoT module, its registration number is generated automatically based on the prefix of the hardware manufacturer specified in the hardware model and the numerical part specified in the corresponding field of the IoT module creation form.': 'IoT modulunu yaradarkən, onun qeydiyyat nömrəsi avadanlıq modelində göstərilən istehsalçı prefiksi və IoT modulunun yaradılması formasında göstərilən rəqəm hissəsi əsasında avtomatik olaraq yaradılır.',
  'When choosing a fixed amount, the client will receive the specified amount upon completion of the trip, regardless of the order cost. With cashback, the customer will receive a specified percentage of the order cost. Important: If the fare already specifies a cashback percentage, the bonuses will not be combined. The system will automatically select the percentage in favor of the client.balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': 'Sabit məbləğ seçildikdə, səfər başa çatdıqdan sonra sifarişin dəyərindən asılı olmayaraq müştəriyə göstərilən məbləğ köçürüləcək. Keşbek olduqda isə müştəriyə sifariş dəyərinin göstərilən faizi köçürüləcək. Vacibdir: tarifdə artıq keşbek faizi göstərilibsə, bonuslar cəmlənmir. Faiz dəyərini sistem avtomatik olaraq müştərinin xeyrinə seçəcək.',
  Footboard: 'Ayaqaltı',
  Rack: 'Rama',
  Battery: 'Batareya',
  'Basic data': 'Əsas məlumatlar',
  'Basic rates': 'Əsas tariflər',
  Basic: 'Əsas',
  'Basic price plans': 'Əsas tariflər',
  Other: 'Digər',
  'Operating mode': 'İş saatları',
  'Operation details': 'Əməliyyat detalları',
  'Operation history': 'Əməliyyatın tarixi',
  'Operating system and version': 'Əməliyyat sistemi və onun versiyası',
  'Broke parts': 'Sınıq hissələr',
  'Public ID': 'Publik ID',
  'Charge start/finish': 'Şarjın başlanğıcı/sonu',
  Booked: 'Rezervasiyada',
  Pause: 'Fasilə',
  km: 'km',
  odometer: 'odometr',
  'by coordinates': 'koordinat əsasən',
  'by odometer': 'odometr əsasən',
  'km ago': 'km əvvəl',
  'km/h': 'km/s',
  'Total cost': 'Ümumi xərc',
  Fine: 'Cərimə',
  Fines: 'Cərimələr',
  'Issue a fine': 'Cərimə tətbiq edin',
  'Order history': 'Sifariş tarixçəsi',
  'Order photos': 'Sifarişin şəkilləri',
  Copy: 'Kopyalayın',
  Copying: 'Kopyalanma',
  Combat: 'Döyüş',
  day: 'gün',
  minute: 'dəqiqə',
  hour: 'saat',
  hours: 'saat',
  hour_: 'saat',
  'Holding error': 'Tutma xətası',
  Pay: 'Ödəniş',
  'Pay debt': 'Borcu ödəyin',
  'Pay using CloudPayments': 'CloudPayments vasitəsilə ödəniş',
  'Not paid': 'Ödənilməyib',
  Paid: 'Ödənilib',
  'Paid up': 'Ödənilib',
  'Number Prefix': 'Nömrə prefiksi',
  'Vendor prefix': 'İstehsalçı prefiksi',
  'Account ID': 'Hesab',
  Success: 'Uğurlu',
  'Order successfully paid': 'Sifariş uğurla ödənilib.',
  Enabled: 'Aktiv',
  'Entity address': 'Hüquqi ünvan',
  'Entity phone': 'Hüquqi telefon',
  'Entity settlement account': 'Cari hesab',
  'Type of entity': 'Təşkilat növü',
  Test: 'Test',
  Testers: 'Testçilər',
  'Test GPRS/Test connection': 'GPRS Testi/Bağlantı Testi',
  'Connected to server': 'Serverə qoşulub',
  'Enable unit grouping': 'Obyekt qruplaşdırmasını aktivləşdir',
  'Disable unit grouping': 'Obyekt qruplaşdırmasını deaktiv et',
  Low: 'Zəif',
  Medium: 'Orta',
  High: 'Yüksək',
  'Without broken parts': 'Sınıq hissələr yoxdur',
  'Please wait': 'Zəhmət olmasa gözləyin',
  'No messages found': 'Mesaj tapılmadı',
  MIR: 'MİR',
  'Unit registration number': 'Obyektin qeydiyyat nömrəsi',
  Headline: 'Başlıq',
  'Units visibility': 'Obyektlərin görünməsi',
  'Head: no information': 'Baş: məlumat yoxdur',
  'Head: is on': 'Baş: Açıq',
  'Head: is off': 'Baş: Söndürülüb',
  'Heat map': 'İstilik xəritəsi',
  'Brake: no information': 'Əyləclər: məlumat yoxdur',
  'Brake: OFF': 'Əyləc: OFF',
  'Brake: ON': 'Əyləc: ON',
  'Speed mode: drive': 'Sürət rejimi: drive',
  'Speed mode: eco': 'Sürət rejimi: eco',
  'Speed mode: speed': 'Sürət rejimi: speed',
  'Speed mode: no information': 'Sürət həddi: məlumat yoxdur',
  'Specify the priority': 'Üstünlüyü göstərin',
  'Specify the reason': 'Səbəb göstərin',
  'Specify purpose': 'Təyinatı göstərinя',
  'Specify the region boundaries': 'Regionun sərhədlərini göstərin',
  'Specify the geopoint location': 'Geonöqtənin yerləşməsini göstərin',
  'Specify the geofence boundaries': 'Geozonanın sərhədlərini göstərin',
  'Specify validity period': 'Qüvvədə olma müddətini göstərin',
  'Specifies the maximum battery charge of the object, at which the tariff can be displayed in the mobile application for the object.':
    'Obyektin batareyasının maksimum doldurma səviyyəsi göstərilir və tarif obyekt üçün mobil tətbiqetmədə göstərilə bilər.',
  'Specify object models for which the tariff will be available.':
    'Tarifin mövcud olacağı obyektlərin modellərini göstərin.',
  'Specifies the user-owner of the objects for which the tariff will be available':
    'Tarifin mövcud olacağı obyektlərə sahib olan istifadəçi göstərilir',
  'Specify the cost': 'Qiyməti göstərin',
  'Specify an increasing cycle time': 'Ümumi icarə müddətini göstərin.',
  'Specifies the total duration of the lease in minutes. It is from this value that the travel time will be deducted.':
    'Ümumi icarə müddəti dəqiqələrlə göstərilir. Bu dəyər səyahət müddətini hesablamaq üçün istifadə olunacaq.',
  'Specify the days of the week on which this tariff will be available. You can select all days of the week, weekdays weekends, or a specific day of the week.':
    'Bu planın həftənin hansı günlərində mövcud olacağını göstərin. Həftənin bütün günlərini, iş günlərini, həftəsonlarını və ya həftənin müəyyən bir gününü seçə bilərsiniz.',
  'Specify the project in which the object will work':
    'Obyektin işləyəcəyi layihəni göstərin',
  'Specify the service delivery region for the object. As long as the object\'s service delivery region does not match the object\'s current location, the region name will be outlined in red.':
    'Bu əmlak üçün xidmət bölgəsini göstərin. Əmlak üçün xidmət bölgəsi əmlakın cari yeri ilə uyğun gələnə qədər bölgənin adı qırmızı rənglə qeyd olunacaq.',
  'Specify the object model. The object model is displayed in the client interface in the object card. Depending on the selected model, the functionality may differ.':
    'Obyekt modelini göstərin. Obyekt modeli obyekt kartındakı klient interfeysində göstərilir. Funksionallıq seçilmiş modeldən asılı olaraq dəyişə bilər.',
  'Service mode: is on': 'Xidmət rejimi: aktivdir',
  'Specify the daily time interval during which the tariff will be available for the selected day of the week.':
    'Həftənin seçilmiş günü üçün tarifin mövcud olacağı gündəlik vaxt intervalını göstərin.',
  'Specify mileage': 'Yürüşü göstərin',
  'Specify seconds': 'Saniyyə göstərin',
  'Specify cost': 'Qiymət göstərin',
  'Specify the IMEI of the telematics equipment installed in your facility. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
    'Zəhmət olmasa, müəssisənizdə quraşdırılmış telematika avadanlığının IMEI-ni daxil edin. Avadanlığın serverə qoşulması düzgün IMEI-dən asılıdır. Daxil edilmiş məlumatları iki dəfə yoxlamaq tövsiyə olunur.',
  'Specify the current mileage of the object. This value will be used to calculate the mileage of the object. ':
    'Obyektin cari yürüşünü göstərin. Obyektin yürüşü bu dəyərdən hesablanacaq. ',
  'Specify the model of telematics equipment installed in your facility. Depending on the selected model of equipment, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
    'Zəhmət olmasa, müəssisənizdə quraşdırılmış telematika avadanlığının modelini göstərin. Seçilmiş avadanlıq modeli mesaj qəbulunun, əmr göndərilməsinin və digər funksional xüsusiyyətlərin düzgün işləməsini müəyyən edəcək.',
  'Specify the integrator to whom the facility is leased.': 'Əmlakın icarəyə götürüldüyü inteqratoru göstərin.',
  'Specify the code of the mechanical lock. It is recommended to change the mechanical lock code as often as possible.':
    'Mexaniki kilid kodunu daxil edin. Mexaniki kilid kodunu mümkün qədər tez-tez dəyişdirmək tövsiyə olunur.',
  'Specify the billing model of payment for services.': 'Platforma xidmətləri üçün ödəniş prosedurunu göstərin.',
  'Specify the amount of negative balance, upon reaching which, the user\'s units will be blocked.':
    'İstifadəçi obyektlərinin bloklanacağı maksimum mənfi balans məbləğini göstərin.',
  'Specify the minimum balance amount at which the partner\'s units will be blocked. A negative value can be specified.':
    'İstifadəçinin aktivlərinin dondurulacağı minimum balans məbləğini göstərin. Mənfi dəyərə icazə verilir.',
  'Specify the minimum number of satellites required for coordinates to be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Koordinatların etibarlı sayılması üçün tələb olunan minimum peyk sayını göstərin. Filtrləmə yalnız son etibarlı koordinatlara əsasən obyektin xəritədə düzgün göstərilməsi və kənar dəyərlərin qarşısının alınması üçün onlayn mesajlara tətbiq olunur. Avadanlıq tərəfindən göndərilən faktiki koordinatlar mesaj tarixçəsində saxlanılır.',
  'Hidden units': 'Gizli Obyektlər',
  'Payment deadline': 'Ödənişin son tarixi',
  'Specify the currency of payment for the platform services.':
    'Platforma xidmətləri üçün ödənişlərin hansı valyutada ediləcəyini göstərin.',
  'Specify the billing period for which payment will be charged.':
    'Ödənişin hansı müddət üçün tutulacağını göstərin.',
  'Specify the number of days in the calculation period.':
    'Hesablama dövründəki günlərin sayını göstərin.',
  'Specify the calculation method for the billing period. The "Units" method means that user pays only for those units that had the status "Available" at least once during the billing period. The "Interest" method means that user pays only the % of revenue or paid order value depending on the choice. The "Access Fee" method means that user pays only a fixed fee for the billing period. The "Combined" method may consist of units calculation as well as access fee calculation and the other combinations of calculation methods.':
    'Platforma xidmətləri üçün ödəniş metodunu göstərin. "Məhsula əsaslanan" ödəniş metodunu seçsəniz, ödəniş "Mövcud" statusuna təyin edilmiş məhsulun göstərilən qiymətinə əsaslanacaq. "Faizə əsaslanan" ödəniş metodunu seçsəniz, ödəniş ödəniş dövrü üçün gəlirin və ya ödənişli sifariş dəyərinin göstərilən faizinə əsaslanacaq. "Abunəyə əsaslanan" ödəniş metodunu seçsəniz, ödəniş ödəniş dövrü üçün göstərilən abunə haqqına əsaslanacaq. "Birləşdirilmiş" ödəniş metodunu seçsəniz, birdən çox ödəniş seçimini seçə bilərsiniz: məhsullar, faiz və ya abunə haqqı.',
  'Specify the value of interest which will be deducted from the source.':
    'Mənbədən tutulacaq faizi göstərin.',
  'Specify the source of deduction of interest: Revenue or Order Cost. The source "Order Cost" means that the user pay the interest of paid order value.':
    'Xidmət haqqının çıxılacağı mənbəni göstərin: "Gəlir" və ya "Sifariş Dəyəri". "Sifariş Dəyəri"ni seçsəniz, ödəniş yalnız ödənilmiş sifariş dəyərindən çıxılacaq.',
  'Specify the access fee value for the billing period.':
    'Müəyyən edilmiş ödəniş dövrü üçün abunə haqqını göstərin.',
  'Specify price of the unit.':
    'Müəyyən edilmiş ödəniş dövrü ərzində əmlak üçün bir dəfə tutulacaq vahid qiymətini göstərin. Ödəniş yalnız "Mövcuddur" statusuna təyin edilmiş əmlaklar üçün tutulur.',
  'Specify calculated service type of the combined calculation method: Units, Interest or Access Fee.':
    'Birləşdirilmiş hesablama metodu üçün ödənişli xidməti göstərin: Obyektlər, Faiz və ya Abunə haqqı.',
  'Specify the account login in Latin letters without spaces':
    'Giriş üçün giriş məlumatlarınızı boşluq olmadan Latın hərflərindən istifadə edərək daxil edin.',
  'Specify the user account password for logging in':
    'Daxil olmaq üçün istifadəçi hesabının şifrəsi daxil edin.',
  'Specify the user\'s email to be able to recover the password':
    'Şifrəni bərpa etmək üçün istifadəçinin e-poçt ünvanını daxil edin.',
  'Specify the user who owns the account': 'Hesabın sahibi olan istifadəçini göstərin',
  'Specify the position of the contact person who has access to the user account':
    'İstifadəçi hesabına girişi olan əlaqə şəxsinin vəzifə adını göstərin',
  'Specify the Telegram username of the contact person who has access to the user account.':
    'Zəhmət olmasa, istifadəçi hesabına daxil ola bilən Telegram əlaqə şəxsinin istifadəçi adını qeyd edin.',
  'Specify a link to the group of the corresponding organization in Telegram in the format https://t.me/BF_news1':
    'Müvafiq təşkilatın Telegram qrupuna https://t.me/BF_news1 formatında keçid təqdim edin',
  'Specify the regions where the user works.': 'İstifadəçinin işlədiyi bölgələri göstərin.',
  'Specify the access rights to the rate functionality the user should have':
    'İstifadəçinin tarif funksiyasına hansı giriş hüquqlarına sahib olmalı olduğunu göstərin',
  'Specify the access rights to the subscription functionality the user should have':
    'İstifadəçinin abunə funksiyasına hansı giriş hüquqlarına sahib olmalı olduğunu göstərin',
  'Specify the acquiring, which will be used for transactions with bank cards to pay for the orders and other purchases.':
    'Sifarişlərin və digər alış-verişlərin ödənişi üçün bank kartı əməliyyatlarını emal etmək üçün istifadə ediləcək ekvayrinq xidmətini göstərin.',
  'Specify the payment service through which the purchase of bonus packages, subscriptions and routes will be available.':
    'Bonus paketlərinin, keçidlərin və marşrutların hansı alış-veriş xidmətləri vasitəsilə əldə edilə biləcəyini göstərin.',
  'Specify the user ID (identifier) in the SimManager system to obtain information about the balance of SIM cards.':
    'SIM kartınızın balansı haqqında məlumat əldə etmək üçün SimManager sisteminə istifadəçi ID-nizi daxil edin.',
  'Specify the acquiring to which funds will be received when replenishing the balance of a user (integrator, administrator) through the admin panel':
    'İstifadəçinin (inteqratorun, administratorun) balansını admin paneli vasitəsilə doldurarkən vəsaitin hansı ekvayrinq xidmətinə köçürüləcəyini göstərin',
  'Specify the reason for closing the alarm': 'Həyəcan siqnalı bağlamağın səbəbini göstərin',
  'Specify the reason for closing all alarms': 'Bütün həyəcan siqnallarının bağlanma səbəbini göstərin',
  'Specify the reason for the deviation': 'Zəhmət olmasa, rədd edilmə səbəbini göstərin.',
  'Specify the regions in which the news item should be displayed': 'Zəhmət olmasa, rədd edilmə səbəbini göstərin.',
  'Specify the geofence owner. The geofence owner, as well as their child users with editing permissions, will be able to edit and delete the geofence.': 'Geozonanın sahibini göstərin. Geozona sahibi və redaktə icazəsi olan onun alt istifadəçiləri geozonanı redaktə edə və silə biləcəklər.',
  'Specify the ordinal number of the client\'s activity level achievement': 'Müştərinin fəaliyyət səviyyəsindəki nailiyyətinin seriya nömrəsini göstərin',
  'Specify the ordinal number': 'Zəhmət olmasa, seriya nömrəsini göstərin',
  'Specify the language in which the notification should be sent if there is no translation corresponding to the language of the client\'s device.':
    'Müştərinin cihazının dilinə uyğun tərcümə yoxdursa, bildirişin hansı dildə göndəriləcəyini göstərin.',
  'Specify the language in which level name should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Müştəri cihazının dilinə uyğun tərcümə yoxdursa, səviyyə adının hansı dildə göstəriləcəyini göstərin.',
  'Specify the unit type(-s) to which the component model belongs':
    'Komponent modelinin aid olduğu obyektin tip(lərini) göstərin.',
  'Specify the unit model(-s) to which the component model belongs': 'Komponent modelinin aid olduğu obyektin model(lər)ini göstərin.',
  'Specify the time zone of the region you are creating': 'Yaratdığınız regionun saat qurşağını göstərin',
  'Specify the period of time for the schedule to operate for the specified days of the week within a day.': 'Göstərilən həftə günləri üçün cədvəlin sutka daxilində işləmə vaxtını qeyd edin.',
  'Specify the geopoint owner. The geopoint owner, as well as their child users with editing permissions, will be able to edit and delete the geopoint.': 'Geopoint sahibini göstərin. Geopoint sahibi və redaktə icazəsi olan onun alt istifadəçiləri geopoint-i redaktə edə və silə biləcəklər.',
  'Specify the language in which the information for the client should be displayed if there is no translation matching the client device language.': 'Müştərinin cihazının dilinə uyğun tərcümə olmadıqda, məlumatın hansı dildə göstərilməli olduğunu qeyd edin.',
  'Specify value': 'Dəyəri daxil edin',
  'Service mode: is off': 'Servis rejimi: söndürülüb',
  'Service mode: no information': 'Servis rejimi: məlumat yoxdur',
  'Lock: is closed': 'Kilid: bağlıdır',
  'Language not selected': 'Dil seçilməyib',
  'Lock: is opened': 'Kilid: açıq',
  Opened: 'Açıq',
  'Lock: no information': 'Kilid: məlumat yoxdur',
  'Flashlight: is on': 'Fənər: Yandırılmış',
  'Flashlight: is off': 'Fənər: söndürülmüş',
  'Flashlight: no information': 'Fənər: məlumat yoxdur',
  'Height unknown': 'Hündürlük naməlum',
  Height: 'Hündürlük',
  'Height(mm)': 'Hündürlük(mm)',
  Organization: 'Təşkilat',
  'Organization name': 'Təşkilatın adı',
  'Taxpayer identification number': 'Vergi ödəyicisinin identifikasiya nömrəsi',
  'Enter taxpayer identification number': 'Vergi ödəyicisinin identifikasiya nömrəsini daxil edin',
  'Select an organization': 'Bir təşkilat seçin',
  'Select an icon': 'İkon seçin',
  'Select an available icon from the icon library': 'İkon kitabxanasından mövcud ikonu seçin.',
  'd.': 'gun',
  'm.': 'ay',
  'h.': 'saat',
  'h. ago': 'saat əvvəl',
  's.': 'san.',
  'Last message time': 'Son mesaj vaxtı',
  ago: 'əvvəl',
  'Last message time unknown': 'Son mesajın vaxtı məlum deyil',
  'Add acceptance certificate': 'Qəbul aktı əlavə edin',
  'Acceptance certificates': 'Qəbul aktları',
  Template: 'Şablon',
  TIN: 'VÖEN',
  'Title not selected': 'Başlıq seçilməyib',
  'You can use the templates above to automatically replace in this text':
    'Bu mətni avtomatik olaraq əvəz etmək üçün yuxarıdakı şablonlardan istifadə edə bilərsiniz.',
  'You have new booking': 'Yeni rezervasiyanız var',
  'You can change the subscription for a group, in which case the current subscription is deactivated, and the new subscription is activated for all clients of the group.':
    'Qrup üçün abunəliyi dəyişə bilərsiniz. Bu halda, cari abunəlik deaktiv ediləcək və yeni abunəlik qrupun bütün müştəriləri üçün aktivləşdiriləcək.',
  'You can assign a previously created schedule if it\'s suitable, or create a new one. The new schedule will be available in your list for future assignments or adjustments.': 'Əvvəl yaratdığınız cədvəl uyğundursa, onu təyin edə bilərsiniz və ya yenisini yarada bilərsiniz. Yeni cədvəl gələcək təyinatlar və düzəlişlər üçün siyahınızda əlçatan olacaq.',
  'You can add icons in PNG or SVG formats with a 1:1 aspect ratio. Recommended icon sizes are 24 x 24 pixels for SVG and 64 x 64 pixels for PNG. The maximum file size is 15 KB.': 'PNG və ya SVG formatlarında 1:1 nisbətində ikon əlavə etmək mümkündür. Tövsiyə olunan ölçülər: SVG üçün 24 x 24 piksel, PNG üçün 64 x 64 piksel. Maksimum fayl ölçüsü 15 KB‑dır.',
  'You can immediately select geofences from the list to which the schedule will apply. You can also assign a created schedule when creating a geofence.': 'Cədvəlin tətbiq olunacağı geozonaları siyahıdan dərhal seçə bilərsiniz. Həmçinin geozona yaradarkən yaradılmış cədvəli təyin edə bilərsiniz.',
  'You can immediately select the tariffs from the list to which the schedule will apply. You can also assign the created schedule when creating the tariff.': 'Cədvəlin tətbiq olunacağı tarifləri siyahıdan dərhal seçə bilərsiniz. Həmçinin tarif yaradarkən yaradılmış cədvəli təyin edə bilərsiniz.',
  Text: 'Mətn',
  'Patterns for set and replace': 'Əvəzetmə şablonları',
  'Unit model name': 'Obyekt modelinin adı',
  'Integrator Organization name': 'İnteqrator təşkilatının adı',
  'Integrator can edit data on the object, as well as delete the object':
    'İnteqrator obyektdəki məlumatları redaktə edə, eləcə də obyekti silə bilər.',
  'Scooter registration number': 'Skuterin qeydiyyat nömrəsi',
  'Client phone number': 'Müştərinin telefon nömrəsi',
  'Client\'s full name': 'Müştərinin tam adı',
  Created: 'Yaradılıb',
  'Electric bikes': 'Elektrik velosipedlər',
  'Electric scooter': 'Elektrik skuter',
  'Electric scooters': 'Elektrik skuterlər',
  'Electric quad bikes': 'Elektrik ATV-lər',
  'Electric-bikes': 'Elektrik velosipedlər',
  'Electric quad bike': 'Elektrik ATV',
  'Electric quad bike price': 'Elektrikli ATV-nin qiyməti',
  'Electric scooter price': 'Elektrikli skuterin qiyməti',
  'Each geofence type has its own logic and corresponding color. Detailed information on each geofence type and its logic is available in the project documentation. To access the documentation, please contact the project support team.': 'Hər bir geozona növünün öz məntiqi və uyğun rəngi var. Hər bir geozona növü və onun işləmə məntiqi haqqında ətraflı məlumat layihə sənədlərində mövcuddur. Sənədlərə giriş əldə etmək üçün layihə dəstək xidməti ilə əlaqə saxlayın.',
  Apartment: 'Mənzil',
  Station: 'Stansiya',
  'Station price': 'Stansiya qiyməti',
  Starts: 'Başlayır',
  'Is used': 'İstifadə olunur',
  'Click to change state': 'Statusu dəyişdirmək üçün klikləyin',
  'Acceptance certificate state successfully changed': 'Qəbul sertifikatının statusu uğurla dəyişdirildi.',
  'Are sure you want to delete this acceptance certificate': 'Bu qəbul sertifikatını həqiqətən silmək istəyirsiniz?',
  'Are sure you want to delete this language': 'Bu dili həqiqətən silmək istəyirsiniz?',
  'Successfully deleted': 'Uğurla silindi',
  'Delete failed': 'Silmək alınmadı',
  'Go Back': 'Geri',
  'Go to': 'Gedin',
  'Good signal': 'Yaxşı siqnal',
  'Google API-key not valid': 'Google API açarı etibarsızdır',
  'Google Maps Settings': 'Google Xəritələrinin tənzimlənməsi',
  'Download application link': 'Tətbiqi yükləmək üçün link',
  Debt: 'Borc',
  'Debt / Fines': 'Borc / Cərimələr',
  'Day of the week not selected': 'Həftənin günü seçilməyib',
  'Debt currency': 'Borcun valyutası',
  'Debt repayments': 'Silinmələr',
  'Debt repayments from': 'Borcların silinməsi',
  'Search by LBS': 'LBS ilə tapın',
  Search: 'Axtarış',
  'Search for': 'Axtarış',
  'Search by name': 'Ad üzrə axtarış',
  precision: 'Dəqiqlik',
  'LBS coordinates': 'LBS koordinatları',
  'Cancel debt': 'Borcu ləğv edin',
  Cancel: 'Ləğv et',
  'Retry attempt': 'Yenidən cəhd edin',
  Cancellation: 'Ləğv et',
  'Cancel insurance': 'Sığortanı ləğv edin',
  'Are sure you want to cancel insurance': 'Həqiqətən sığortanızı ləğv etmək istəyirsiniz?',
  'Insurance successfully canceled': 'Sığorta uğurla ləğv edildi.',
  'An error occurred while trying to cancel insurance': 'Sığortanız ləğv edilərkən xəta baş verdi.',
  'Error in price plan': 'Tarifdə xəta',
  'Insurance payment error': 'Sığorta ödənişi xətası',
  Min: 'Dəq.',
  min: 'dəq.',
  Minutes: 'Dəqiqə.',
  Max: 'Maks.',
  'less than 5 minutes': '5 dəqiqədən az',
  '5 to 15 minutes': '5 dəqiqədən 15 dəqiqəyə qədər',
  '15 to 30 minutes': '15 dəqiqədən 30 dəqiqəyə qədər',
  'more than 30 minutes': '30 dəqiqədən çox',
  '80% to 100%': '80%-dən 100%-ə qədər',
  '50% to 79%': '50%-dən 79%-ə qədər',
  '20% to 49%': '20%-dən 49%-ə qədər',
  'Max debt amount': 'Borcun maksimum məbləği',
  'Minimum balance': 'Minimum balans',
  'The maximum length of the identifier is 100 characters. Only lowercase Latin letters (a-z), numbers, hyphens and underscores are allowed':
    'İdentifikatorun maksimum uzunluğu 100 simvoldur. Yalnız kiçik Latın hərfləri (a-z), rəqəmlər, defislər və alt xətlərə icazə verilir.',
  'The main screen of the app displays only three recent unread news items. You can pin an important news item to display it on the main screen every time the app is launched, regardless of whether it has been read/hidden by the client or not. We do not recommend pinning more than one news item.':
    'Tətbiqin əsas ekranında ən son oxunmamış üç xəbərdən çoxu göstərilmir. İstifadəçi tərəfindən oxunub-gizlədilməməsindən asılı olmayaraq, tətbiq hər dəfə işə salındıqda əsas ekranda göstərmək üçün vacib bir xəbəri sancmaq olar. Birdən çox xəbəri sancmağı tövsiyə etmirik.',
  'Maximum duration of the trip': 'Maksimum səfər müddəti',
  'Maximum duration of the trip (-1 - no limits)': 'Maksimum səfər müddəti (-1 - məhdudiyyətsiz)',
  'Debt canceled successfully': 'Borc uğurla silindi.',
  'Debt successfully paid': 'Borc uğurla ödənilib.',
  'Remaining number of uses': 'Qalan istifadə sayı',
  'LBS search': 'LBS üzrə axtarış',
  'Not enough data to search for LBS': 'LBS axtarmaq üçün kifayət qədər məlumat yoxdur',
  'Not enough cash': 'Yetərli vəsait yoxdur',
  'Units count': 'Obyektlərin sayı',
  'Units active count by period': 'Dövr üçün aktiv obyektlərin sayı',
  'Units event log': 'Obyekt hadisəsi qeydiyyatı',
  'Amount for period by active units': 'Aktiv obyektlər üçün dövr üçün məbləğ',
  'Fixed amount': 'Sabit məbləğ',
  Messages: 'Mesajlar',
  Latitude: 'Enlem',
  'Latest photos': 'Ən son şəkillər',
  Longitude: 'Uzunluq',
  Parameters: 'Parametrlər',
  'Parent account blocked': 'Valideyn bloklandı',
  Course: 'Kurs',
  'Report by users': 'Kurs',
  'Representative\'s name': 'Nümayəndənin adı',
  'Data collection time': 'Məlumatların toplanması vaxtı',
  'Date and time of connection': 'Qoşulma tarixi və vaxtı',
  From: 'Başlanma',
  To: 'Son',
  'Number days in minus': 'Mənfi ilə göstərilən günlərin sayı',
  'Number of days': 'Günlərin sayı',
  'Active units amount': 'Aktiv obyektlər üçün məbləğ',
  'All units amount': 'Bütün obyektlər üçün ümumi məbləğ',
  'Chat in whatsapp': 'WhatsApp-da yazın',
  'Journal orders': 'Sifariş jurnalı',
  'User id': 'İstifadəçi ID-si',
  'Time start': 'Başlama vaxtı',
  'Store ID': 'Mağaza ID-si',
  'Last Order Finish Time': 'Son sifariş vaxtı',
  'Secret Key': 'Gizli açar',
  'Security mode': 'Təhlükəsizlik rejimi',
  'Security mode: is on': 'Təhlükəsizlik rejimi: aktiv',
  'Security mode: is off': 'Təhlükəsizlik rejimi: deaktiv',
  'Security mode: no information': 'Təhlükəsizlik rejimi: məlumat yoxdur',
  'Public Key': 'Publik açar',
  'Technical area': 'Texniki zona',
  'Technics territories': 'Texnikin əraziləri',
  'Technics territory': 'Texnikin ərazisi',
  Technicians: 'Texniklər',
  Technician: 'Texnik',
  'Balance in coins': 'Coin balans',
  'Balance in currency': 'Valyuta balansı',
  'On Charge': 'Şarjda',
  Alarm: 'Həyəcan',
  'On Charge At Stock': 'Anbarda şarjda',
  'Not Available': 'Mövcud deyil',
  Stolen: 'Oğurlanıb',
  'Under Repair': 'Təmir altında',
  Donor: 'Donor',
  'Not set': 'Təyin edilməyib',
  'SIM cards balance': 'SIM kart balansı',
  'User balance': 'İstifadəçi balansı',
  'Balance report': 'Balans tarixçəsi',
  'Balance report 2023': 'Balans Tarixi 2023',
  'Paid message log': 'Ödənişli Mesaj Jurnalı',
  'Close all': 'Hamısını bağlayın',
  'Close all alarms': 'Bütün siqnalları bağlayın',
  'Description details': 'Təsvir detalları',
  Routes: 'Marşrutlar',
  Purchases: 'Satınalmalar',
  'Purchase by client': 'Müştəri alışı',
  'Purchase log': 'Satınalma jurnalı',
  'End user': 'Müştəri',
  'End of billing period': 'Faktura dövrünün sonu',
  Ending: 'Son',
  'Only a user with the administrator role can be the project owner': 'Layihənin sahibi yalnız administrator roluna malik istifadəçi ola bilər.',
  'Only administrator or integrator can be the owner of the news item.':
    'Xəbərin sahibi ya administrator, ya da inteqrator ola bilər',
  'Free-form project name': 'Layihənin adı istənilən formada',
  'The unique identifier is used to bind the mobile app to the project. It\'s the name of the project, written in small Latin letters without spaces or special characters. IMPORTANT!!! Once the project is created, the unique identifier cannot be changed!':
    'Unikal identifikator layihəni mobil tətbiqə bağlamaq üçün istifadə olunur. Bu, boşluq və xüsusi simvollar olmadan kiçik Latın hərfləri ilə yazılmış layihə adıdır. VACİBDİR!!! Layihə yaradıldıqdan sonra unikal identifikator dəyişdirilə bilməz!',
  'Simple registration contains a basic information about the client and doesn\'t require document verification. Extended registration contains supporting documents that are sent for moderation to the project administrator and/or project manager with moderator functionality.'
    : 'Əsas qeydiyyat minimal müştəri məlumatı tələb edir və sənəd təsdiqini tələb etmir. Ətraflı qeydiyyat dəstəkləyici sənədləri tələb edir və bunlar moderator funksiyası ilə layihə administratoruna və/və ya layihə menecerinə moderasiya üçün göndərilir.',
  'The extended registration type determines the set of supporting documents. Detailed information is available in the platform documentation.':
    'Genişləndirilmiş qeydiyyat növü dəstəkləyici sənədlər dəstini müəyyən edir. Ətraflı məlumat platforma sənədlərində mövcuddur.',
  'One-time password is valid for only one authentication session and is provided to the client by one of the available sources. A reusable password is created when registering a client account and its use for authentication is unlimited.'
    : 'Birdəfəlik şifrə yalnız bir identifikasiya sessiyası üçün etibarlıdır və mövcud mənbələrdən biri tərəfindən müştəriyə təqdim olunur. Təkrar istifadə edilə bilən şifrə müştəri hesabı qeydiyyatdan keçirilərkən yaradılır və identifikasiya üçün qeyri-müəyyən müddətə istifadə edilə bilər.',
  'Specify the sources of provision of one-time password to the client.':
    'Müştəriyə birdəfəlik şifrə verilmə mənbələrini göstərin.',
  'Provide the phone number of the Telegram Gateway account owner.': 'Zəhmət olmasa, Telegram Gateway hesabı sahibinin telefon nömrəsini təqdim edin.',
  'API token can be obtained in the Telegram Gateway settings on the API page.': 'Zəhmət olmasa, Telegram Gateway hesabı sahibinin telefon nömrəsini təqdim edin.',
  'Provide a link to the document posted on the project\'s official website.': 'Layihənin rəsmi saytında yerləşdirilmiş sənədə keçidi göstərin',
  'You can optionally specify the sender username, designating a verified channel you own as the one from which the code will be sent to the user.':
    'Kodun istifadəçiyə göndəriləcəyi kanal kimi sahib olduğunuz təsdiqlənmiş kanalı qeyd etməklə göndərənin adını istəyə bağlı olaraq göstərə bilərsiniz.',
  'Specify the outgoing mail server address': 'Gedən poçt serverinin ünvanını göstərin',
  'Specify the outgoing mail server port': 'Gedən poçt server portunu göstərin',
  'Specify the encryption type': 'Şifrələmə növünü göstərin',
  'Specify the sender email': 'Göndərənin e-poçt ünvanını daxil edin.',
  'Enter username': 'İstifadəçi adını daxil edin',
  'Specify the email password': 'Göndərənin e-poçt şifrəsi daxil edin',
  'Specify the minimum age of the client': 'Zəhmət olmasa, müştərinin minimum yaşını göstərin.',
  'Specify the document signature text, including a link to the document in the form of the document name, using the automatic data substitution template - {{documentLinkName}}': 'Sənədin imzalanma mətnini, sənədin adı formasında olan keçidi də daxil etməklə, {{documentLinkName}} avtomatik məlumat əvəzetmə şablonundan istifadə edərək göstərin',
  'A short smart link of the service that redirects the user to the desired app store depending on the device. The link is automatically added to the QR code of the unit before the registration number. Thus, when scanning the QR code of the unit with the camera in the mobile app, the unit is booked, and when scanning with the camera of a mobile phone, the transition to the app page for downloading is performed.'
    : 'İstifadəçini cihazından asılı olaraq müvafiq tətbiq mağazasına yönləndirən xidmət üçün qısa, ağıllı bir keçid. Keçid qeydiyyat nömrəsindən əvvəl avtomatik olaraq əmlakın QR koduna əlavə olunur. Bu o deməkdir ki, QR kodunu mobil tətbiqin kamerası ilə skan etmək rezervasiya edir, mobil telefonun kamerası ilə skan etmək isə istifadəçini tətbiq mağazasının yükləmə səhifəsinə yönləndirir.',
  'Used to navigate to the mobile app when confirming the client\'s Email on an iOS device. Provided by the developer':
    'iOS cihazında müştərinin e-poçtunu təsdiqləyərkən mobil tətbiqə yönləndirmək üçün istifadə olunur. Geliştirici tərəfindən təmin edilir.',
  'Used to navigate to the mobile app when confirming the client\'s Email on an Android device. Provided by the developer':
    'Android cihazında müştərinin e-poçtunu təsdiqləyərkən mobil tətbiqə yönləndirmək üçün istifadə olunur. Geliştirici tərəfindən təmin edilir.',
  'To credit cashback to the balance of clients in all completed and successfully paid orders of the project, it is necessary to specify the value in percentage.'
    : 'Hesab balansınıza keşbek köçürmək üçün layihə daxilində tamamlanmış və uğurla ödənilmiş bütün sifarişlər üçün faiz dəyərini göstərməlisiniz.',
  'Manage visibility of units in the client mobile app. Should be enabled by default. If you need to hide temporarily all units of the project from clients without changing status of the units, you should uncheck the box.'
    : 'Müştəri mobil tətbiqində obyektlərin görünürlüyünü idarə edir. Varsayılan olaraq aktiv olmalıdır.' +
    ' Obyektlərin vəziyyətini dəyişdirmədən bütün layihə obyektlərini müştərilərdən müvəqqəti olaraq gizlətmək lazımdırsa, onay qutusundan işarəni çıxarmalısınız..',
  'Tourist route price plan': 'Turist marşrutu planı',
  'Duration days': 'Günlərin uzunluğu',
  'Time of purchase request': 'Satınalma tələbi vaxtı',
  'Payment status': 'Ödəniş statusu',
  'Time of purchase completion': 'Satınalma vaxtı',
  'Is activated': 'Satınalma aktivdirmi?',
  'Tourist route purchase identifier': 'Turist marşrutu alış ID-si',
  'Vat rate': 'ƏDV dərəcəsi',
  'Taxation system': 'Vergi sistemi',
  'Clients with debt': 'Borcu olan müştərilər',
  Gallery: 'Qalereya',
  'Show all': 'Hamısını göstər',
  Next: 'Növbəti',
  Prev: 'Əvvəlki',
  'Last day': 'Son gün',
  'Chat to WhatsApp': 'WhatsApp-a yazın',
  'Order id': 'Sifariş ID-si: ',
  'Client login': 'Müştəri login: ',
  'Client activity levels': 'Müştəri fəaliyyət səviyyələri',
  Current: 'Cari',
  'Currency code': 'Valyuta: ',
  'Customize notifications by unit': 'Obyektlər üçün bildirişlərin qurulması',
  'Customize notifications by client': 'Müştərilər üçün bildirişlərin qurulması',
  'Customization settings': 'Fərdiləşdirmənin qurulması',
  'Order price': 'Ümumi sifariş qiyməti: ',
  'Order start time': 'Sifarişin başlama vaxtı',
  'Order finish time': 'Sifarişin bitmə vaxtı',
  'Order completion': 'Sifarişin tamamlanması',
  'Ordering statistics': 'Sifariş statistikası',
  'Price plan name': 'Tarif adı: ',
  'Last order': 'Son sifariş',
  Hour: 'Saat',
  'next day': 'növbəti gün',
  'prev. day': 'əvvəlki gün',
  'next week': 'növbəti həftə',
  'prev. week': 'əvvəlki həftə',
  'next month': 'növbəti ay',
  'prev. month': 'əvvəlki ay',
  week: 'həftə',
  month: 'ay',
  'Reset filters': 'Filtrləri sıfırlayın',
  'Pay penalty': 'Cəriməni ödəyin',
  'Cancel penalty': 'Cərimənin ləğvi',
  'Penalty successfully paid': 'Cərimə uğurla ödənilib.',
  'Penalty canceled successfully': 'Cərimə uğurla ləğv edildi.',
  'Confirm cancellation': 'Ləğvi təsdiqləyin',
  'Consider the amount': 'Məbləği nəzərə alın',
  'Consider the duration': 'Müddəti nəzərə alın',
  'Consent text': 'Razılıq mətni',
  Confirm: 'Təsdiqləyin',
  'Reason for canceling fine': 'Cərimənin ləğv edilməsinin səbəbi',
  'Reason for canceling': 'Ləğv səbəbi',
  'Reason for subscription termination': 'Abunəliyin dayandırılma səbəbi',
  'Debt for fine': 'Cərimə borcları',
  'Debt for trip': 'Səfər borcları',
  'Your reason for closing all notifications': 'Bildirişlərin bağlanma səbəbi',
  'Client location at end of lease': 'İcarə müqaviləsinin sonunda müştərinin yeri',
  'Unit location at end of lease': 'İcarə müqaviləsinin sonunda əmlakın yeri',
  'Trip info': 'Səyahət məlumatları',
  'Limit error, use filters': 'Nəticə çox böyükdür, filtrlərdən istifadə edin',
  'List of clients': 'Müştəri siyahısı',
  'List of couriers': 'Kuryerlərin siyahısı',
  Limit: 'Məhdudiyyət',
  'Trip start': 'Səfərin başlanğıcı',
  'Trip continue': 'Səfərin davamı',
  'Trip finish': 'Səfərin sonu',
  'Distance from Unit to Client, m': 'Obyektdən müştəriyə qədər olan məsafə, m',
  m: 'm',
  'hh:mm': 'ss:dd',
  'hh:mm:ss - hh:mm:ss': 'ss:dd:ss - ss:dd:ss',
  'Order start place': 'Sifarişin başlama yeri',
  'Order finish place': 'Sifarişin tamamlanma yeri',
  'Orders price': 'Ümumi sifariş məbləği',
  'Bank card type': 'Bank kartı növü',
  'Bank cards': 'Bank kartları',
  'Bank card last four digits': 'Bank kartının son dörd rəqəmi',
  Banking: 'Bankçılıq',
  'Bank card': 'Bank kartı',
  'Notification link': 'Bildiriş linki',
  'Send notifications': 'Bildirişlərin göndərilməsi',
  'Preview image': 'Başlıq şəkli',
  'Has furniture': 'Mebel var',
  'Has fridge': 'Soyuducu var',
  'With kids': 'Uşaqlara icazə verilir',
  Floor: 'Mərtəbə',
  'Window view': 'Pəncərədən görünüş',
  'Rooms amount': 'Otaqların sayı',
  'Quality repair': 'Təmir',
  'Question type': 'Sual növü',
  Question: 'Sual',
  'Select question type': 'Sual növünü seçin',
  'Value should be like 12+13+14': 'Dəyər 12+13+14 olmalıdır',
  'The value must be at least 6 characters.': 'Dəyər ən azı 6 simvoldan ibarət olmalıdır.',
  'Invalid value': 'Yanlış dəyər',
  'Invalid format. Allowed: ': 'Yanlış format. İcazə verilir: {{params}}',
  Balcony: 'Balkon',
  Bathroom: 'Hamam otağı',
  'Square meter rooms': 'Otaqların sahəsi',
  'Square meter kitchen': 'Mətbəx sahəsi',
  'Square meter living': 'Yaşayış sahəsi',
  'Square meter full': 'Ümumi sahə',
  'Closest metro': 'Ən yaxın metro stansiyası',
  'Minutes to metro': 'Metroya məsəfə dəq.',
  'Floors total in building': 'Binadakı mərtəbələrin sayı',
  'Maximum amount of people': 'Maksimum insan sayı',
  'Next maintenance mileage': 'Növbəti təmir',
  'With conditioner': 'Kondisioner var',
  'With dishwasher': 'Qabyuyan maşın var',
  'With washer': 'Paltaryuyan maşın var',
  'With tv': 'Televizor var',
  'With pets': 'Ev heyvanlarına icazə verilir',
  'Near reservoir': 'Yaxınlıqda su hövzəsi var',
  'Near park': 'Yaxınlıqda park var',
  'Year of construction': 'Tikinti ili',
  'Year of card expiry': 'Kartın bitmə ili',
  'Yandex Maps Settings': 'Yandex Xəritələrinin tənzimlənməsi',
  'Ceiling height': 'Tavan hündürlüyü',
  'Certificate of absence (presence) of a criminal record': 'Cinayət qeydinin olmaması (mövcudluğu) haqqında arayış',
  Parking: 'Parkinq',
  'House type': 'Evin növü',
  'Accommodation type': 'Mənzil növü',
  'Price for day': 'Gündəlik qiymət',
  Bookings: 'Rezervasiyalar',
  'Booking info': 'Rezervasiya məlumatı',
  'Invalid year of construction': 'Yanlış tikinti ili',
  'Name can only contain letters, numbers, dashes and underscores':
    'Ad yalnız hərflərdən, rəqəmlərdən, defislərdən və alt xəttlərdən ibarət ola bilər.',
  'Login can only contain letters, numbers, dashes and underscores':
    'Giriş yalnız hərflər, rəqəmlər, defislər və alt xəttlərdən ibarət ola bilər.',
  'Login can\'t contain a whitespace': 'Giriş boşluq ehtiva edə bilməz',
  'Name can\'t start with dash or underscore characters': 'Ad defis və ya alt xətt ilə başlaya bilməz.',
  'Internal name will be used for administrative purposes only and will not be available to the client.':
    'Daxili ad yalnız inzibati məqsədlər üçün istifadə olunur və müştəri üçün əlçatan olmayacaq.',
  'Unit type name may only contain lowercase latin letters, hyphens and underscores':
    'Obyekt tipinin adı yalnız kiçik Latın hərflərindən, defislərdən və alt xəttlərdən ibarət ola bilər.',
  'Unit types': 'Obyekt növləri',
  'Apartment number': 'Mənzil nömrəsi',
  apartment: 'mənzil {{val}}',
  'Email host': 'E-mail hostu',
  'Email username': 'E-mail istifadəçi adı',
  'Email password': 'E-mail şifrə',
  'Email port': 'Poçt portu',
  'Email encryption': 'Şifrələmə növü',
  'Email from': 'E-mail göndərən',
  Date: 'Tarix',
  'Date from': 'Başlama tarixi',
  'Date to': 'Bitmə tarixi',
  'Confirm version': 'Dəyişikliyi təsdiqləyin',
  'Reject version': 'Dəyişikliyi rədd edin',
  Reject: 'Rədd et',
  'Delivery time': 'Çatdırılma müddəti',
  'Delivery address': 'Çatdırılma ünvanı',
  'Return address': 'Qaytarma ünvanı',
  'Delivery point': 'Çatdırılma nöqtəsi',
  'Return point': 'Geri dönüş nöqtəsi',
  Returned: 'Qaytarıldı',
  'Active booking': 'Aktiv rezervasiya',
  'Activation log': 'Aktivləşdirmə jurnalı',
  'Another region': 'Başqa bölgə',
  'Value time is not correct': 'Daxil edilmiş vaxt səhvdir.',
  Updated: 'Yeniləndi',
  'Update type': 'Dəyişiklik növü',
  Update: 'Dəyişiklik',
  'Car delivered': 'Maşın təhvil verildi',
  'Car price': 'Avtomobilin qiyməti',
  'Card expiry month': 'Kartın bitmə ayı',
  'Close booking': 'Rezervasiyanı bağlayın',
  'Request for update': 'Yeniləmə sorğusu',
  'Request to fill out the registration form': 'Qeydiyyat formasını doldurmaq üçün sorğu',
  'Fill out the registration form yourself': 'Qeydiyyat formasını özünüz doldurun',
  Recalculate: 'Yenidən hesablama',
  'Order created': 'Sifariş yaradılıb',
  'Order cost': 'Sifariş dəyəri',
  'Update confirmed': 'Yeniləmə təsdiqləndi',
  'Update rejected': 'Yeniləmə rədd edildi',
  'Upload a file in .txt format with a list of customers\' phone numbers in a column, without spaces or other punctuation marks.':
    'Sütunda boşluq və ya digər durğu işarələri olmadan sadalanan müştəri nömrələrinin siyahısını ehtiva edən txt faylını yükləyin.',
  'Upload the document in HTML format, having previously specified the necessary data substitution templates in its content.': 'Sənədi HTML formatında yükləyin və əvvəlcədən onun məzmununda lazım olan məlumat əvəzetmə şablonlarını göstərin.',
  'Upload a photo of the document': 'Sənədin şəklini yükləyin',
  'Upload the document (HTML)': 'Sənədi yükləyin (HTML)',
  'Booking closed': 'Rezervasiya bağlanıb',
  'Booking confirmation': 'Rezervasiya təsdiqi',
  'Bonus package purchases': 'Bonus paketlərinin alınması',
  'Bonus on order completion': 'Sifarişin tamamlanmasından sonra bonus',
  'End user type': 'Müştəri növü',
  'Cot amount': 'Beşiklərin sayı',
  'Entrance number': 'Blok nömrəsi',
  entrance_number: 'blok {{val}}',
  'Enter ID': 'İD daxil edin',
  'Enter API-key': 'API-key daxil edin',
  'Enter email': 'E-mail daxil edin',
  'Enter code': 'Kod daxil edin',
  'Enter contact': 'Əlaqənizi daxil edin',
  'Enter consent text': 'Razılıq mətnini daxil edin',
  'Enter the amount': 'Miqdarı daxil edin',
  'Enter value': 'Qiyməti daxil edin',
  'Enter the name': 'Ad daxil edin',
  'Enter phone number': 'Telefon nömrsi daxil edin',
  'Enter last name': 'Soyadınızı daxil edin',
  'Enter middle name': 'Atasının adı daxil edin',
  'Enter the interest value': 'Faiz dəyərini daxil edin',
  'Enter the amount value': 'Məbləğ dəyərini daxil edin',
  'Enter the amount in hours': 'Məbləği saatlarla daxil edin',
  'Enter the document text': 'Sənədin mətnini daxil edin',
  'Enter the signing text': 'İmzalama mətnini daxil edin',
  'Enter the cashback percentage': 'Keşbek faizini göstərin.',
  'Enter the amount in the country\'s currency': 'Ölkənin valyutasında məbləği göstərin.',
  'Enter number of days': 'Günlərin sayını daxil edin',
  'Enter number': 'Nömrəni daxil edin',
  'Enter number prefix': 'Nömrə prefiksini daxil edin',
  'Enter subscription name': 'Abunə adını daxil edin',
  'Enter a name': 'Adı daxil edin',
  'Enter a name for the new schedule.': 'Yeni cədvəl üçün ad daxil edin.',
  'Enter a name for the icon.': 'İkon üçün ad daxil edin.',
  'Enter a unique identifier': 'Unikal identifikator daxil edin',
  'Enter an address': 'Ünvanı daxil edin',
  'Enter short description text': 'Qısa təsvir mətni daxil edin',
  'Enter short description text 1': 'Qısa təsvir 1 mətni daxil edin',
  'Enter short description text 2': 'Qısa təsvir 2 mətni daxil edin',
  'Enter text for detailed description': 'Ətraflı təsvir mətnini daxil edin',
  'Enter text to search': 'Axtarış üçün mətn daxil edin',
  'Enter name of the rate': 'Tarif adını daxil edin',
  'Enter name': 'Ad daxil edin',
  'Enter service name 1': '1 nömrəli xidmətin adını daxil edin',
  'Enter service name 2': '2 nömrəli xidmətin adını daxil edin',
  'Enter service name 3': '3 nömrəli xidmətin adını daxil edin',
  'Enter service name 4': '4 nömrəli xidmətin adını daxil edin',
  'Enter price': 'Qiyməti daxil edin',
  'Enter price for service 1': '1 nömrəli xidmətin qiymətini daxil edin',
  'Enter price for service 2': '2 nömrəli xidmətin qiymətini daxil edin',
  'Enter price for service 3': '4 nömrəli xidmətin qiymətini daxil edin',
  'Enter price for service 4': '1 nömrəli xidmətin qiymətini daxil edin',
  'Enter cost': 'Qiyməti daxil edin',
  'Enter description text': 'Təsvir mətnini daxil edin',
  'Enter description': 'Təsvir daxil edin',
  'Enter driver\'s license number': 'Sürücülük vəsiqəsinin nömrəsini daxil edin',
  'Enter serial number': 'Seriya nömrəsini daxil edin',
  'Enter series and document number': 'Sənədin seriyasını və nömrəsini daxil edin',
  'Enter charge value': 'Ödəniş dəyərini daxil edin',
  'Enter the serial number of the object': 'Obyektin seriya nömrəsini daxil edin.',
  'Enter registration number': 'Qeydiyyat nömrəsini daxil edin',
  'Enter IMEI': 'IMEI daxil edin',
  'Enter reg. object number': 'Obyektin qeydiyyat nömrəsini daxil edin',
  'Enter a free-form description of the color, for example, "Beige", "Metallic Green", etc.':
    'Rəngin sərbəst formada təsvirini daxil edin, məsələn, “Bej”, “Metallik Yaşıl” və s.',
  'Enter the number of the SIM card installed in the telematics equipment':
    'Zəhmət olmasa, telematika avadanlığına quraşdırılmış SIM kartın nömrəsini daxil edin.',
  'Enter comment text': 'Şərh mətninizi daxil edin',
  'Enter a comment': 'Şərhinizi daxil edin',
  'Enter amount': 'Məbləği daxil edin',
  'Enter percentage': 'Faizi daxil edin',
  'Enter command text': 'Komanda mətnini daxil edin',
  'Enter notification text': 'Bildiriş mətnini daxil edin',
  'Enter the number of days to pay the invoice. Invoice date for the billing period is the start date of a new billing period. Account will be blocked in case of non-payment of the debt within the specified period.':
    'Faktura tarixindən etibarən ödəniş üçün günlərin sayını göstərin. Faktura tarixi yeni ödəniş dövrünün başlanğıcını qeyd edir. Göstərilən müddət ərzində faktura üçün vəsait alınmazsa, hesabınız bloklanacaq.',
  'Enter text of the client\'s agreement to the terms of the document. For example: "I have read the terms of the privacy policy and, by checking this box, I agree to its terms."': 'Sənədin şərtlərinə müştərinin razılıq mətnini daxil edin. Məsələn: «Mən məxfilik siyasətinin şərtləri ilə tanış oldum və bu xanaya işarə qoymaqla onun şərtləri ilə razılaşıram».',
  'Enter mileage': 'Yürüş daxil edin',
  'Enter account login': 'Hesabınıza giriş daxil edin',
  'Enter login': 'Girişinizi daxil edin',
  'Enter your name': 'Adınızı daxil edin',
  'Enter your phone number': 'Telefon nömrənizi daxil edin',
  'Enter password': 'Şifrənizi daxil edin',
  'Enter a password': 'Şifrənizi daxil edin',
  'Enter passport number': 'Pasport nömrəsini daxil edin',
  'Enter position': 'Vəzifə daxil edin',
  'Enter port': 'Port daxil edin',
  'Enter API token': 'API token daxil edin',
  'Enter the Full Name of the contact person who has access to the user account':
    'İstifadəçi hesabına girişi olan əlaqə şəxsinin soyadını, adını və atasının adını qeyd edin.',
  'İstifadəçi hesabına girişi olan əlaqə şəxsinin telefon nömrəsini +994101111111 formatında daxil edin':
    'Zəhmət olmasa, istifadəçi hesabına girişi olan əlaqə şəxsinin telefon nömrəsini təqdim edin.',
  'Enter the number n the format +375291111111': 'Nömrəni +994101111111 formatında daxil edin',
  'Enter the user name in the format @ivanovivanivanovich': 'İstifadəçi adınızı @mammadlimammad formatında daxil edin',
  'Enter the link in the format https://t.me/BF_news1': 'Linki https://t.me/BF_news1 formatında daxil edin',
  'Enter the address of registration': 'Qeydiyyat ünvanınızı təqdim edin.',
  'Enter the name of the client\'s activity level. This name will be used for administrative purposes only and will not be available to the client. The client\'s activity level name is set when adding transfers':
    'Müştərinin fəaliyyət səviyyəsinin daxili adını göstərin. Bu ad yalnız inzibati məqsədlər üçün istifadə olunacaq və müştəri tərəfindən görünməyəcək. Köçürmələr əlavə edilərkən müştərinin fəaliyyət səviyyəsinin adı təyin olunur.',
  'Enter the name of the parameter by which the battery charge level value will be calculated': 'AKB dolum səviyyəsinin hesablanacağı parametrin adını daxil edin',
  'Enter the address of your actual residence': 'Zəhmət olmasa, faktiki yaşayış ünvanınızı göstərin',
  'Enrollment form': 'Qeydiyyat forması',
  'Enter Push notification text': 'Push bildiriş mətninizi daxil edin',
  'Enter verification code': 'Təsdiq kodunu daxil edin',
  'Enter promo code': 'Promo kodunu daxil edin',
  'Enter a short description': 'Qısa təsvir daxil edin',
  'Enter a detailed description': 'Ətraflı təsvir daxil edin',
  'Enter the title of the question': 'Sualın başlığını daxil edin',
  'Enter a heading': 'Başlıq daxil edin',
  'Enter age': 'Yaşınızı daxil edin',
  'Enter the cashback percentage value': 'Keşbek faiz dəyərini daxil edin',
  'Enter the key': 'Açarı daxil edin',
  'Enter the minimum duration': 'Minimum müddəti daxil edin',
  'Enter sort priority': 'Çeşidləmə prioritetini daxil edin',
  'Enter parameter name': 'Parametrin adını daxil edin',
  'Enter parameter value': 'Parametrin dəyərini daxil edin',
  'Enter the translation of the client activity level name':
    'Zəhmət olmasa, seçilmiş hədəf dilində müştəri fəaliyyət səviyyəsinin adını daxil edin.',
  'Enter the internal name of the branch in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
    'Filialınızın daxili adını istənilən formatda daxil edin. Daxili ad yalnız inzibati məqsədlər üçün istifadə olunur və müştərilər üçün mobil proqramda göstərilmir.',
  'Enter the internal name of the Legal Entity in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
    'Hüquqi şəxsin daxili adını istənilən formatda daxil edin. Daxili ad yalnız inzibati məqsədlər üçün istifadə olunur və müştərilər üçün mobil proqramda göstərilmir.',
  'Enter the value of the parameter, upon reaching which the charge level will be 0%': 'Parametrin dəyərini daxil edin, bu dəyərə çatdıqda AKB dolum səviyyəsi 0% olacaq.',
  'Enter the value of the parameter, upon reaching which the charge level will be 100%': 'Parametrin dəyərini daxil edin, bu dəyərə çatdıqda AKB dolum səviyyəsi 100% olacaq.',
  'Enter the document name that will be available to the client in the mobile app.': 'Mobil tətbiqdə müştəri üçün əlçatan olacaq sənədin adını daxil edin.',
  'Enter a name for the geopoint. We recommend adding, for example, an address to the name, so you can quickly find the geopoint in the list if needed.': 'Geopoint üçün ad daxil edin. Məsələn, ünvan əlavə etməyi tövsiyə edirik ki, lazım olduqda geopoint-i siyahıda tez tapa biləsiniz.',
  'Passport number': 'Pasport nömrəsi',
  'Passport term': 'Pasportun müddəti',
  'Passport series and number': 'Pasport seriyası və nömrəsi',
  'Series and number': 'Seriyası və nömrəsi',
  'Passport photo': 'Pasport şəkli',
  'Passport photo (New)': 'Pasport Şəkil (Yeni)',
  'Passport selfies': 'Pasportla Selfi',
  'Passport selfies (New)': 'Pasportla Selfi (Yeni)',
  'Driver license number': 'Sürücülük vəsiqəsin nömrəsi',
  'Driver\'s license number': 'Sürücülük vəsiqəsinin nömrəsi',
  'Driver\'s license category': 'Sürücülük vəsiqəsinin kateqoriyası',
  'Driver license term': 'Sürücülük vəsiqəsin müddəti',
  Passport: 'Pasport',
  'Selfie with passport': 'Pasportla selfi',
  'Driver\'s license': 'Sürücülük vəsiqəsi',
  'Driver license front': 'Sürücülük vəsiqəsi, ön tərəf',
  'Driver license back': 'Sürücülük vəsiqəsi, arxa tərəfi',
  'Validity period of driver\'s license': 'Sürücülük vəsiqəsinin etibarlılıq müddəti',
  'Driver\'s licence. Front side': 'Sürücülük vəsiqəsi. Ön tərəf',
  'Driver\'s licence. Front side (New)': 'Sürücülük vəsiqəsi. Ön tərəf (Yeni)',
  'Driver\'s licence. Reverse side': 'Sürücülük vəsiqəsi. Arxa tərəf',
  'Driver\'s licence. Reverse side (New)': 'Sürücülük vəsiqəsi. Arxa tərəf (Yeni)',
  'Driver\'s license categories': 'Sürücülük vəsiqəsi kateqoriyaları',
  Selfie: 'Selfi',
  'E-mail': 'E-mail',
  'Term of use': 'İstifadəçi Sazişi',
  'Privacy policy': 'Məlumatların emalına razılıq',
  'End user verified': 'Müştəri təsdiqləndi',
  'End user rejected': 'İstifadəçi məlumatları rədd edildi',
  'Can\'t verify end user, everything has to be confirmed': 'Müştərini təsdiqləmək mümkün deyil, bütün qeydiyyat addımları təsdiqlənməlidir',
  'Registration data': 'Müştəri qeydiyyatı',
  'Registration history': 'Qeydiyyat tarixçəsi',
  'Registration number must correspond to the specified number in the name of the object (numerical value). Based on the specified registration number, the system generates a QR code required for ordering an object by a client. If for some reason the QR code is not readable, the customer enters the registration number manually to start the rental.':
    'Qeydiyyat nömrəsi əmlakın adında göstərilən nömrə ilə (rəqəm dəyəri) uyğun olmalıdır. Qeydiyyat nömrəsinə əsasən sistem müştərinin əmlakı sifariş etməsi üçün lazım olan QR kodu yaradır. Hər hansı bir səbəbdən QR kodu oxunmazsa, müştəri icarəyə başlamaq üçün qeydiyyat nömrəsini əl ilə daxil etməlidir.',
  'Nothing to reject': 'Heç nə seçilməyib',
  'Nothing found': 'Heç nə tapılmadı',
  'Return to customer': 'Müştərini rədd edin',
  'Verify account': 'Hesabınızı təsdiqləyin',
  'Verified sender name': 'Təsdiqlənmiş göndərən adı',
  'Maximum people allowed': 'İcazə verilən maksimum sayda insan',
  'Confirm apartment': 'Mənzili təsdiqləyin',
  'Arrive time': 'Gəliş vaxtı',
  'Departure time': 'Gediş vaxtı',
  'Depending on the selected type of subscription, different conditions for its provision are available. Starts - type of subscription to provide access to tariffs with zero cost of starts for a set period of validity of the subscription. Minutes - type of subscription to provide free rental minutes for a set period of validity of the subscription. Trips - a type of subscription for providing free trips for a set period of validity.':
    'Seçilmiş abunə növündən asılı olaraq, müxtəlif şərtlər və qaydalar mövcuddur. Starts, abunəliyin müəyyən bir dövrü üçün sıfır başlanğıc xərcləri ilə tariflərə giriş təmin edən abunə növüdür. Dəqiqələr, abunəliyin müəyyən bir dövrü üçün pulsuz icarə dəqiqələri təmin edən abunə növüdür. Trips, abunəliyin müəyyən bir dövrü üçün pulsuz gəzintilər təmin edən abunə növüdür.',
  'Depending on the selected role, the user selection will be displayed':
    'Seçilmiş roldan asılı olaraq, istifadəçinin seçimi göstəriləcək',
  'Depending on the role of the user in the system there are different functionalities. You can find detailed information about the differencies in user roles you can find in our documentation':
    'İstifadəçinin rolundan asılı olaraq, müxtəlif sistem xüsusiyyətləri mövcuddur. Mövcud olan hər bir rolun funksionallığı haqqında ətraflı məlumatı sənədlərimizdə tapa bilərsiniz.',
  'Depending on the selected role of the account owner, a list of users of the corresponding role will be available.':
    'Seçilmiş hesab sahibi rolundan asılı olaraq, müvafiq rolun istifadəçilərinin siyahısı mövcud olacaq.',
  'Depending on the assignment type, different document types are available. The "General" document type is a link to a legal document posted on the project website. The "Rental Agreement" is also a general document type; however, depending on the business model, this document can be used in different places, so it has been designated as a separate type. The "Acceptance Certificate" and "Power of Attorney" document types are generated based on an added document template, automatically populating the client and rented unit details.': 'Təyinat növündən asılı olaraq müxtəlif sənəd növləri mövcuddur. “Ümumi” sənəd növü layihənin saytında yerləşdirilmiş hüquqi sənədə keçiddir. “İcarə müqaviləsi” də ümumi sənəd növünə aiddir, lakin biznes modelindən asılı olaraq müxtəlif yerlərdə istifadə oluna bilər, buna görə ayrıca növ kimi ayrılıb. “Qəbul-təhvil aktı” və “Etibarnamə” sənəd növləri əlavə edilmiş sənəd şablonu əsasında yaradılır və müştəri ilə icarəyə götürülmüş obyektin məlumatları avtomatik doldurulur.',
  'Service hours': 'Təmizləmə vaxtıdır',
  'Date publish': 'Dərc tarixi',
  'Usages log': 'İstifadə qeydi',
  'Activated at': 'Aktivləşdirmə tarixi',
  'Minimum transaction amount': 'Minimum əməliyyat məbləği',
  'Card binding transaction amount': 'Kart əlaqələndirmə əməliyyatının məbləği',
  'Change of terms': 'Şərtlərin dəyişməsi',
  'Minimum transaction amount currency': 'Minimum əməliyyat məbləği valyutası',
  Customer: 'Müştəri',
  Custom: 'Xüsusi',
  'Don\'t show it again': 'Bunu bir daha göstərmə',
  'Reject publish': 'Mənzilin siyahıya alınmasından imtina edin',
  'Flat status': 'Mənzil statusu',
  'Minimum rental period': 'Minimum icarə müddəti',
  'Minimum number of satellites': 'Minimum peyk sayı',
  'Minimum altitude above sea level, m': 'Dəniz səviyyəsindən minimal hündürlük, m',
  'Maximum altitude above sea level, m': 'Dəniz səviyyəsindən maksimal hündürlük, m',
  'altitude-region-hint': 'Hündürlüyə görə etibarsız koordinatların filtrasiyasını tətbiq etmək üçün region üzrə dəniz səviyyəsindən olan hündürlüyün icazə verilən diapazonunu müəyyən etmək lazımdır. Müvafiq məlumatı əldə etmək üçün ərazinin topoqrafik xəritəsindən istifadə edin. Filtrasiya yalnız onlayn mesajlara tətbiq olunur ki, kənar göstəricilərin qarşısı alınsın və obyekt xəritədə son etibarlı koordinatlar üzrə sabitlənsin. Mesaj tarixçəsində avadanlıq tərəfindən göndərilən faktiki koordinatlar saxlanılır. Nəzərinizə çatdırırıq ki, filtrasiyanın tətbiqi üçün həm minimal, həm də maksimal hündürlük dəyərləri doldurulmalı, obyekt isə regiona əl ilə təyin edilməlidir',
  Descriptions: 'Təsvirlər',
  Discounts: 'Endirimlər',
  'Increased tariff': 'Artan tarif',
  'Insurance balance': 'Sığorta balansı',
  'Insurance report': 'Sığorta hesabatı',
  'Insurance cancellation': 'Sığortanın ləğvi',
  'end-user-order-insurance-text': 'Sığorta ödənişinizi ləğv etdikdə, avtomatik olaraq geri ödəniş alacaqsınız. Sığorta ödənişini bank kartı ilə etmisinizsə, vəsait kartınıza qaytarılacaq. Sığorta ödənişini balansla etmisinizsə, debet məbləği geri qaytarılacaq. Şərtlərə uyğun olaraq, filial komissiyaları da ləğv ediləcək.',
  'Report format': 'Hesabat formatı',
  'Insurer type': 'Sığortaçının növü',
  'Illustration for mobile application': 'Mobil tətbiq üçün illüstrasiya',
  'Transfer to the balance': 'Balansa hesablayın',
  'Percent value': 'Faiz dərəcəsi',
  'Base URL': 'Əsas URL',
  'Insurance policy template (HTML)': 'Sığorta siyasəti şablonu (HTML)',
  'Email for sending insurance reports': 'Sığorta hesabatlarının göndərilməsi üçün e-mail',
  'Custom subject for insurance report messages': 'Sığorta hesabatlarının göndərilməsi üçün xüsusi mesaj mövzusu',
  Subject: 'Mövzu',
  'Sending interval': 'Göndərmə tezliyi',
  Insurer: 'Sığortaçı',
  'Select insurer': 'Sığortaçı seçin',
  'If partner has its own contract with an insurance company, then you should select the previously created partner\'s insurer from the list. Otherwise, this field must be left blank.':
    'Əgər tərəfdaşın sığorta şirkəti ilə öz müqaviləsi varsa, siyahıdan əvvəllər yaradılmış tərəfdaş sığortaçını seçmək lazımdır. ' +
    'Əks halda, bu sahə boş qalmalıdır.',
  'If the income from insurance is distributed between the partner and the owner of the project / platform, then, depending on who accepts the payment for insurance, % of the insurance cost is either credited to the partner\'s balance or written-off. To specify the percentage value, select either "Add to balance" or "Withdraw from balance". If the insurance income is not distributed, select "NO".' :
    'Əgər sığorta gəliri tərəfdaş və layihə/platforma sahibi arasında bölüşdürülürsə, sığorta xərcinin müəyyən faizi ya tərəfdaşın balansına köçürülür, ya da sığorta ödənişini kimin qəbul etməsindən asılı olaraq debet edilir. Faizi müəyyən etmək üçün "Balansa kredit" və ya "Balansdan debet" seçin. Sığorta gəliri paylaşılmırsa, YOX seçin.',
  'If the news is intended to be displayed in all regions of the country, select the Country type. If the news can be displayed only in certain regions of the country, select the Regions type to be able to specify the required regions.' :
    'Xəbərin ölkənin bütün bölgələrində nümayiş etdirilməsi nəzərdə tutulursa, Ölkə növünü seçin. Xəbər yalnız ölkənin müəyyən bölgələrində göstərilməlidirsə, tələb olunan bölgələri göstərmək üçün Regionlar növünü seçin.',
  'If the news is intended to promote tourist routes or subscriptions, you can add buttons to go from the news article directly to the catalog of routes or subscriptions.' :
    'Əgər xəbər turist marşrutlarını və ya abunəliklərini təşviq etmək məqsədi daşıyırsa, xəbərlərdən düymələri müvafiq olaraq birbaşa marşrutlar və ya abunəliklər qovluğuna əlavə edə bilərsiniz.',
  'It is necessary to specify the component type to create a component model. If the appropriate type is not listed you can create a new one on the Component Type Page.':
    'Komponent modelini yaratmaq üçün siz yaratdığınız modelə uyğun komponent tipini təyin etməlisiniz. Müvafiq növ siyahıda yoxdursa, Komponent Tipləri səhifəsində yenisini yaradın.',
  'If a serial number is required for each component in this model, check this box. Components with serial numbers are added on the "Components" page. If components in this model do not have serial numbers, but only quantitative values, leave this field blank. Components without serial numbers are added on the "Components without s/n" page. Please note that this parameter cannot be changed once at least one component for this model has been added.':
    'Əgər modelin hər bir komplekt hissəsi üçün seriya nömrəsinin göstərilməsi tələb olunursa, bu sahədə işarə qoymaq lazımdır. Seriya nömrələri ilə komplekt hissələrin əlavə edilməsi «Komplekt hissələr» səhifəsində həyata keçirilir. Əgər modelin komplekt hissələrinin seriya nömrəsi yoxdursa və yalnız say göstəriciləri varsa, bu sahəni boş buraxın. Seriya nömrəsi olmayan komplekt hissələrin əlavə edilməsi «Seriya nömrəsiz komplekt hissələr» səhifəsində həyata keçirilir. Diqqətinizə çatdırırıq ki, bu parametrin dəyişdirilməsi, modelə ən azı bir komplekt hissə əlavə edildikdən sonra mümkün olmayacaq.',
  'If the component model only matches a specific model(s) of an unit, check this box and specify the unit type and model(s) in the "Assignments" section that appears. If the component model is not limited to specific unit models, leave this field blank. (Accessories, for example)':
    'Komponent modeli yalnız obyektin konkret model(lər)inə uyğun gəlirsə, bu qutuyu işarələyin və görünən "Tapşırıqlar" bölməsində obyektin növünü və model(lər)i qeyd edin. Komponent modeli aksesuarlar kimi xüsusi modellərlə məhdudlaşmırsa, bu sahəni boş buraxın.',
  'If the use of the service requires the client\'s consent to the terms of the document, check this point. If you simply want to add the document to the list of available legal documents in the mobile app, uncheck this box.': 'Əgər xidmətin istifadəsi üçün müştərinin sənədin şərtlərinə razılığı tələb olunursa, bu xanaya işarə qoyun. Əgər sənədi sadəcə mobil tətbiqdə mövcud hüquqi sənədlər siyahısına əlavə etmək istəyirsinizsə, bu xananın işarəsini götürün.',
  'If a geofence has day of week or time restrictions, you can set the geofence\'s operating schedule by specifying the geofence\'s working days and/or working hours. Outside of business hours, the geofence\'s logic will not function, and the geofence will not be visible to clients in the mobile app.': 'Əgər geozona üçün həftə günləri və ya vaxt məhdudiyyətləri varsa, siz geozonanın iş cədvəlini iş günlərini və/və ya iş saatlarını göstərməklə təyin edə bilərsiniz. İş vaxtından kənarda geozonanın məntiqi işləməyəcək və geozona mobil tətbiqdə müştərilərə görünməyəcək.',
  'Percent of insurance amount': 'Sığorta məbləğinin faizi',
  'Percent of insurance amount to add to account': 'Sığorta məbləğinin balansa köçürüldüyü zaman faizi',
  'Percent of insurance amount to withdraw from account': 'Balansdan silindikdə sığorta məbləğinin faizi',
  'Acquirer for insurance payments': 'Sığorta ödənişləri üçün ekvayer',
  'Report log': 'Hesabat jurnalı',
  'Arbitrary report': 'Xüsusi hesabat',
  'Report interval': 'Hesabat intervalı',
  'Download report': 'Hesabatı yükləyin',
  'It will be displayed in the mobile application in the first line of the tariff preview of the tariff list.':
    'Mobil tətbiqdə tarif siyahısındakı tarif önizləməsinin birinci sətrində göstəriləcək. ',
  'It will be displayed in the mobile application on the second line of the tariff preview of the tariff list.':
    'Bu, mobil tətbiqdə tarif siyahısındakı tarif önizləməsinin ikinci sətrində göstəriləcək.',
  'It should be noted if you want the tariff to become available in the mobile application immediately after saving.':
    'Tarifin yadda saxladıqdan dərhal sonra mobil tətbiqdə mövcud olmasını istəyirsinizsə, xahiş edirik nəzərə alın.',
  'It should be noted if this rate is the cheapest default rate': 'Xahiş edirik, bu tarifin ən ucuz standart tarif olub-olmadığını nəzərə alın',
  'It should be noted if you want to add a schedule for the availability of this tariff by time of day, days of the week, etc.':
    'Bu tarifin mövcudluğu üçün günün vaxtına, həftənin gününə və s. görə cədvəl əlavə etmək istəyirsinizsə, xahiş edirik nəzərə alın.',
  'It is necessary to specify the language in which the information for the client is provided.':
    'Məlumatın müştəriyə hansı dildə təqdim edildiyini göstərmək lazımdır.',
  'It\'s on': 'Aktivdir',
  'It\'s off': 'Söndürülüb',
  'Rent type': 'Kirayə növü',
  Reward: 'Mükafat',
  'Unavailable dates': 'Əlçatan olmayan tarixlər',
  Unavailable: 'Əlçatan deyil',
  'Cancellation cost': 'Ləğv haqları',
  'Free cancellation before (in hours)': 'Pulsuz ləğvetmə (saat)',
  'Free minutes': 'Pulsuz dəqiqələr',
  'Time for service (in hours)': 'Servis müddəti (saat)',
  'Price for service': 'Servis qiyməti',
  'Collateral value': 'Girov dəyəri',
  'Cancellation cost (percents from collateral value)': 'Ləğv haqqı (əmanət dəyərinin faizi kimi)',
  'Days of week': 'Həftənin günləri',
  'Value (in percents)': 'Dəyər (faizlə)',
  'Discount from (in days)': 'Endirim başlayir (gün)',
  'Discount from (in hours)': 'Endirim başlayir (saat)',
  'Rent periods': 'Sifariş müddətləri',
  'Rent / Insurance': 'Kirayə / Sığorta',
  'Private key': 'Şəxsi açar',
  'Public Key (iOS)': 'Açıq açar (iOS)',
  'Private Key (iOS)': 'Şəxsi açar (iOS)',
  'Captcha is active': 'Captcha aktivdir',
  'Captcha public key': 'Captcha açıq açar',
  'Captcha secret key': 'Captcha şəxsi açar',
  'Captcha IOS public key': 'Captcha IOS açıq açar',
  'Captcha IOS secret key': 'Captcha IOS şəxsi açar',
  'Cashback percent': 'Keşbek faizi',
  'Cash register registration number': 'Kassa aparatının qeydiyyat nömrəsi',
  'Legal documents': 'Hüquqi sənədlər',
  'Less than 20% (hidden in the app)': '20%-dən az (tətbiqdə gizlidir)',
  'Less than 20%': '20%-dən az',
  'Level of demand': 'Tələb səviyyəsi',
  'Leave a comment in any format. This is an optional field. This field is used for administrative purposes only and is not used in the mobile app for clients.':
    'Zəhmət olmasa sərbəst formada şərh yazın. Bu isteğe bağlı sahədir. Bu sahə yalnız inzibati məqsədlər üçün istifadə olunur və müştərilər üçün mobil proqramda göstərilmir.',
  'Client activity level': 'Müştəri fəaliyyət səviyyəsi',
  Level: 'Səviyyə',
  Leasing: 'İcarə transferi',
  'Leased out': 'Kirayəyə verilib',
  'Country documents': 'Ölkədəki sənədlər',
  'Add country document': 'Ölkədə sənəd əlavə edin',
  'Add a comment to this tariff. The comment is displayed only in the admin panel.':
    'Bu plan üçün şərh əlavə edin. Şərh yalnız admin panelində göstərilir.',
  'Add a step': 'Addım əlavə edin',
  'Add option': 'Seçim əlavə edin',
  Option: 'Seçim',
  'Add a question': 'Sual əlavə edin',
  'Delete country document': 'Bir ölkədə sənədi silin',
  Translates: 'Tərcümələr',
  Link: 'Link',
  'Link to detailed information': 'Ətraflı məlumata keçid',
  'Link to the document': 'Sənədə keçid',
  'Link to the insurance company is terms and conditions page': 'Sığorta şirkətinin şərtlər və qaydalar səhifəsinə keçid',
  'Text when accepting document': 'Sənəd qəbul edildikdə mətn',
  'Edit rent period': 'Sifariş müddətini dəyişdirin',
  'Add rent period': 'Sifariş müddəti əlavə edin',
  'Time from': 'Başlama vaxtı',
  'Time must be 3600 seconds or more': 'Vaxt ən azı 3600 saniyə olmalıdır.',
  'Time must be 1800 seconds or more': 'Vaxt ən azı 1800 saniyə olmalıdır.',
  'Time to': 'Bitmə vaxtı',
  'Change booking': 'Rezervasiyanı dəyişdirin',
  'Make reservation': 'Rezervasiyanı yaradın',
  'make changes to the payment terms in the current billing period upon saving changes.':
    'Dəyişiklikləri yadda saxladıqdan sonra cari ödəniş dövründə ödəniş şərtlərində dəyişiklik edin.',
  'Type of property': 'Əmlak növü',
  'Type of business model': 'Biznes modelinin növü',
  'View outside': 'Pəncərədən görünüş',
  'Previous balance': 'Əvvəlki balans',
  'New balance': 'Yeni balans',
  'New (inactive)': 'Yeni (qeyri-aktiv)',
  'New (active)': 'Yeni (aktiv)',
  'New messages from units': 'Obyektlərdən yeni mesajlar',
  'New services': 'Yeni sifarişlər',
  'New ones first': 'Əvvəlcə yeni',
  'Old ones first': 'Əvvəlcə köhnə',
  'Amount in coins': 'Coin məbləğ',
  'Purchase canceled': 'Alış ləğv edildi',
  'Purchase region': 'Satınalma bölgəsi',
  Purchase: 'Alış',
  'Purchase finished': 'Satınalma tamamlandı',
  'Purchase status': 'Satınalma statusu',
  Pending: 'Emalda',
  'Unknown purchase status': 'Naməlum alış statusu',
  'Cashback Percent': 'Keşbek faizi',
  'Purchase time': 'Satınalma vaxtı',
  'Purchase declined': 'Satınalma rədd edildi',
  'Purpose of operation': 'Əməliyyatın məqsədi',
  'Unit assignment': 'Obyektin məqsədi',
  'Operation declined - insufficient funds': 'Əməliyyat rədd edildi - vəsait çatışmır',
  'Operation declined': 'Əməliyyat rədd edildi',
  'Payment number': 'Ödəniş nömrəsi',
  'Transaction ID': 'Əməliyyat ID-si',
  'Error description': 'Xəta təsviri',
  'Short description 1': 'Qısa təsvir 1',
  'Short description 2': 'Qısa təsvir 2',
  'Account number': 'Hesab nömrəsi',
  'Finished by': 'Kim tərəfindən tamamlanıb',
  Finished_: 'Tamamlandı',
  Server: 'Server',
  ORDER_FINISH_BY_USER: 'İstifadəçi {{user}}',
  'Contact type': 'Əlaqə növü',
  Contact: 'Əlaqə',
  'Contact information': 'Əlaqə məlumatları',
  'Contact person': 'Əlaqə şəxs',
  'Content language': 'Məzmun dili',
  'HelpCrunch organisation': 'HelpCrunch organisation',
  'New HelpCrunch APP ID': 'Yeni HelpCrunch APP ID',
  'New HelpCrunch secret': 'Yeni HelpCrunch secret',
  'HelpCrunch APP ID': 'HelpCrunch APP ID',
  'HelpCrunch secret': 'HelpCrunch secret',
  'QRCode size': 'Qeydiyyat nömrəsinin ölçüsü',
  'QR sharing': 'QR-şerinq',
  'Flash call balance': 'Balans təsdiqləmə zəngləri',
  'Debt by trips': 'Səfərlərə borc',
  'Debt by penalties': 'Ödənilməmiş cərimələr',
  Declined: 'Rədd edildi',
  'Login for payments by binding': 'Ödənişlər üçün link vasitəsilə daxil olun',
  'Password for payments by binding': 'Link vasitəsilə ödənişlər üçün şifə',
  'w.': 'h.',
  'Work shifts': 'İş növbələri',
  'Working days': 'İş günləri',
  Cashback: 'Keşbek',
  'Fiscalization service API login': 'Maliyyələşdirmə xidməti API girişi',
  'Fiscalization service API password': 'maliyyələşdirmə xidməti API şifrəsi',
  'Success probability percent': 'Uğur ehtimalının faizi',
  'Bank card first six digits (leave blank for random)': 'Bank kartınızın ilk 6 rəqəmi (təsadüfi generasiya üçün boş saxlayın)',
  'Bank card last four digits (leave blank for random)': 'Bank kartınızın son 4 rəqəmi (təsadüfi generasiya üçün boş buraxın)',
  'Bank card type (leave blank for random)': 'Bank kartının növü (təsadüfi generasiya üçün boş buraxın)',
  'Bank card expiration time (MM/YY format, leave blank for random)': 'Bank kartının bitmə tarixi (AA/İİ formatında, təsadüfi generasiya üçün boş buraxın)',
  'Transit account acquirer': 'Tranzit hesabının ekvayeri',
  'Transit account': 'Tranzit hesabı',
  'Transfer to partner\'s account' : 'Tərəfdaşın hesabına köçürmə',
  'Default commission percent': 'Standart komissiya faizi',
  'Default map': 'Əsas xəritə',
  'Refund transaction': 'Vəsaitlərin qaytarılması',
  'Are sure you want to refund this transaction': 'Həqiqətən də vəsaiti geri qaytarmaq istəyirsiniz?',
  'Are you sure you want to cancel your subscription purchase and get a refund?':
    'Abunə alışınızı ləğv edib pulunuzu geri almaq istədiyinizə əminsinizmi?',
  'Are you sure you want to export table data?': 'Cədvəl məlumatlarını ixrac etmək istədiyinizə əminsinizmi?',
  'Are you sure you want to end the courier\'s work shift?': 'Kuryer növbənizi bitirmək istədiyinizə əminsinizmi?',
  'Are you sure you want to remove the courier from the group?': 'Kuryeri qrupdan çıxarmaq istədiyinizə əminsinizmi?',
  'Transaction was successfully refunded': 'Geri ödəmə uğurla emal edildi.',
  'Error of transaction refund': 'Geri ödəmə alınmadı',
  'Unknown bank card type': 'Naməlum bank kartı növü',
  Acquiring: 'Ekvayinq',
  'Acquiring for balance replenishment': 'Balansın doldurulmas ekvayrinqi',
  'Acquiring payment acceptance': 'Ödəniş qəbulunun əldə edilməsi',
  'This field is for reference purposes only. It is recommended to include specific characteristics and features of the hardware model as a description.': 'Bu sahə yalnız arayış xarakteri daşıyır. Təsvir kimi avadanlıq modelinin spesifik xüsusiyyətlərini və özəlliklərini göstərmək tövsiyə olunur.',
  'This field is used only when migrating from one acquirer to another.': 'Bu sahə yalnız bir alıcıdan digərinə keçərkən istifadə olunur.',
  'Next acquirer for insurance payments': 'Sığorta ödənişləri üçün növbəti əldə edən',
  'Insurance payment type': 'Sığorta ödənişinin növü',
  'Next acquirer': 'Növbəti ekvayer',
  'Subscription fee merchant': 'Abunə haqqı satıcısı',
  'Replenish balance': 'Balansınızı artırın',
  'Top-up balance': 'Balansınızı artırın',
  'Top-up amount': 'Doldurma məbləği',
  'Amount to be withdrawn from card': 'Kartdan pul çıxılacaq.',
  Proceed: 'Davam et',
  'Payment settings': 'Ödəniş parametrləri',
  'Amount in your currency': 'İstifadəçinizin valyutasındakı məbləğ',
  'Amount in currency of payment system': 'Ödəniş sisteminin valyutasında məbləğ',
  'Replenish your balance with': 'Balansınızı istifadə edərək artırın',
  Continue: 'Davam et',
  'Payment amount must be greater': 'Ödəniş məbləği daha çox olmalıdır',
  'Maximum allowable amount has been exceeded': 'Maksimum məbləğ aşılıb',
  'Replenish balance balance failed': 'Balansı doldurmaq alınmadı',
  'Replenish balance was canceled': 'Balansın artırılması ləğv edildi',
  'Replenish balance was declined': 'Balansın artırılması rədd edildi',
  'Replenish balance successfully completed': 'Balans uğurla dolduruldu.',
  'Account balance successfully replenished': 'Balans uğurla dolduruldu.',
  REPLENISH_USER_BALANCE_ERROR_MESSAGE:
    '{{paymentSystem}} ödəniş sistemi vasitəsilə balansınızı artırmaq xidməti mövcud deyil. Zəhmət olmasa, texniki dəstək xidməti ilə əlaqə saxlayın.',
  Icon: 'İkon',
  'Icon Library': 'İkon Kitabxanası',
  'Image height is too large': 'Şəkil hündürlüyü çox böyükdür',
  'Image width is too large': 'Şəkil eni çox böyükdür',
  'Image size is too large': 'Şəkil ölçüsü çox böyükdür (Maksimum ölçü 15 kilobayt)',
  'Telegram Chat ID': 'Telegram chat identifikatoru',
  'Telegram bot api key': 'Telegram bot API açarı',
  'Telegram account': 'Telegram hesabı',
  'Telegram Group': 'Telegram qrupu',
  'Send message to telegram': 'Telegramda mesaj göndərin',
  'Max. count of bookings (0 - no limits)': 'Maksimum rezervasiya sayı (0 - limitsiz)',
  'Image format must be SVG or PNG': 'Şəkil formatı SVG və ya PNG olmalıdır.',
  'Image format must be SVG': 'Şəkil formatı SVG olmalıdır',
  Detailing: 'Təfərrüatlı',
  'Averages-statistic': 'Göstərilən dövrdə aktiv obyektlərin vəziyyətinin orta müddəti',
  'Object-statistic-description': 'Göstərilən müddət ərzində Mövcud statusuna köçürülmüş obyektlər',
  'Object models': 'Obyekt modelləri',
  'Balance-statistic': 'Balans',
  'Refunds(balance)': 'Geri ödəmələr (balans)',
  Refunded: 'Qaytarıldı',
  'Refund amount': 'Geri qaytarılma məbləği',
  'Related operations': 'Əlaqəli əməliyyatlar',
  'Cancellation of debt': 'Borcların ləğvi',
  'coming soon': 'tezliklə',
  'Assigned to regions': 'Bölgələrə təyin edilib',
  'All regions': 'Bütün bölgələr',
  'All users': 'Bütün istifadəçilər',
  'All user objects': 'Bütün istifadəçi obyektləri',
  'All couriers': 'Bütün kuryerlər',
  'My couriers': 'Kuryerlərim',
  'Advanced holding settings': 'Qabaqcıl Saxlama Parametrləri',
  'Holding confirmation': 'Saxlamanın təsdiqlənməsi',
  'Mandatory card binding': 'Məcburi kart bağlantısı',
  'Card binding': 'Kart əlaqələndirilməsi',
  'For new clients': 'Yeni müştərilər üçün',
  'Tariffs with this option will be available to clients without finished orders in place of regular tariffs': 'Bu qiymətlər əsas qiymətlər əvəzinə yeni müştərilərə (uğurlu sifarişləri olmayanlara) təklif olunacaq.',
  day_: 'gün',
  days: 'gün',
  year: 'il',
  years: 'il',
  years_: 'il',
  'osm-hint': 'Dünyanın pulsuz xəritəsi. Sistem tərəfindən standart olaraq istifadə olunur. API açarı olmadan qoşulur',
  'gomap-hint': 'Azərbaycanın pulsuz milli xəritəsi. API açarı olmadan qoşulur',
  'google-maps-hint': 'Google Platform-un rəsmi xəritələri. Xidmətin saytından əldə edilən API açarı tələb olunur: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-maps-api-key-hint': 'Xidmətin saytından əldə etdiyiniz API açarını daxil edin: <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-roadmap-hint': 'Klassik küçə və yol sxemini göstərən xəritə rejimi',
  'google-hybrid-hint': 'Peyk görüntülərini yolların, küçələrin və obyekt adlarının sxemi ilə birləşdirən xəritə rejimi',
  'default-map-hint': 'Sistem üzrə sizə və digər istifadəçilərinizə standart olaraq göstəriləcək xəritəni seçin',
  'Are you sure you want to manually confirm the client\'s email?': 'Müştərinin e-poçtunu əl ilə təsdiqləmək istədiyinizdən əminsiniz?',
  findOrdersPlaceholder: 'Axtarış bölgəsini qeyd etmək üçün xəritə alətlərindən istifadə edin. Vaxt aralığını seçin və "Axtar" düyməsini basın',
  'Number of selected objects': 'Seçilmiş obyektlərin sayı',
  'Command source': 'Komanda mənbəyi',
  'Select command source': 'Komanda mənbəyini seçin',
  'Command template': 'Komanda şablonu',
  'Payment by card': 'Kartla ödəniş',
  'Payment by balance': 'Balansla ödəniş',
  Compensation: 'Kompensasiya',
  'Balance adjustment': 'Balansın tənzimlənməsi',
  'Receipts to the client balance': 'Müştəri balansına daxilolmalar',
  'Bonus parking': 'Bonus parkinq',
  'Paid by card': 'Kartla ödənilib',
  'Paid by balance': 'Balansla ödənilib',
  'Paid via payment services': 'Ödəniş xidmətləri',
  'Custom period': 'Fərdi dövr',
  'Only my units': 'Yalnız mənim obyektlərim'
};
